// before 20-5-2025


// import React, { useState, useEffect, useRef, useMemo } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   IconButton,
//   useTheme,
//   useMediaQuery,
//   TextField,
//   Grid,
//   InputAdornment,
//   Chip,
//   Checkbox,
//   Slide,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Paper,
//   ClickAwayListener,
//   Alert,
//   Collapse,
//   GlobalStyles,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import SearchIcon from '@mui/icons-material/Search';
// import ClearIcon from '@mui/icons-material/Clear';
// import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
// import CheckBoxIcon from '@mui/icons-material/CheckBox';
// import HistoryIcon from '@mui/icons-material/History';
// import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
// import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// import UpdateIcon from '@mui/icons-material/Update';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import GroupsIcon from '@mui/icons-material/Groups';
// import InfoIcon from '@mui/icons-material/Info';
// import { useDispatch, useSelector } from 'react-redux';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import moment from 'moment';

// // استيراد الـ actions
// import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
// import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
// import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
// import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';

// // Transition للـ offcanvas من اليمين
// const SlideTransition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="left" ref={ref} {...props} />;
// });

// // أيقونات الـ Checkbox
// const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
// const checkedIcon = <CheckBoxIcon fontSize="small" />;

// // Global styles لضبط z-index للتقويم
// const globalStyles = (
//   <GlobalStyles
//     styles={{
//       '.MuiPickersPopper-root': {
//         zIndex: '999999 !important',
//       },
//       '.MuiPaper-root.MuiPickersPopper-paper': {
//         zIndex: '999999 !important',
//         maxHeight: '400px !important',
//         overflow: 'auto !important',
//       },
//       '.MuiPickersCalendar-root': {
//         maxHeight: '300px !important',
//         minHeight: '280px !important',
//       },
//       '.MuiDayCalendar-monthContainer': {
//         maxHeight: '300px !important',
//         overflow: 'hidden !important',
//       },
//     }}
//   />
// );

// // مكون DatePicker مخصص مع إصلاح مشكلة الظهور
// const CustomDatePicker = ({ label, value, onChange, color = 'primary', ...props }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;

//   const getColor = () => {
//     if (color === 'warning') return mode === 'dark' ? '#ff9800' : '#1976d2';
//     return mode === 'dark' ? '#2196f3' : '#1976d2';
//   };

//   return (
//     <DatePicker
//       label={label}
//       value={value}
//       onChange={onChange}
//       views={['year', 'month', 'day']}
//       slotProps={{
//         textField: {
//           fullWidth: true,
//           size: 'small',
//           sx: {
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//             '& .MuiInputLabel-root': {
//               color: getColor(),
//               '&.Mui-focused': {
//                 color: getColor(),
//               },
//             },
//             '& .MuiOutlinedInput-root': {
//               '&:hover .MuiOutlinedInput-notchedOutline': {
//                 borderColor: getColor(),
//               },
//               '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                 borderColor: getColor(),
//               },
//             },
//           },
//         },
//         popper: {
//           sx: {
//             zIndex: 999999,
//             '& .MuiPaper-root': {
//               zIndex: '999999 !important',
//               maxHeight: '400px',
//               overflow: 'auto',
//             },
//             '& .MuiPickersCalendar-root': {
//               maxHeight: '300px',
//               minHeight: '280px',
//             },
//             '& .MuiDayCalendar-monthContainer': {
//               maxHeight: '300px',
//               minHeight: '280px',
//             },
//             '& .MuiDayCalendar-weekContainer': {
//               height: '36px',
//             },
//             '& .MuiPickersDay-root': {
//               height: '32px',
//               width: '32px',
//               fontSize: '0.875rem',
//             },
//           },
//           disablePortal: false,
//           placement: 'bottom-start',
//           modifiers: [
//             {
//               name: 'preventOverflow',
//               enabled: true,
//               options: {
//                 boundary: 'viewport',
//                 altBoundary: true,
//                 padding: 8,
//               },
//             },
//             {
//               name: 'flip',
//               enabled: true,
//               options: {
//                 fallbackPlacements: ['bottom-start', 'bottom-end', 'top-start', 'top-end'],
//               },
//             },
//           ],
//         },
//         desktopPaper: {
//           sx: {
//             zIndex: 999999,
//             maxHeight: '400px',
//             overflow: 'auto',
//           },
//         },
//       }}
//       {...props}
//     />
//   );
// };

// const QuickFilterModal = ({ open, onClose, onApplyFilters }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const dispatch = useDispatch();

//   // States للفلاتر
//   const [filters, setFilters] = useState({
//     budget: '',
//     stage: [],
//     oldstage: [],
//     sales: [],
//     chanel: [],
//     campaign: [],
//     project: [],
//     developer: [],
//     addby: [],
//     assignedFrom: [],
//     assignedTo: [],
//     teamLeaders: [], // 🔥 حقل جديد للـ Team Leaders
//     createdAt: {
//       from: null,
//       to: null,
//     },
//     stagedateupdated: {
//       from: null,
//       to: null,
//     },
//   });

//   // State للتحكم في الـ auto select
//   const [showAutoSelectInfo, setShowAutoSelectInfo] = useState(true);

//   // State للقائمة المفتوحة حاليًا
//   const [openMenu, setOpenMenu] = useState(null);
//   const [searchValue, setSearchValue] = useState('');
//   const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0, width: 0 });

//   // Refs للحقول
//   const fieldRefs = {
//     stage: useRef(null),
//     oldstage: useRef(null),
//     sales: useRef(null),
//     chanel: useRef(null),
//     campaign: useRef(null),
//     project: useRef(null),
//     developer: useRef(null),
//     addby: useRef(null),
//     assignedFrom: useRef(null),
//     assignedTo: useRef(null),
//     teamLeaders: useRef(null),
//   };

//   // جلب البيانات من Redux
//   const ressales = useSelector((state) => state.AllSales.sales);
//   const reschannel = useSelector((state) => state.AllChannalRoot.channal);
//   const resproject = useSelector((state) => state.AllProjects.Projects);
//   const resstages = useSelector((state) => state.Allstages.stage);
//   const resdevelopers = useSelector((state) => state.AllDevelopers.Developers);
//   const rescampaigns = useSelector((state) => state.AllCampaign.campaign);
//   const resusersAuth = useSelector((state) => state.AuthRoot.Signup);

//   // 🔥 استخراج جميع الـ Team Leaders الفريدة من بيانات الـ sales
//   const teamLeadersArray = useMemo(() => {
//     if (!ressales?.data || !Array.isArray(ressales.data)) return [];

//     const teamLeadersMap = new Map();

//     ressales.data.forEach((sale) => {
//       if (sale?.teamleader && sale.teamleader._id) {
//         // فقط الـ Team Leaders الحقيقيين (الذين لديهم role === 'Team Leader')
//         if (sale.teamleader.role === 'Team Leader') {
//           teamLeadersMap.set(sale.teamleader._id, {
//             _id: sale.teamleader._id,
//             name: sale.teamleader.name,
//             email: sale.teamleader.email,
//             role: sale.teamleader.role,
//             profileImg: sale.teamleader.profileImg,
//           });
//         }
//       }
//     });

//     return Array.from(teamLeadersMap.values())
//       .filter(
//         (leader) =>
//           !['Default', 'Default M', 'Default T', 'Default S', 'Developer', 'Dev'].includes(
//             leader?.name,
//           ),
//       )
//       .sort((a, b) => a?.name?.localeCompare(b?.name));
//   }, [ressales]);

//   // 🔥 دالة للحصول على الـ sales التابعين لـ Team Leader معين
//   const getSalesByTeamLeader = (teamLeaderId) => {
//     if (!teamLeaderId || !ressales?.data || !Array.isArray(ressales.data)) return [];

//     return ressales.data
//       .filter((sale) => {
//         return sale?.teamleader?._id === teamLeaderId;
//       })
//       .filter(
//         (sale) =>
//           !['Default', 'Default M', 'Default T', 'Default S', 'Developer', 'Dev'].includes(
//             sale?.name,
//           ),
//       );
//   };

//   // معالجة البيانات بشكل صحيح
//   const salesarray = useMemo(() => {
//     return (Array.isArray(ressales?.data) ? ressales.data : [])
//       .filter(
//         (sale) =>
//           !['Default', 'Default M', 'Default T', 'Default S', 'Developer', 'Dev'].includes(
//             sale?.name,
//           ),
//       )
//       .sort((a, b) => {
//         if (a?.name === 'No Sales') return -1;
//         if (b?.name === 'No Sales') return 1;
//         return a?.name?.localeCompare(b?.name);
//       });
//   }, [ressales]);

//   const channelarray = Array.isArray(reschannel?.data) ? reschannel.data : [];
//   const projectarray = Array.isArray(resproject?.data) ? resproject.data : [];
//   const stagesarray = Array.isArray(resstages?.data) ? resstages.data : [];
//   const developersarray = Array.isArray(resdevelopers?.data) ? resdevelopers.data : [];
//   const campaignsarray = Array.isArray(rescampaigns?.data) ? rescampaigns.data : [];

//   const usersarray = (Array.isArray(resusersAuth?.data) ? resusersAuth.data : []).filter(
//     (user) =>
//       !['Default', 'Default M', 'Default T', 'Default S', 'Developer', 'Dev'].includes(user?.name),
//   );

//   const getallfiltersarray = async () => {
//     await dispatch(Get_All_Sales_Action());
//     await dispatch(GetAllchannalData());
//     await dispatch(GetallProjectsdata());
//     await dispatch(GetAll_stage_Data());
//     await dispatch(GetDevelopersData());
//     await dispatch(GetAllCampainData());
//   };

//   useEffect(() => {
//     if (open) {
//       getallfiltersarray();
//     }
//   }, [open, dispatch]);

//   // 🔥 useEffect لتفعيل الـ auto select عند اختيار Team Leader
//   useEffect(() => {
//     if (filters.teamLeaders.length > 0) {
//       // جمع جميع الـ sales التابعين لجميع الـ Team Leaders المختارين
//       const allTeamLeaderIds = filters.teamLeaders.map((tl) => getItemId(tl));
//       let allSalesUnderTeamLeaders = [];

//       allTeamLeaderIds.forEach((teamLeaderId) => {
//         const salesUnderTeamLeader = getSalesByTeamLeader(teamLeaderId);
//         allSalesUnderTeamLeaders = [...allSalesUnderTeamLeaders, ...salesUnderTeamLeader];
//       });

//       // إزالة التكرارات
//       const uniqueSales = Array.from(new Set(allSalesUnderTeamLeaders.map((s) => getItemId(s))))
//         .map((id) => allSalesUnderTeamLeaders.find((s) => getItemId(s) === id))
//         .filter((s) => s);

//       // تحديث الـ sales filter
//       setFilters((prev) => ({
//         ...prev,
//         sales: uniqueSales,
//       }));
//     } else if (filters.teamLeaders.length === 0 && filters.sales.length > 0) {
//       // إذا لم يعد هناك Team Leaders مختارين، لا نغير الـ sales
//       // (يمكنك تعديل هذا السلوك إذا أردت مسح الـ sales أيضاً)
//     }
//   }, [filters.teamLeaders]);

//   // 🔥 دالة للتعامل مع اختيار/إزالة Team Leader
//   const handleTeamLeaderToggle = (teamLeader) => {
//     const isSelected = filters.teamLeaders.some((tl) => getItemId(tl) === getItemId(teamLeader));

//     if (isSelected) {
//       // إزالة Team Leader
//       const newTeamLeaders = filters.teamLeaders.filter(
//         (tl) => getItemId(tl) !== getItemId(teamLeader),
//       );

//       setFilters((prev) => ({
//         ...prev,
//         teamLeaders: newTeamLeaders,
//       }));
//     } else {
//       // إضافة Team Leader
//       const newTeamLeaders = [...filters.teamLeaders, teamLeader];

//       setFilters((prev) => ({
//         ...prev,
//         teamLeaders: newTeamLeaders,
//       }));
//     }
//   };

//   // دوال التعامل مع الفلاتر
//   const handleFilterChange = (filterType, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       [filterType]: value,
//     }));
//   };

//   const handleBudgetChange = (value) => {
//     setFilters((prev) => ({
//       ...prev,
//       budget: value,
//     }));
//   };

//   const handleDateChange = (dateType, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       createdAt: {
//         ...prev.createdAt,
//         [dateType]: value ? moment(value).format('YYYY-MM-DD') : null,
//       },
//     }));
//   };

//   const handleStageDateChange = (dateType, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       stagedateupdated: {
//         ...prev.stagedateupdated,
//         [dateType]: value ? moment(value).format('YYYY-MM-DD') : null,
//       },
//     }));
//   };

//   const handleItemToggle = (filterType, item) => {
//     setFilters((prev) => {
//       const current = prev[filterType];
//       const isSelected = current.some((i) => getItemId(i) === getItemId(item));

//       if (isSelected) {
//         return {
//           ...prev,
//           [filterType]: current.filter((i) => getItemId(i) !== getItemId(item)),
//         };
//       } else {
//         return {
//           ...prev,
//           [filterType]: [...current, item],
//         };
//       }
//     });
//   };

//   const handleSelectAll = (filterType, options) => {
//     setFilters((prev) => {
//       const current = prev[filterType];
//       if (current.length === options.length) {
//         return {
//           ...prev,
//           [filterType]: [],
//         };
//       } else {
//         return {
//           ...prev,
//           [filterType]: [...options],
//         };
//       }
//     });
//   };

//   const handleOpenMenu = (menuType) => {
//     const fieldRef = fieldRefs[menuType];
//     if (fieldRef.current) {
//       const rect = fieldRef.current.getBoundingClientRect();
//       setAnchorPosition({
//         top: rect.bottom + window.scrollY,
//         left: rect.left + window.scrollX,
//         width: rect.width,
//       });
//       setOpenMenu(menuType);
//       setSearchValue('');
//     }
//   };

//   const handleCloseMenu = () => {
//     setOpenMenu(null);
//     setSearchValue('');
//   };

//   const getDisplayName = (item) => {
//     if (typeof item === 'string') return item;
//     return item?.name || item?.CampainName || item?.title || 'Unknown';
//   };

//   const getItemId = (item) => {
//     return item?._id || item?.id || item?.name || item?.CampainName || JSON.stringify(item);
//   };

//   const handleApplyFilters = () => {
//     const cleanedFilters = {
//       ...filters,
//       stage: filters.stage.filter((item) => item),
//       oldstage: filters.oldstage.filter((item) => item),
//       sales: filters.sales.filter((item) => item),
//       chanel: filters.chanel.filter((item) => item),
//       campaign: filters.campaign.filter((item) => item),
//       project: filters.project.filter((item) => item),
//       developer: filters.developer.filter((item) => item),
//       addby: filters.addby.filter((item) => item),
//       assignedFrom: filters.assignedFrom.filter((item) => item),
//       assignedTo: filters.assignedTo.filter((item) => item),
//       teamLeaders: filters.teamLeaders.filter((item) => item),
//       budget: filters.budget || '',
//       createdAt: {
//         from: filters.createdAt.from,
//         to: filters.createdAt.to,
//       },
//       stagedateupdated: {
//         from: filters.stagedateupdated.from,
//         to: filters.stagedateupdated.to,
//       },
//     };

//     console.log('🔍 Applying filters:', cleanedFilters);

//     const queryParams = new URLSearchParams();

//     const multiValueFields = [
//       'stage',
//       'sales',
//       'chanel',
//       'campaign',
//       'project',
//       'developer',
//       'addby',
//     ];

//     multiValueFields.forEach((field) => {
//       if (cleanedFilters[field] && cleanedFilters[field].length > 0) {
//         cleanedFilters[field].forEach((item) => {
//           const itemId = getItemId(item);
//           if (itemId) {
//             queryParams.append(field, itemId);
//           }
//         });
//       }
//     });

//     if (cleanedFilters.teamLeaders && cleanedFilters.teamLeaders.length > 0) {
//       cleanedFilters.teamLeaders.forEach((item) => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('teamLeaders', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.oldstage && cleanedFilters.oldstage.length > 0) {
//       cleanedFilters.oldstage.forEach((item) => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('oldstage', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.assignedFrom && cleanedFilters.assignedFrom.length > 0) {
//       cleanedFilters.assignedFrom.forEach((item) => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('assignedFrom', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.assignedTo && cleanedFilters.assignedTo.length > 0) {
//       cleanedFilters.assignedTo.forEach((item) => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('assignedTo', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.budget) {
//       queryParams.append('budget', cleanedFilters.budget);
//     }

//     if (cleanedFilters.createdAt.from) {
//       queryParams.append('createdFrom', cleanedFilters.createdAt.from);
//     }
//     if (cleanedFilters.createdAt.to) {
//       queryParams.append('createdTo', cleanedFilters.createdAt.to);
//     }

//     if (cleanedFilters.stagedateupdated.from) {
//       queryParams.append('stageDateFrom', cleanedFilters.stagedateupdated.from);
//     }
//     if (cleanedFilters.stagedateupdated.to) {
//       queryParams.append('stageDateTo', cleanedFilters.stagedateupdated.to);
//     }

//     const queryString = queryParams.toString();
//     console.log('🔍 Final Query String:', queryString);

//     onApplyFilters(cleanedFilters, queryString);
//     onClose();
//   };

//   const handleClearFilters = () => {
//     setFilters({
//       budget: '',
//       stage: [],
//       oldstage: [],
//       sales: [],
//       chanel: [],
//       campaign: [],
//       project: [],
//       developer: [],
//       addby: [],
//       assignedFrom: [],
//       assignedTo: [],
//       teamLeaders: [],
//       createdAt: {
//         from: null,
//         to: null,
//       },
//       stagedateupdated: {
//         from: null,
//         to: null,
//       },
//     });
//     handleCloseMenu();
//   };

//   const MenuComponent = () => {
//     if (!openMenu) return null;

//     let options = [];
//     switch (openMenu) {
//       case 'stage':
//         options = stagesarray;
//         break;
//       case 'oldstage':
//         options = stagesarray;
//         break;
//       case 'sales':
//         options = salesarray;
//         break;
//       case 'chanel':
//         options = channelarray;
//         break;
//       case 'campaign':
//         options = campaignsarray;
//         break;
//       case 'project':
//         options = projectarray;
//         break;
//       case 'developer':
//         options = developersarray;
//         break;
//       case 'addby':
//         options = usersarray;
//         break;
//       case 'assignedFrom':
//         options = usersarray;
//         break;
//       case 'assignedTo':
//         options = salesarray;
//         break;
//       case 'teamLeaders':
//         options = teamLeadersArray;
//         break;
//       default:
//         options = [];
//     }

//     const selectedItems = filters[openMenu] || [];

//     const filteredOptions = options.filter(
//       (option) =>
//         getDisplayName(option).toLowerCase().includes(searchValue.toLowerCase()) ||
//         selectedItems.some((selected) => getItemId(selected) === getItemId(option)),
//     );

//     const handleItemClick = (item) => {
//       if (openMenu === 'teamLeaders') {
//         handleTeamLeaderToggle(item);
//       } else {
//         handleItemToggle(openMenu, item);
//       }
//     };

//     return (
//       <ClickAwayListener onClickAway={handleCloseMenu}>
//         <Paper
//           sx={{
//             position: 'fixed',
//             top: anchorPosition.top,
//             left: anchorPosition.left,
//             width: anchorPosition.width || 300,
//             maxHeight: 400,
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
//             border: mode === 'dark' ? '1px solid #444' : '1px solid #ddd',
//             boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
//             borderRadius: '8px',
//             overflow: 'hidden',
//             zIndex: 999998,
//           }}
//         >
//           {openMenu === 'teamLeaders' && (
//             <Box
//               sx={{
//                 p: 1,
//                 borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}`,
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.05)',
//               }}
//             >
//               <Typography
//                 variant="caption"
//                 sx={{
//                   fontSize: '0.7rem',
//                   color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 0.5,
//                 }}
//               >
//                 <InfoIcon fontSize="inherit" />
//                 “All Sales members under this Team Leader will be selected automatically.”
//               </Typography>
//             </Box>
//           )}

//           <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}` }}>
//             <TextField
//               fullWidth
//               size="small"
//               placeholder={`Search...`}
//               value={searchValue}
//               onChange={(e) => setSearchValue(e.target.value)}
//               autoFocus
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon fontSize="small" />
//                   </InputAdornment>
//                 ),
//                 endAdornment: searchValue && (
//                   <InputAdornment position="end">
//                     <IconButton size="small" onClick={() => setSearchValue('')} edge="end">
//                       <ClearIcon fontSize="small" />
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//                 sx: {
//                   fontSize: '14px',
//                 },
//               }}
//             />
//           </Box>

//           <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}` }}>
//             <Button
//               onClick={() => handleSelectAll(openMenu, options)}
//               size="small"
//               fullWidth
//               sx={{
//                 textTransform: 'none',
//                 fontSize: '0.75rem',
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 justifyContent: 'flex-start',
//                 paddingLeft: 2,
//               }}
//             >
//               {selectedItems.length === options.length ? 'Deselect All' : 'Select All'}
//             </Button>
//           </Box>

//           <List
//             sx={{
//               maxHeight: 300,
//               overflow: 'auto',
//               p: 0,
//             }}
//           >
//             {filteredOptions.length > 0 ? (
//               filteredOptions.map((option, index) => {
//                 const isSelected = selectedItems.some(
//                   (item) => getItemId(item) === getItemId(option),
//                 );

//                 // 🔥 حساب عدد الـ sales تحت Team Leader
//                 let salesCount = 0;
//                 if (openMenu === 'teamLeaders') {
//                   salesCount = getSalesByTeamLeader(getItemId(option)).length;
//                 }

//                 return (
//                   <ListItem
//                     key={getItemId(option) || index}
//                     onClick={() => handleItemClick(option)}
//                     sx={{
//                       py: 1,
//                       px: 2,
//                       cursor: 'pointer',
//                       backgroundColor: isSelected
//                         ? mode === 'dark'
//                           ? 'rgba(25, 118, 210, 0.2)'
//                           : 'rgba(25, 118, 210, 0.1)'
//                         : 'transparent',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                       '&:hover': {
//                         backgroundColor: isSelected
//                           ? mode === 'dark'
//                             ? 'rgba(25, 118, 210, 0.3)'
//                             : 'rgba(25, 118, 210, 0.15)'
//                           : mode === 'dark'
//                             ? 'rgba(255,255,255,0.1)'
//                             : 'rgba(0,0,0,0.04)',
//                       },
//                     }}
//                   >
//                     <ListItemIcon sx={{ minWidth: 40 }}>
//                       <Checkbox
//                         checked={isSelected}
//                         icon={icon}
//                         checkedIcon={checkedIcon}
//                         sx={{
//                           color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                           '&.Mui-checked': {
//                             color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                           },
//                         }}
//                       />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={getDisplayName(option)}
//                       primaryTypographyProps={{
//                         fontSize: '14px',
//                         fontWeight: isSelected ? '500' : '400',
//                       }}
//                       secondary={
//                         openMenu === 'teamLeaders' && salesCount > 0 ? (
//                           <Typography
//                             variant="caption"
//                             color={mode === 'dark' ? '#4caf50' : '#2e7d32'}
//                           >
//                             {salesCount} sales
//                           </Typography>
//                         ) : null
//                       }
//                     />
//                   </ListItem>
//                 );
//               })
//             ) : (
//               <ListItem disabled sx={{ justifyContent: 'center', py: 2 }}>
//                 <Typography variant="body2" color="text.secondary">
//                   No options found
//                 </Typography>
//               </ListItem>
//             )}
//           </List>
//         </Paper>
//       </ClickAwayListener>
//     );
//   };

//   const FilterField = ({
//     title,
//     filterType,
//     icon: customIcon,
//     placeholder = `Select ${title}...`,
//   }) => {
//     const selectedItems = filters[filterType] || [];
//     const isOpen = openMenu === filterType;

//     const handleClick = () => {
//       if (isOpen) {
//         handleCloseMenu();
//       } else {
//         handleOpenMenu(filterType);
//       }
//     };

//     const handleRemoveItem = (item, event) => {
//       event.stopPropagation();
//       if (filterType === 'teamLeaders') {
//         handleTeamLeaderToggle(item);
//       } else {
//         handleItemToggle(filterType, item);
//       }
//     };

//     const getSalesCountUnderSelectedTeamLeaders = () => {
//       if (filterType !== 'teamLeaders') return 0;

//       let totalSales = 0;
//       selectedItems.forEach((teamLeader) => {
//         const salesUnderTeamLeader = getSalesByTeamLeader(getItemId(teamLeader));
//         totalSales += salesUnderTeamLeader.length;
//       });

//       return totalSales;
//     };

//     return (
//       <Box sx={{ mb: 3 }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, alignItems: 'center' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             {customIcon && customIcon}
//             <Typography sx={{ fontWeight: 600, color: mode === 'dark' ? '#fff' : '#000' }}>
//               {title}
//             </Typography>
//           </Box>
//           {filterType === 'teamLeaders' && selectedItems.length > 0 && (
//             <Typography
//               variant="caption"
//               sx={{ color: mode === 'dark' ? '#4caf50' : '#2e7d32', fontWeight: '500' }}
//             >
//               {getSalesCountUnderSelectedTeamLeaders()} sales selected
//             </Typography>
//           )}
//         </Box>

//         <Box
//           ref={fieldRefs[filterType]}
//           onClick={handleClick}
//           sx={{
//             border: '1px solid',
//             borderColor: isOpen
//               ? mode === 'dark'
//                 ? '#90caf9'
//                 : '#1976d2'
//               : mode === 'dark'
//                 ? '#444'
//                 : '#ccc',
//             borderRadius: '4px',
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
//             minHeight: '40px',
//             padding: '8px 12px',
//             cursor: 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             '&:hover': {
//               borderColor: mode === 'dark' ? '#666' : '#999',
//             },
//             position: 'relative',
//             outline: isOpen ? `2px solid ${mode === 'dark' ? '#90caf9' : '#1976d2'}` : 'none',
//             outlineOffset: '-2px',
//           }}
//         >
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, flex: 1 }}>
//             {selectedItems.length > 0 ? (
//               selectedItems.slice(0, 3).map((item, index) => (
//                 <Chip
//                   key={index}
//                   label={getDisplayName(item)}
//                   size="small"
//                   onDelete={(e) => handleRemoveItem(item, e)}
//                   sx={{
//                     height: 24,
//                     fontSize: '0.7rem',
//                     backgroundColor: mode === 'dark' ? '#1976d2' : '#e3f2fd',
//                     color: mode === 'dark' ? '#fff' : '#1976d2',
//                     '& .MuiChip-deleteIcon': {
//                       fontSize: '1rem',
//                       color: 'inherit',
//                       '&:hover': {
//                         color: mode === 'dark' ? '#bbdefb' : '#bbdefb',
//                       },
//                     },
//                   }}
//                 />
//               ))
//             ) : (
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                   fontStyle: 'italic',
//                 }}
//               >
//                 {placeholder}
//               </Typography>
//             )}
//             {selectedItems.length > 3 && (
//               <Chip
//                 label={`+${selectedItems.length - 3} more`}
//                 size="small"
//                 sx={{
//                   height: 24,
//                   fontSize: '0.7rem',
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
//                 }}
//               />
//             )}
//           </Box>
//           <ArrowDropDownIcon
//             sx={{
//               color: isOpen
//                 ? mode === 'dark'
//                   ? '#90caf9'
//                   : '#1976d2'
//                 : mode === 'dark'
//                   ? '#aaa'
//                   : '#666',
//               ml: 1,
//               transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
//               transition: 'transform 0.2s',
//             }}
//           />
//         </Box>

//         {filterType === 'teamLeaders' && selectedItems.length > 0 && (
//           <Collapse in={showAutoSelectInfo}>
//             <Alert
//               severity="info"
//               icon={<InfoIcon fontSize="small" />}
//               sx={{
//                 mt: 1,
//                 py: 0.5,
//                 '& .MuiAlert-message': {
//                   fontSize: '0.75rem',
//                   padding: '4px 0',
//                 },
//               }}
//               onClose={() => setShowAutoSelectInfo(false)}
//             >
//               Choose Done {getSalesCountUnderSelectedTeamLeaders()} sales For {selectedItems.length}{' '}
//               Team Leader{selectedItems.length > 1 ? 's' : ''} تلقائياً
//             </Alert>
//           </Collapse>
//         )}

//         {selectedItems.length > 0 && (
//           <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//             {selectedItems.map((item, index) => (
//               <Chip
//                 key={index}
//                 label={getDisplayName(item)}
//                 size="small"
//                 onDelete={(e) => handleRemoveItem(item, e)}
//                 sx={{
//                   height: 24,
//                   fontSize: '0.7rem',
//                   backgroundColor: mode === 'dark' ? '#1976d2' : '#e3f2fd',
//                   color: mode === 'dark' ? '#fff' : '#1976d2',
//                   '& .MuiChip-deleteIcon': {
//                     fontSize: '1rem',
//                     color: 'inherit',
//                     '&:hover': {
//                       color: mode === 'dark' ? '#bbdefb' : '#bbdefb',
//                     },
//                   },
//                 }}
//               />
//             ))}
//           </Box>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <>
//       {globalStyles}
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="md"
//         fullWidth
//         fullScreen={isSmallScreen}
//         style={{ zIndex: '50000' }}
//         TransitionComponent={SlideTransition}
//         PaperProps={{
//           sx: {
//             borderRadius: 0,
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//             backgroundImage: 'none',
//             margin: 0,
//             height: '100vh',
//             width: isSmallScreen ? '100vw' : '600px',
//             maxWidth: '600px !important',
//             position: 'fixed',
//             right: 0,
//             top: 0,
//             bottom: 0,
//             overflow: 'hidden',
//             boxShadow: '0 0 20px rgba(0,0,0,0.3)',
//           },
//         }}
//         sx={{
//           '& .MuiBackdrop-root': {
//             backgroundColor: 'rgba(0, 0, 0, 0.5)',
//           },
//           '& .MuiDialog-container': {
//             overflow: 'hidden',
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             backgroundColor: mode === 'dark' ? 'primary.dark' : 'primary.main',
//             color: 'white',
//             padding: '16px 24px',
//             position: 'sticky',
//             top: 0,
//             zIndex: 9999,
//             boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//             minHeight: '64px',
//           }}
//         >
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <FilterListIcon />
//             <Typography variant="h6" component="span">
//               Quick Filter
//             </Typography>
//           </Box>
//           <IconButton onClick={onClose} sx={{ color: 'white' }} size="small">
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent
//           sx={{
//             p: 3,
//             overflow: 'auto',
//             width: '100%',
//             margin: 0,
//             height: 'calc(100vh - 128px)',
//           }}
//         >
//           <LocalizationProvider dateAdapter={AdapterMoment}>
//             <Grid container spacing={3} alignItems="flex-start">
//               <Grid item xs={12}>
//                 <Box
//                   sx={{
//                     mb: 3,
//                     minHeight: '95px',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     marginTop: '40px',
//                   }}
//                 >
//                   <Typography
//                     variant="subtitle1"
//                     gutterBottom
//                     sx={{
//                       fontWeight: '600',
//                       fontSize: '0.95rem',
//                       minHeight: '24px',
//                       lineHeight: '1.2',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                     }}
//                   >
//                     Budget
//                   </Typography>
//                   <Box sx={{ flex: 1 }}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       placeholder="Enter budget amount..."
//                       value={filters.budget}
//                       onChange={(e) => handleBudgetChange(e.target.value)}
//                       type="number"
//                       sx={{
//                         width: '100%',
//                         '& .MuiInputBase-root': {
//                           width: '100%',
//                           backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//                         },
//                         '& .MuiOutlinedInput-root': {
//                           '&:hover .MuiOutlinedInput-notchedOutline': {
//                             borderColor: mode === 'dark' ? '#666' : '#1976d2',
//                           },
//                         },
//                       }}
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             <Typography
//                               variant="body2"
//                               color={mode === 'dark' ? '#aaa' : 'text.secondary'}
//                             >
//                               $
//                             </Typography>
//                           </InputAdornment>
//                         ),
//                         endAdornment: filters.budget && (
//                           <InputAdornment position="end">
//                             <IconButton size="small" onClick={() => handleBudgetChange('')}>
//                               <ClearIcon fontSize="small" />
//                             </IconButton>
//                           </InputAdornment>
//                         ),
//                       }}
//                     />
//                   </Box>
//                   <Typography
//                     variant="caption"
//                     color={mode === 'dark' ? '#aaa' : 'text.secondary'}
//                     sx={{ mt: 0.5, display: 'block', minHeight: '20px' }}
//                   >
//                     Enter the budget amount
//                   </Typography>
//                 </Box>

//                 {/* 🔥 Team Leaders Filter - حقل جديد */}
//                 <FilterField
//                   title="Team Leaders"
//                   filterType="teamLeaders"
//                   icon={
//                     <GroupsIcon
//                       fontSize="small"
//                       sx={{ mr: 0.5, color: mode === 'dark' ? '#4caf50' : '#1976d2' }}
//                     />
//                   }
//                   placeholder="Select Team Leaders..."
//                 />

//                 <FilterField title="Stage" filterType="stage" placeholder="Select Stage..." />

//                 <FilterField
//                   title="Old Stage"
//                   filterType="oldstage"
//                   icon={
//                     <HistoryIcon
//                       fontSize="small"
//                       sx={{ mr: 0.5, color: mode === 'dark' ? '#ff9800' : '#1976d2' }}
//                     />
//                   }
//                   placeholder="Select Old Stage..."
//                 />

//                 <FilterField title="Sales" filterType="sales" placeholder="Select Sales..." />

//                 <FilterField title="Channel" filterType="chanel" placeholder="Select Channel..." />

//                 <FilterField
//                   title="Campaign"
//                   filterType="campaign"
//                   placeholder="Select Campaign..."
//                 />

//                 <FilterField title="Project" filterType="project" placeholder="Select Project..." />

//                 <FilterField
//                   title="Developer"
//                   filterType="developer"
//                   placeholder="Select Developer..."
//                 />

//                 <FilterField title="Added By" filterType="addby" placeholder="Select Added By..." />

//                 <FilterField
//                   title="Assigned From"
//                   filterType="assignedFrom"
//                   icon={
//                     <AssignmentIndIcon
//                       fontSize="small"
//                       sx={{ mr: 0.5, color: mode === 'dark' ? '#4fc3f7' : '#1976d2' }}
//                     />
//                   }
//                   placeholder="Select Assigned From..."
//                 />

//                 <FilterField
//                   title="Assigned To"
//                   filterType="assignedTo"
//                   icon={
//                     <AssignmentTurnedInIcon
//                       fontSize="small"
//                       sx={{ mr: 0.5, color: mode === 'dark' ? '#81c784' : '#1976d2' }}
//                     />
//                   }
//                   placeholder="Select Assigned To..."
//                 />

//                 <Box
//                   sx={{
//                     mb: 3,
//                     p: 2,
//                     border: '1px solid',
//                     borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                     borderRadius: 1,
//                     minHeight: '110px',
//                     backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fafafa',
//                   }}
//                 >
//                   <Typography
//                     variant="subtitle1"
//                     gutterBottom
//                     sx={{
//                       fontWeight: '600',
//                       fontSize: '0.95rem',
//                       minHeight: '24px',
//                       lineHeight: '1.2',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                     }}
//                   >
//                     Creation Date Range
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <CustomDatePicker
//                         label="From Date"
//                         value={filters.createdAt.from ? moment(filters.createdAt.from) : null}
//                         onChange={(date) => handleDateChange('from', date)}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <CustomDatePicker
//                         label="To Date"
//                         value={filters.createdAt.to ? moment(filters.createdAt.to) : null}
//                         onChange={(date) => handleDateChange('to', date)}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 <Box
//                   sx={{
//                     mb: 3,
//                     p: 2,
//                     border: '1px solid',
//                     borderColor: mode === 'dark' ? 'rgba(255,152,0,0.3)' : 'rgba(255,152,0,0.2)',
//                     borderRadius: 1,
//                     minHeight: '110px',
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(255,152,0,0.05)' : 'rgba(255,152,0,0.05)',
//                   }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                     <UpdateIcon fontSize="small" color="warning" />
//                     <Typography
//                       variant="subtitle1"
//                       gutterBottom
//                       sx={{
//                         fontWeight: '600',
//                         fontSize: '0.95rem',
//                         minHeight: '24px',
//                         lineHeight: '1.2',
//                         color: mode === 'dark' ? '#ff9800' : '#1976d2',
//                       }}
//                     >
//                       Stage Date Range
//                     </Typography>
//                   </Box>
//                   <Typography
//                     variant="caption"
//                     color={mode === 'dark' ? '#aaa' : 'text.secondary'}
//                     gutterBottom
//                     sx={{ display: 'block', mb: 2 }}
//                   >
//                     Filter by stage update date (Stage Date Updated)
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <CustomDatePicker
//                         label="Stage Date From"
//                         value={
//                           filters.stagedateupdated.from
//                             ? moment(filters.stagedateupdated.from)
//                             : null
//                         }
//                         onChange={(date) => handleStageDateChange('from', date)}
//                         color="warning"
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <CustomDatePicker
//                         label="Stage Date To"
//                         value={
//                           filters.stagedateupdated.to ? moment(filters.stagedateupdated.to) : null
//                         }
//                         onChange={(date) => handleStageDateChange('to', date)}
//                         color="warning"
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
//               </Grid>
//             </Grid>

//             {(filters.budget ||
//               Object.values(filters).some((val) =>
//                 Array.isArray(val)
//                   ? val.length > 0
//                   : typeof val === 'object' && val !== null
//                     ? val.from || val.to
//                     : false,
//               )) && (
//               <Box
//                 sx={{
//                   mt: 3,
//                   p: 2,
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(25,118,210,0.1)' : 'rgba(25,118,210,0.05)',
//                   borderRadius: 2,
//                 }}
//               >
//                 <Typography
//                   variant="subtitle2"
//                   gutterBottom
//                   sx={{ fontWeight: 'bold', color: mode === 'dark' ? '#fff' : '#000' }}
//                 >
//                   Selected Filters:
//                 </Typography>
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                   {filters.budget && (
//                     <Chip
//                       label={`Budget: $${filters.budget}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       onDelete={() => handleBudgetChange('')}
//                       deleteIcon={<ClearIcon />}
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.teamLeaders.length > 0 && (
//                     <Chip
//                       label={`Team Leaders: ${filters.teamLeaders.length}`}
//                       size="small"
//                       color="success"
//                       variant="outlined"
//                       icon={<GroupsIcon />}
//                       sx={{ color: mode === 'dark' ? '#4caf50' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.stage.length > 0 && (
//                     <Chip
//                       label={`Stage: ${filters.stage.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.oldstage.length > 0 && (
//                     <Chip
//                       label={`Old Stage: ${filters.oldstage.length}`}
//                       size="small"
//                       color="secondary"
//                       variant="outlined"
//                       icon={<HistoryIcon />}
//                       sx={{ color: mode === 'dark' ? '#ff9800' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.sales.length > 0 && (
//                     <Chip
//                       label={`Sales: ${filters.sales.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.chanel.length > 0 && (
//                     <Chip
//                       label={`Channel: ${filters.chanel.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.campaign.length > 0 && (
//                     <Chip
//                       label={`Campaign: ${filters.campaign.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.project.length > 0 && (
//                     <Chip
//                       label={`Project: ${filters.project.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.developer.length > 0 && (
//                     <Chip
//                       label={`Developer: ${filters.developer.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.addby.length > 0 && (
//                     <Chip
//                       label={`Added By: ${filters.addby.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.assignedFrom.length > 0 && (
//                     <Chip
//                       label={`Assigned From: ${filters.assignedFrom.length}`}
//                       size="small"
//                       color="info"
//                       variant="outlined"
//                       icon={<AssignmentIndIcon />}
//                       sx={{ color: mode === 'dark' ? '#4fc3f7' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.assignedTo.length > 0 && (
//                     <Chip
//                       label={`Assigned To: ${filters.assignedTo.length}`}
//                       size="small"
//                       color="success"
//                       variant="outlined"
//                       icon={<AssignmentTurnedInIcon />}
//                       sx={{ color: mode === 'dark' ? '#81c784' : '#1976d2' }}
//                     />
//                   )}
//                   {(filters.createdAt.from || filters.createdAt.to) && (
//                     <Chip
//                       label="Creation Date Range"
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {(filters.stagedateupdated.from || filters.stagedateupdated.to) && (
//                     <Chip
//                       label="Stage Date Range"
//                       size="small"
//                       color="warning"
//                       variant="outlined"
//                       icon={<UpdateIcon />}
//                       sx={{ color: mode === 'dark' ? '#ff9800' : '#1976d2' }}
//                     />
//                   )}
//                 </Box>
//               </Box>
//             )}
//           </LocalizationProvider>

//           {openMenu && <MenuComponent />}
//         </DialogContent>

//         <DialogActions
//           sx={{
//             p: 3,
//             gap: 1,
//             borderTop: '1px solid',
//             borderColor: 'divider',
//             position: 'sticky',
//             bottom: 0,
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//           }}
//         >
//           <Button
//             onClick={handleClearFilters}
//             variant="outlined"
//             sx={{
//               color: mode === 'dark' ? '#ffffff' : '#1976d2',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               '&:hover': { borderColor: mode === 'dark' ? '#ffffff' : '#1976d2' },
//             }}
//           >
//             Clear All
//           </Button>
//           <Box sx={{ flex: 1 }} />
//           <Button
//             onClick={onClose}
//             variant="outlined"
//             sx={{
//               color: mode === 'dark' ? '#ffffff' : '#666',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             onClick={handleApplyFilters}
//             sx={{ backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#1565c0' } }}
//           >
//             Apply Filters
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default QuickFilterModal;













// import React, { useState, useEffect } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   IconButton,
//   useTheme,
//   useMediaQuery,
//   TextField,
//   Grid,
//   InputAdornment,
//   Chip,
//   Autocomplete,
//   Checkbox,
//   Slide,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import SearchIcon from '@mui/icons-material/Search';
// import ClearIcon from '@mui/icons-material/Clear';
// import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
// import CheckBoxIcon from '@mui/icons-material/CheckBox';
// import HistoryIcon from '@mui/icons-material/History'; // أيقونة للـ Old Stage
// import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'; // أيقونة للـ Assigned From
// import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'; // أيقونة للـ Assigned To
// import UpdateIcon from '@mui/icons-material/Update'; // أيقونة للـ Stage Date
// import { useDispatch, useSelector } from 'react-redux';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import moment from 'moment';

// // استيراد الـ actions
// import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
// import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
// import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
// import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';

// // Transition للـ offcanvas من اليمين
// const SlideTransition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="left" ref={ref} {...props} />;
// });

// const QuickFilterModal = ({ open, onClose, onApplyFilters }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const dispatch = useDispatch();

//   // States للفلاتر - أضفنا stageDate
//   const [filters, setFilters] = useState({
//     budget: '',
//     stage: [],
//     oldstage: [],
//     sales: [],
//     chanel: [],
//     campaign: [],
//     project: [],
//     developer: [],
//     addby: [],
//     assignedFrom: [], // حقل جديد للـ Assigned From (User)
//     assignedTo: [],   // حقل جديد للـ Assigned To (Sales)
//     createdAt: {
//       from: null,
//       to: null
//     },
//     stagedateupdated: { // 🔥 حقل جديد للـ Stage Date Range
//       from: null,
//       to: null
//     }
//   });

//   // States للتحكم في فتح القوائم
//   const [openMenus, setOpenMenus] = useState({
//     stage: false,
//     oldstage: false,
//     sales: false,
//     chanel: false,
//     campaign: false,
//     project: false,
//     developer: false,
//     addby: false,
//     assignedFrom: false,
//     assignedTo: false
//   });

//   // States لنصوص البحث في كل Autocomplete
//   const [searchInputs, setSearchInputs] = useState({
//     stage: '',
//     oldstage: '',
//     sales: '',
//     chanel: '',
//     campaign: '',
//     project: '',
//     developer: '',
//     addby: '',
//     assignedFrom: '',
//     assignedTo: ''
//   });

//   // جلب البيانات من Redux
//   const ressales = useSelector(state => state.AllSales.sales);
//   const reschannel = useSelector(state => state.AllChannalRoot.channal);
//   const resproject = useSelector(state => state.AllProjects.Projects);
//   const resstages = useSelector(state => state.Allstages.stage);
//   const resdevelopers = useSelector(state => state.AllDevelopers.Developers);
//   const rescampaigns = useSelector(state => state.AllCampaign.campaign);
//   const resusersAuth = useSelector(state => state.AuthRoot.Signup);

//   // معالجة البيانات بشكل صحيح
//   const salesarray = (Array.isArray(ressales?.data) ? ressales.data : [])
//     .filter(sale => !["Default", "Default M", "Default T", "Default S", "Developer", "Dev"].includes(sale?.name))
//     .sort((a, b) => a?.name === "No Sales" ? -1 : b?.name === "No Sales" ? 1 : 0);

//   const channelarray = Array.isArray(reschannel?.data) ? reschannel.data : [];
//   const projectarray = Array.isArray(resproject?.data) ? resproject.data : [];
//   const stagesarray = Array.isArray(resstages?.data) ? resstages.data : [];
//   const developersarray = Array.isArray(resdevelopers?.data) ? resdevelopers.data : [];
//   const campaignsarray = Array.isArray(rescampaigns?.data) ? rescampaigns.data : [];

//   // usersarray: تستخدم لـ Added By و Assigned From
//   const usersarray = (Array.isArray(resusersAuth?.data) ? resusersAuth.data : [])
//     .filter(user => !["Default", "Default M", "Default T", "Default S", "Developer", "Dev"].includes(user?.name));

//   const getallfiltersarray = async () => {
//     await dispatch(Get_All_Sales_Action());
//     await dispatch(GetAllchannalData());
//     await dispatch(GetallProjectsdata());
//     await dispatch(GetAll_stage_Data());
//     await dispatch(GetDevelopersData());
//     await dispatch(GetAllCampainData());
//   };

//   // جلب البيانات عند فتح المودال
//   useEffect(() => {
//     if (open) {
//       getallfiltersarray();
//     }
//   }, [open, dispatch]);

//   // دوال التعامل مع الفلاتر
//   const handleFilterChange = (filterType, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [filterType]: value
//     }));
//   };

//   const handleBudgetChange = (value) => {
//     setFilters(prev => ({
//       ...prev,
//       budget: value
//     }));
//   };

//   const handleDateChange = (dateType, value) => {
//     setFilters(prev => ({
//       ...prev,
//       createdAt: {
//         ...prev.createdAt,
//         [dateType]: value ? moment(value).format('YYYY-MM-DD') : null
//       }
//     }));
//   };

//   // 🔥 دالة جديدة للتعامل مع Stage Date
//   const handleStageDateChange = (dateType, value) => {
//     setFilters(prev => ({
//       ...prev,
//       stagedateupdated: {
//         ...prev.stagedateupdated,
//         [dateType]: value ? moment(value).format('YYYY-MM-DD') : null
//       }
//     }));
//   };

//   // دالة للتحكم في فتح/قفل القوائم
//   const handleToggleMenu = (menuType, isOpen) => {
//     setOpenMenus(prev => ({
//       ...prev,
//       [menuType]: isOpen
//     }));
//   };

//   // دالة للتحكم في نصوص البحث
//   const handleSearchInputChange = (filterType, value) => {
//     setSearchInputs(prev => ({
//       ...prev,
//       [filterType]: value
//     }));
//   };

//   // دالة للحصول على الاسم المعروض
//   const getDisplayName = (item) => {
//     if (typeof item === 'string') return item;
//     return item?.name || item?.CampainName || item?.title || 'Unknown';
//   };

//   // دالة للحصول على الـ ID الفريد للعنصر
//   const getItemId = (item) => {
//     return item?._id || item?.id || item?.name || item?.CampainName || JSON.stringify(item);
//   };

//   // دالة تطبيق الفلاتر - محدثة مع دعم Stage Date
//   const handleApplyFilters = () => {
//     // تنظيف الفلاتر من القيم الفارغة
//     const cleanedFilters = {
//       ...filters,
//       // إزالة القيم الفارغة من المصفوفات
//       stage: filters.stage.filter(item => item),
//       oldstage: filters.oldstage.filter(item => item),
//       sales: filters.sales.filter(item => item),
//       chanel: filters.chanel.filter(item => item),
//       campaign: filters.campaign.filter(item => item),
//       project: filters.project.filter(item => item),
//       developer: filters.developer.filter(item => item),
//       addby: filters.addby.filter(item => item),
//       assignedFrom: filters.assignedFrom.filter(item => item),
//       assignedTo: filters.assignedTo.filter(item => item),
//       // إزالة budget إذا كان فارغاً
//       budget: filters.budget || '',
//       // التأكد من صيغة التاريخ
//       createdAt: {
//         from: filters.createdAt.from,
//         to: filters.createdAt.to
//       },
//       stagedateupdated: { // 🔥 إضافة تنظيف stageDate
//         from: filters.stagedateupdated.from,
//         to: filters.stagedateupdated.to
//       }
//     };

//     console.log("🔍 Applying filters:", cleanedFilters);

//     // ✅ بناء query string يدعم جميع الحقول المتعددة
//     const queryParams = new URLSearchParams();

//     // إضافة جميع الحقول المتعددة
//     const multiValueFields = [
//       'stage', 'sales', 'chanel', 'campaign', 'project', 'developer', 'addby'
//     ];

//     multiValueFields.forEach(field => {
//       if (cleanedFilters[field] && cleanedFilters[field].length > 0) {
//         cleanedFilters[field].forEach(item => {
//           const itemId = getItemId(item);
//           if (itemId) {
//             queryParams.append(field, itemId);
//           }
//         });
//       }
//     });

//     // 🔥 إضافة الـ Old Stage إذا كان مختار
//     if (cleanedFilters.oldstage && cleanedFilters.oldstage.length > 0) {
//       cleanedFilters.oldstage.forEach(item => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('oldstage', itemId);
//         }
//       });
//     }

//     // 🔥 إضافة الـ Assigned From إذا كان مختار
//     if (cleanedFilters.assignedFrom && cleanedFilters.assignedFrom.length > 0) {
//       cleanedFilters.assignedFrom.forEach(item => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('assignedFrom', itemId);
//         }
//       });
//     }

//     // 🔥 إضافة الـ Assigned To إذا كان مختار
//     if (cleanedFilters.assignedTo && cleanedFilters.assignedTo.length > 0) {
//       cleanedFilters.assignedTo.forEach(item => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('assignedTo', itemId);
//         }
//       });
//     }

//     // إضافة budget إذا موجود
//     if (cleanedFilters.budget) {
//       queryParams.append('budget', cleanedFilters.budget);
//     }

//     // ✅ إضافة التواريخ كـ createdFrom و createdTo
//     if (cleanedFilters.createdAt.from) {
//       queryParams.append('createdFrom', cleanedFilters.createdAt.from);
//     }
//     if (cleanedFilters.createdAt.to) {
//       queryParams.append('createdTo', cleanedFilters.createdAt.to);
//     }

//     // 🔥🔥 إضافة Stage Date Range
//     if (cleanedFilters.stagedateupdated.from) {
//       queryParams.append('stageDateFrom', cleanedFilters.stagedateupdated.from);
//     }
//     if (cleanedFilters.stagedateupdated.to) {
//       queryParams.append('stageDateTo', cleanedFilters.stagedateupdated.to);
//     }

//     const queryString = queryParams.toString();
//     console.log("🔍 Final Query String:", queryString);

//     onApplyFilters(cleanedFilters, queryString);
//     onClose();
//   };

//   // دالة مسح الفلاتر - محدثة مع stageDate
//   const handleClearFilters = () => {
//     setFilters({
//       budget: '',
//       stage: [],
//       oldstage: [],
//       sales: [],
//       chanel: [],
//       campaign: [],
//       project: [],
//       developer: [],
//       addby: [],
//       assignedFrom: [],
//       assignedTo: [],
//       createdAt: {
//         from: null,
//         to: null
//       },
//       stagedateupdated: { // 🔥 تنظيف حقل stageDate
//         from: null,
//         to: null
//       }
//     });

//     // مسح جميع نصوص البحث أيضاً
//     setSearchInputs({
//       stage: '',
//       oldstage: '',
//       sales: '',
//       chanel: '',
//       campaign: '',
//       project: '',
//       developer: '',
//       addby: '',
//       assignedFrom: '',
//       assignedTo: ''
//     });
//   };

//   // أيقونات الـ Checkbox
//   const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
//   const checkedIcon = <CheckBoxIcon fontSize="small" />;

//   // مكون الـ Autocomplete Filter Section
//   const AutocompleteFilterSection = ({
//     title,
//     filterType,
//     options,
//     renderOption = (opt) => getDisplayName(opt),
//     icon: customIcon,
//     placeholder = `Search ${title}...`
//   }) => {
//     const [localSearch, setLocalSearch] = useState('');

//     const handleChange = (event, newValue) => {
//       handleFilterChange(filterType, newValue);
//     };

//     const handleOpen = () => {
//       handleToggleMenu(filterType, true);
//       setLocalSearch(searchInputs[filterType]);
//     };

//     const handleClose = (event, reason) => {
//       if (reason === 'selectOption' || reason === 'removeOption') {
//         return;
//       }
//       handleToggleMenu(filterType, false);
//       handleSearchInputChange(filterType, localSearch);
//     };

//     const handleInputChange = (event, value) => {
//       setLocalSearch(value);
//     };

//     const filteredOptions = options.filter(option =>
//       renderOption(option).toLowerCase().includes(localSearch.toLowerCase()) ||
//       filters[filterType].some(selected => getItemId(selected) === getItemId(option))
//     );

//     return (
//       <Box sx={{ mb: 3 }}>
//         <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, alignItems: "center" }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//             {customIcon && customIcon}
//             <Typography sx={{ fontWeight: 600 }}>{title}</Typography>
//           </Box>
//           {options.length > 0 && (
//             <Button
//               onClick={() =>
//                 filters[filterType].length === options.length
//                   ? handleFilterChange(filterType, [])
//                   : handleFilterChange(filterType, [...options])
//               }
//               size="small"
//               sx={{ textTransform: "none", fontSize: "0.75rem" }}
//             >
//               {filters[filterType].length === options.length
//                 ? "Deselect All"
//                 : "Select All"}
//             </Button>
//           )}
//         </Box>

//         <Autocomplete
//           multiple
//           open={openMenus[filterType]}
//           onOpen={handleOpen}
//           onClose={handleClose}
//           disableCloseOnSelect
//           options={filteredOptions}
//           value={filters[filterType]}
//           onChange={handleChange}
//           inputValue={localSearch}
//           onInputChange={handleInputChange}
//           isOptionEqualToValue={(a, b) => getItemId(a) === getItemId(b)}
//           getOptionLabel={renderOption}
//           renderOption={(props, option, { selected }) => (
//             <li {...props}>
//               <Checkbox
//                 icon={icon}
//                 checkedIcon={checkedIcon}
//                 checked={selected}
//                 sx={{ mr: 1 }}
//               />
//               {renderOption(option)}
//             </li>
//           )}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               label={title}
//               size="small"
//               placeholder={placeholder}
//               InputProps={{
//                 ...params.InputProps,
//                 startAdornment: (
//                   <>
//                     <InputAdornment position="start">
//                       <SearchIcon fontSize="small" />
//                     </InputAdornment>
//                     {params.InputProps.startAdornment}
//                   </>
//                 ),
//                 endAdornment: (
//                   <>
//                     {localSearch && (
//                       <IconButton
//                         size="small"
//                         onClick={() => {
//                           setLocalSearch('');
//                           handleSearchInputChange(filterType, '');
//                         }}
//                         sx={{ mr: 0.5 }}
//                       >
//                         <ClearIcon fontSize="small" />
//                       </IconButton>
//                     )}
//                     {params.InputProps.endAdornment}
//                   </>
//                 ),
//               }}
//             />
//           )}
//           renderTags={(value, getTagProps) =>
//             value.map((option, index) => (
//               <Chip
//                 label={renderOption(option)}
//                 size="small"
//                 {...getTagProps({ index })}
//                 sx={{ height: 24, fontSize: "0.7rem", maxWidth: "120px" }}
//               />
//             ))
//           }
//           sx={{ width: "100%" }}
//         />
//       </Box>
//     );
//   };

//   // مكون خاص للـ Campaign Filter
//   const CampaignFilterSection = () => {
//     const [localSearch, setLocalSearch] = useState('');

//     const handleChange = (event, newValue) => {
//       handleFilterChange("campaign", newValue);
//     };

//     const handleOpen = () => {
//       handleToggleMenu('campaign', true);
//       setLocalSearch(searchInputs.campaign);
//     };

//     const handleClose = (event, reason) => {
//       if (reason === 'selectOption' || reason === 'removeOption') {
//         return;
//       }
//       handleToggleMenu('campaign', false);
//       handleSearchInputChange('campaign', localSearch);
//     };

//     const handleInputChange = (event, value) => {
//       setLocalSearch(value);
//     };

//     const filteredOptions = campaignsarray.filter(option =>
//       (option?.CampainName || 'Unknown Campaign').toLowerCase().includes(localSearch.toLowerCase()) ||
//       filters.campaign.some(selected => getItemId(selected) === getItemId(option))
//     );

//     return (
//       <Box sx={{ mb: 3 }}>
//         <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}>
//           <Typography sx={{ fontWeight: 600 }}>Campaign</Typography>
//           {campaignsarray.length > 0 && (
//             <Button
//               onClick={() =>
//                 filters.campaign.length === campaignsarray.length
//                   ? handleFilterChange("campaign", [])
//                   : handleFilterChange("campaign", [...campaignsarray])
//               }
//               size="small"
//               sx={{ textTransform: "none", fontSize: "0.75rem" }}
//             >
//               {filters.campaign.length === campaignsarray.length
//                 ? "Deselect All"
//                 : "Select All"}
//             </Button>
//           )}
//         </Box>

//         <Autocomplete
//           multiple
//           open={openMenus.campaign}
//           onOpen={handleOpen}
//           onClose={handleClose}
//           disableCloseOnSelect
//           options={filteredOptions}
//           value={filters.campaign}
//           onChange={handleChange}
//           inputValue={localSearch}
//           onInputChange={handleInputChange}
//           isOptionEqualToValue={(a, b) => getItemId(a) === getItemId(b)}
//           getOptionLabel={(option) => option?.CampainName || "Unknown Campaign"}
//           renderOption={(props, option, { selected }) => (
//             <li {...props}>
//               <Checkbox
//                 icon={icon}
//                 checkedIcon={checkedIcon}
//                 checked={selected}
//                 sx={{ mr: 1 }}
//               />
//               {option?.CampainName || "Unknown Campaign"}
//             </li>
//           )}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               label="Campaign"
//               size="small"
//               placeholder="Search Campaign..."
//               InputProps={{
//                 ...params.InputProps,
//                 startAdornment: (
//                   <>
//                     <InputAdornment position="start">
//                       <SearchIcon fontSize="small" />
//                     </InputAdornment>
//                     {params.InputProps.startAdornment}
//                   </>
//                 ),
//                 endAdornment: (
//                   <>
//                     {localSearch && (
//                       <IconButton
//                         size="small"
//                         onClick={() => {
//                           setLocalSearch('');
//                           handleSearchInputChange('campaign', '');
//                         }}
//                         sx={{ mr: 0.5 }}
//                       >
//                         <ClearIcon fontSize="small" />
//                       </IconButton>
//                     )}
//                     {params.InputProps.endAdornment}
//                   </>
//                 ),
//               }}
//             />
//           )}
//           renderTags={(value, getTagProps) =>
//             value.map((option, index) => (
//               <Chip
//                 label={option?.CampainName || "Unknown Campaign"}
//                 size="small"
//                 {...getTagProps({ index })}
//                 sx={{ height: 24, fontSize: "0.7rem", maxWidth: "120px" }}
//               />
//             ))
//           }
//           sx={{ width: "100%" }}
//         />
//       </Box>
//     );
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="md"
//       fullWidth
//       fullScreen={isSmallScreen}
//       TransitionComponent={SlideTransition}
//       PaperProps={{
//         sx: {
//           borderRadius: 0,
//           backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//           backgroundImage: 'none',
//           margin: 0,
//           height: '100vh',
//           width: isSmallScreen ? '100vw' : '600px',
//           maxWidth: '600px !important',
//           position: 'fixed',
//           right: 0,
//           top: 0,
//           bottom: 0,
//           overflow: 'hidden',
//           boxShadow: '0 0 20px rgba(0,0,0,0.3)'
//         }
//       }}
//       sx={{
//         '& .MuiBackdrop-root': {
//           backgroundColor: 'rgba(0, 0, 0, 0.5)'
//         },
//         '& .MuiDialog-container': {
//           overflow: 'hidden'
//         }
//       }}
//     >
//       <DialogTitle
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           backgroundColor: mode === 'dark' ? 'primary.dark' : 'primary.main',
//           color: 'white',
//           padding: '16px 24px',
//           position: 'sticky',
//           top: 0,
//           zIndex: 9999,
//           boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//           minHeight: '64px'
//         }}
//       >
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//           <FilterListIcon />
//           <Typography variant="h6" component="span">
//             Quick Filter
//           </Typography>
//         </Box>
//         <IconButton
//           onClick={onClose}
//           sx={{ color: 'white' }}
//           size="small"
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent sx={{
//         p: 3,
//         overflow: 'auto',
//         width: '100%',
//         margin: 0,
//         height: 'calc(100vh - 128px)'
//       }}>
//         <LocalizationProvider dateAdapter={AdapterMoment}>
//           <Grid container spacing={3} alignItems="flex-start">
//             <Grid item xs={12}>

//               {/* Budget Filter */}
//               <Box sx={{ mb: 3, minHeight: '95px', display: 'flex', flexDirection: 'column', marginTop:"40px" }}>
//                 <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: '600', fontSize: '0.95rem', minHeight: '24px', lineHeight: '1.2' }}>
//                   Budget
//                 </Typography>
//                 <Box sx={{ flex: 1 }}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     placeholder="Enter budget amount..."
//                     value={filters.budget}
//                     onChange={(e) => handleBudgetChange(e.target.value)}
//                     type="number"
//                     sx={{ width: '100%', '& .MuiInputBase-root': { width: '100%' } }}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Typography variant="body2" color="text.secondary">$</Typography>
//                         </InputAdornment>
//                       ),
//                       endAdornment: filters.budget && (
//                         <InputAdornment position="end">
//                           <IconButton size="small" onClick={() => handleBudgetChange('')}>
//                             <ClearIcon fontSize="small" />
//                           </IconButton>
//                         </InputAdornment>
//                       )
//                     }}
//                   />
//                 </Box>
//                 <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block', minHeight: '20px' }}>
//                   Enter the budget amount
//                 </Typography>
//               </Box>

//               {/* Stage Filter */}
//               <AutocompleteFilterSection title="Stage" filterType="stage" options={stagesarray} renderOption={(opt) => opt?.name || 'Unknown Stage'} />

//               {/* 🔥 Old Stage Filter - حقل جديد */}
//               <AutocompleteFilterSection
//                 title="Old Stage"
//                 filterType="oldstage"
//                 options={stagesarray}
//                 renderOption={(opt) => opt?.name || 'Unknown Stage'}
//                 icon={<HistoryIcon fontSize="small" sx={{ mr: 0.5 }} />}
//               />

//               {/* Sales Filter */}
//               <AutocompleteFilterSection title="Sales" filterType="sales" options={salesarray} renderOption={(opt) => opt?.name || 'Unknown Sales'} />

//               {/* Channel Filter */}
//               <AutocompleteFilterSection title="Channel" filterType="chanel" options={channelarray} renderOption={(opt) => opt?.name || 'Unknown Channel'} />

//               {/* Campaign Filter */}
//               <CampaignFilterSection />

//               {/* Project Filter */}
//               <AutocompleteFilterSection title="Project" filterType="project" options={projectarray} renderOption={(opt) => opt?.name || 'Unknown Project'} />

//               {/* Developer Filter */}
//               <AutocompleteFilterSection title="Developer" filterType="developer" options={developersarray} renderOption={(opt) => opt?.name || 'Unknown Developer'} />

//               {/* Added By Filter */}
//               <AutocompleteFilterSection title="Added By" filterType="addby" options={usersarray} renderOption={(opt) => opt?.name || 'Unknown User'} />

//               {/* 🔥 Assigned From Filter */}
//               <AutocompleteFilterSection
//                 title="Assigned From"
//                 filterType="assignedFrom"
//                 options={usersarray}
//                 renderOption={(opt) => opt?.name || 'Unknown User'}
//                 icon={<AssignmentIndIcon fontSize="small" sx={{ mr: 0.5 }} />}
//                 placeholder="Search Assigned From User..."
//               />

//               {/* 🔥 Assigned To Filter */}
//               <AutocompleteFilterSection
//                 title="Assigned To"
//                 filterType="assignedTo"
//                 options={salesarray}
//                 renderOption={(opt) => opt?.name || 'Unknown Sales'}
//                 icon={<AssignmentTurnedInIcon fontSize="small" sx={{ mr: 0.5 }} />}
//                 placeholder="Search Assigned To Sales..."
//               />

//               {/* Creation Date Range */}
//               <Box sx={{ mb: 3, p: 2, border: '1px solid', borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', borderRadius: 1, minHeight: '110px' }}>
//                 <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: '600', fontSize: '0.95rem', minHeight: '24px', lineHeight: '1.2' }}>
//                   Creation Date Range
//                 </Typography>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="From Date"
//                       value={filters.createdAt.from ? moment(filters.createdAt.from) : null}
//                       onChange={(date) => handleDateChange('from', date)}
//                       slotProps={{ textField: { fullWidth: true, size: 'small' } }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="To Date"
//                       value={filters.createdAt.to ? moment(filters.createdAt.to) : null}
//                       onChange={(date) => handleDateChange('to', date)}
//                       slotProps={{ textField: { fullWidth: true, size: 'small' } }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Box>

//               {/* 🔥🔥 Stage Date Range - حقل جديد */}
//               <Box sx={{ mb: 3, p: 2, border: '1px solid', borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', borderRadius: 1, minHeight: '110px', backgroundColor: mode === 'dark' ? 'rgba(255,152,0,0.05)' : 'rgba(255,152,0,0.05)' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                   <UpdateIcon fontSize="small" color="warning" />
//                   <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: '600', fontSize: '0.95rem', minHeight: '24px', lineHeight: '1.2', color: mode === 'dark' ? '#ff9800' : '#1976d2' }}>
//                     Stage Date Range
//                   </Typography>
//                 </Box>
//                 <Typography variant="caption" color="text.secondary" gutterBottom sx={{ display: 'block', mb: 2 }}>
//                   Filter by stage update date (Stage Date Updated)
//                 </Typography>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="Stage Date From"
//                       value={filters.stagedateupdated.from ? moment(filters.stagedateupdated.from) : null}
//                       onChange={(date) => handleStageDateChange('from', date)}
//                       slotProps={{
//                         textField: {
//                           fullWidth: true,
//                           size: 'small',
//                           sx: {
//                             '& .MuiInputLabel-root': {
//                               color: mode === 'dark' ? '#ff9800' : '#1976d2'
//                             },
//                             '& .MuiOutlinedInput-root': {
//                               '&:hover .MuiOutlinedInput-notchedOutline': {
//                                 borderColor: mode === 'dark' ? '#ff9800' : '#1976d2'
//                               }
//                             }
//                           }
//                         }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="Stage Date To"
//                       value={filters.stagedateupdated.to ? moment(filters.stagedateupdated.to) : null}
//                       onChange={(date) => handleStageDateChange('to', date)}
//                       slotProps={{
//                         textField: {
//                           fullWidth: true,
//                           size: 'small',
//                           sx: {
//                             '& .MuiInputLabel-root': {
//                               color: mode === 'dark' ? '#ff9800' : '#1976d2'
//                             },
//                             '& .MuiOutlinedInput-root': {
//                               '&:hover .MuiOutlinedInput-notchedOutline': {
//                                 borderColor: mode === 'dark' ? '#ff9800' : '#1976d2'
//                               }
//                             }
//                           }
//                         }
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Selected Filters Summary */}
//           {(filters.budget || Object.values(filters).some(val =>
//             Array.isArray(val) ? val.length > 0 :
//             typeof val === 'object' && val !== null ? (val.from || val.to) :
//             false
//           )) && (
//             <Box sx={{ mt: 3, p: 2, backgroundColor: mode === 'dark' ? 'rgba(25,118,210,0.1)' : 'rgba(25,118,210,0.05)', borderRadius: 2 }}>
//               <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
//                 Selected Filters:
//               </Typography>
//               <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                 {filters.budget && (
//                   <Chip label={`Budget: $${filters.budget}`} size="small" color="primary" variant="outlined" onDelete={() => handleBudgetChange('')} deleteIcon={<ClearIcon />} />
//                 )}
//                 {filters.stage.length > 0 && <Chip label={`Stage: ${filters.stage.length}`} size="small" color="primary" variant="outlined" />}
//                 {filters.oldstage.length > 0 && <Chip label={`Old Stage: ${filters.oldstage.length}`} size="small" color="secondary" variant="outlined" icon={<HistoryIcon />} />}
//                 {filters.sales.length > 0 && <Chip label={`Sales: ${filters.sales.length}`} size="small" color="primary" variant="outlined" />}
//                 {filters.chanel.length > 0 && <Chip label={`Channel: ${filters.chanel.length}`} size="small" color="primary" variant="outlined" />}
//                 {filters.campaign.length > 0 && <Chip label={`Campaign: ${filters.campaign.length}`} size="small" color="primary" variant="outlined" />}
//                 {filters.project.length > 0 && <Chip label={`Project: ${filters.project.length}`} size="small" color="primary" variant="outlined" />}
//                 {filters.developer.length > 0 && <Chip label={`Developer: ${filters.developer.length}`} size="small" color="primary" variant="outlined" />}
//                 {filters.addby.length > 0 && <Chip label={`Added By: ${filters.addby.length}`} size="small" color="primary" variant="outlined" />}
//                 {filters.assignedFrom.length > 0 && <Chip label={`Assigned From: ${filters.assignedFrom.length}`} size="small" color="info" variant="outlined" icon={<AssignmentIndIcon />} />}
//                 {filters.assignedTo.length > 0 && <Chip label={`Assigned To: ${filters.assignedTo.length}`} size="small" color="success" variant="outlined" icon={<AssignmentTurnedInIcon />} />}
//                 {(filters.createdAt.from || filters.createdAt.to) && (
//                   <Chip label="Creation Date Range" size="small" color="primary" variant="outlined" />
//                 )}
//                 {/* 🔥 إضافة Stage Date Range في الملخص */}
//                 {(filters.stagedateupdated.from || filters.stagedateupdated.to) && (
//                   <Chip label="Stage Date Range" size="small" color="warning" variant="outlined" icon={<UpdateIcon />} />
//                 )}
//               </Box>
//             </Box>
//           )}
//         </LocalizationProvider>
//       </DialogContent>

//       <DialogActions sx={{ p: 3, gap: 1, borderTop: '1px solid', borderColor: 'divider', position: 'sticky', bottom: 0, backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff' }}>
//         <Button onClick={handleClearFilters} variant="outlined" sx={{ color: mode === 'dark' ? '#ffffff' : '#1976d2', borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)', '&:hover': { borderColor: mode === 'dark' ? '#ffffff' : '#1976d2', } }}>
//           Clear All
//         </Button>
//         <Box sx={{ flex: 1 }} />
//         <Button onClick={onClose} variant="outlined" sx={{ color: mode === 'dark' ? '#ffffff' : '#666', borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)', }}>
//           Cancel
//         </Button>
//         <Button variant="contained" onClick={handleApplyFilters} sx={{ backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#1565c0' } }}>
//           Apply Filters
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default QuickFilterModal;

// =======================================================================================================

// import React, { useState, useEffect, useRef } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   IconButton,
//   useTheme,
//   useMediaQuery,
//   TextField,
//   Grid,
//   InputAdornment,
//   Chip,
//   Checkbox,
//   Slide,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Paper,
//   ClickAwayListener,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import SearchIcon from '@mui/icons-material/Search';
// import ClearIcon from '@mui/icons-material/Clear';
// import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
// import CheckBoxIcon from '@mui/icons-material/CheckBox';
// import HistoryIcon from '@mui/icons-material/History';
// import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
// import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// import UpdateIcon from '@mui/icons-material/Update';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import { useDispatch, useSelector } from 'react-redux';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import moment from 'moment';

// // استيراد الـ actions
// import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
// import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
// import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
// import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';

// // Transition للـ offcanvas من اليمين
// const SlideTransition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="left" ref={ref} {...props} />;
// });

// // أيقونات الـ Checkbox
// const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
// const checkedIcon = <CheckBoxIcon fontSize="small" />;

// const QuickFilterModal = ({ open, onClose, onApplyFilters }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const dispatch = useDispatch();

//   // States للفلاتر
//   const [filters, setFilters] = useState({
//     budget: '',
//     stage: [],
//     oldstage: [],
//     sales: [],
//     chanel: [],
//     campaign: [],
//     project: [],
//     developer: [],
//     addby: [],
//     assignedFrom: [],
//     assignedTo: [],
//     createdAt: {
//       from: null,
//       to: null
//     },
//     stagedateupdated: {
//       from: null,
//       to: null
//     }
//   });

//   // State للقائمة المفتوحة حاليًا
//   const [openMenu, setOpenMenu] = useState(null);
//   const [searchValue, setSearchValue] = useState('');
//   const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0, width: 0 });

//   // Refs للحقول
//   const fieldRefs = {
//     stage: useRef(null),
//     oldstage: useRef(null),
//     sales: useRef(null),
//     chanel: useRef(null),
//     campaign: useRef(null),
//     project: useRef(null),
//     developer: useRef(null),
//     addby: useRef(null),
//     assignedFrom: useRef(null),
//     assignedTo: useRef(null)
//   };

//   // جلب البيانات من Redux
//   const ressales = useSelector(state => state.AllSales.sales);
//   const reschannel = useSelector(state => state.AllChannalRoot.channal);
//   const resproject = useSelector(state => state.AllProjects.Projects);
//   const resstages = useSelector(state => state.Allstages.stage);
//   const resdevelopers = useSelector(state => state.AllDevelopers.Developers);
//   const rescampaigns = useSelector(state => state.AllCampaign.campaign);
//   const resusersAuth = useSelector(state => state.AuthRoot.Signup);

//   // معالجة البيانات بشكل صحيح
//   const salesarray = (Array.isArray(ressales?.data) ? ressales.data : [])
//     .filter(sale => !["Default", "Default M", "Default T", "Default S", "Developer", "Dev"].includes(sale?.name))
//     .sort((a, b) => a?.name === "No Sales" ? -1 : b?.name === "No Sales" ? 1 : 0);

//   const channelarray = Array.isArray(reschannel?.data) ? reschannel.data : [];
//   const projectarray = Array.isArray(resproject?.data) ? resproject.data : [];
//   const stagesarray = Array.isArray(resstages?.data) ? resstages.data : [];
//   const developersarray = Array.isArray(resdevelopers?.data) ? resdevelopers.data : [];
//   const campaignsarray = Array.isArray(rescampaigns?.data) ? rescampaigns.data : [];

//   const usersarray = (Array.isArray(resusersAuth?.data) ? resusersAuth.data : [])
//     .filter(user => !["Default", "Default M", "Default T", "Default S", "Developer", "Dev"].includes(user?.name));

//   const getallfiltersarray = async () => {
//     await dispatch(Get_All_Sales_Action());
//     await dispatch(GetAllchannalData());
//     await dispatch(GetallProjectsdata());
//     await dispatch(GetAll_stage_Data());
//     await dispatch(GetDevelopersData());
//     await dispatch(GetAllCampainData());
//   };

//   useEffect(() => {
//     if (open) {
//       getallfiltersarray();
//     }
//   }, [open, dispatch]);

//   // دوال التعامل مع الفلاتر
//   const handleFilterChange = (filterType, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [filterType]: value
//     }));
//   };

//   const handleBudgetChange = (value) => {
//     setFilters(prev => ({
//       ...prev,
//       budget: value
//     }));
//   };

//   const handleDateChange = (dateType, value) => {
//     setFilters(prev => ({
//       ...prev,
//       createdAt: {
//         ...prev.createdAt,
//         [dateType]: value ? moment(value).format('YYYY-MM-DD') : null
//       }
//     }));
//   };

//   const handleStageDateChange = (dateType, value) => {
//     setFilters(prev => ({
//       ...prev,
//       stagedateupdated: {
//         ...prev.stagedateupdated,
//         [dateType]: value ? moment(value).format('YYYY-MM-DD') : null
//       }
//     }));
//   };

//   // دالة للتعامل مع اختيار/إزالة عنصر
//   const handleItemToggle = (filterType, item) => {
//     setFilters(prev => {
//       const current = prev[filterType];
//       const isSelected = current.some(i => getItemId(i) === getItemId(item));

//       if (isSelected) {
//         return {
//           ...prev,
//           [filterType]: current.filter(i => getItemId(i) !== getItemId(item))
//         };
//       } else {
//         return {
//           ...prev,
//           [filterType]: [...current, item]
//         };
//       }
//     });
//   };

//   // دالة Select All
//   const handleSelectAll = (filterType, options) => {
//     setFilters(prev => {
//       const current = prev[filterType];
//       if (current.length === options.length) {
//         return {
//           ...prev,
//           [filterType]: []
//         };
//       } else {
//         return {
//           ...prev,
//           [filterType]: [...options]
//         };
//       }
//     });
//   };

//   // دالة فتح القائمة
//   const handleOpenMenu = (menuType) => {
//     const fieldRef = fieldRefs[menuType];
//     if (fieldRef.current) {
//       const rect = fieldRef.current.getBoundingClientRect();
//       setAnchorPosition({
//         top: rect.bottom + window.scrollY,
//         left: rect.left + window.scrollX,
//         width: rect.width
//       });
//       setOpenMenu(menuType);
//       setSearchValue('');
//     }
//   };

//   // دالة إغلاق القائمة
//   const handleCloseMenu = () => {
//     setOpenMenu(null);
//     setSearchValue('');
//   };

//   // دالة للحصول على الاسم المعروض
//   const getDisplayName = (item) => {
//     if (typeof item === 'string') return item;
//     return item?.name || item?.CampainName || item?.title || 'Unknown';
//   };

//   // دالة للحصول على الـ ID الفريد للعنصر
//   const getItemId = (item) => {
//     return item?._id || item?.id || item?.name || item?.CampainName || JSON.stringify(item);
//   };

//   // دالة تطبيق الفلاتر
//   const handleApplyFilters = () => {
//     // تنظيف الفلاتر من القيم الفارغة
//     const cleanedFilters = {
//       ...filters,
//       stage: filters.stage.filter(item => item),
//       oldstage: filters.oldstage.filter(item => item),
//       sales: filters.sales.filter(item => item),
//       chanel: filters.chanel.filter(item => item),
//       campaign: filters.campaign.filter(item => item),
//       project: filters.project.filter(item => item),
//       developer: filters.developer.filter(item => item),
//       addby: filters.addby.filter(item => item),
//       assignedFrom: filters.assignedFrom.filter(item => item),
//       assignedTo: filters.assignedTo.filter(item => item),
//       budget: filters.budget || '',
//       createdAt: {
//         from: filters.createdAt.from,
//         to: filters.createdAt.to
//       },
//       stagedateupdated: {
//         from: filters.stagedateupdated.from,
//         to: filters.stagedateupdated.to
//       }
//     };

//     console.log("🔍 Applying filters:", cleanedFilters);

//     const queryParams = new URLSearchParams();

//     const multiValueFields = [
//       'stage', 'sales', 'chanel', 'campaign', 'project', 'developer', 'addby'
//     ];

//     multiValueFields.forEach(field => {
//       if (cleanedFilters[field] && cleanedFilters[field].length > 0) {
//         cleanedFilters[field].forEach(item => {
//           const itemId = getItemId(item);
//           if (itemId) {
//             queryParams.append(field, itemId);
//           }
//         });
//       }
//     });

//     if (cleanedFilters.oldstage && cleanedFilters.oldstage.length > 0) {
//       cleanedFilters.oldstage.forEach(item => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('oldstage', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.assignedFrom && cleanedFilters.assignedFrom.length > 0) {
//       cleanedFilters.assignedFrom.forEach(item => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('assignedFrom', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.assignedTo && cleanedFilters.assignedTo.length > 0) {
//       cleanedFilters.assignedTo.forEach(item => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('assignedTo', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.budget) {
//       queryParams.append('budget', cleanedFilters.budget);
//     }

//     if (cleanedFilters.createdAt.from) {
//       queryParams.append('createdFrom', cleanedFilters.createdAt.from);
//     }
//     if (cleanedFilters.createdAt.to) {
//       queryParams.append('createdTo', cleanedFilters.createdAt.to);
//     }

//     if (cleanedFilters.stagedateupdated.from) {
//       queryParams.append('stageDateFrom', cleanedFilters.stagedateupdated.from);
//     }
//     if (cleanedFilters.stagedateupdated.to) {
//       queryParams.append('stageDateTo', cleanedFilters.stagedateupdated.to);
//     }

//     const queryString = queryParams.toString();
//     console.log("🔍 Final Query String:", queryString);

//     onApplyFilters(cleanedFilters, queryString);
//     onClose();
//   };

//   // دالة مسح الفلاتر
//   const handleClearFilters = () => {
//     setFilters({
//       budget: '',
//       stage: [],
//       oldstage: [],
//       sales: [],
//       chanel: [],
//       campaign: [],
//       project: [],
//       developer: [],
//       addby: [],
//       assignedFrom: [],
//       assignedTo: [],
//       createdAt: {
//         from: null,
//         to: null
//       },
//       stagedateupdated: {
//         from: null,
//         to: null
//       }
//     });
//     handleCloseMenu();
//   };

//   // مكون القائمة المفتوحة
//   const MenuComponent = () => {
//     if (!openMenu) return null;

//     let options = [];
//     switch (openMenu) {
//       case 'stage': options = stagesarray; break;
//       case 'oldstage': options = stagesarray; break;
//       case 'sales': options = salesarray; break;
//       case 'chanel': options = channelarray; break;
//       case 'campaign': options = campaignsarray; break;
//       case 'project': options = projectarray; break;
//       case 'developer': options = developersarray; break;
//       case 'addby': options = usersarray; break;
//       case 'assignedFrom': options = usersarray; break;
//       case 'assignedTo': options = salesarray; break;
//       default: options = [];
//     }

//     const selectedItems = filters[openMenu] || [];

//     const filteredOptions = options.filter(option =>
//       getDisplayName(option).toLowerCase().includes(searchValue.toLowerCase()) ||
//       selectedItems.some(selected => getItemId(selected) === getItemId(option))
//     );

//     return (
//       <ClickAwayListener onClickAway={handleCloseMenu}>
//         <Paper
//           sx={{
//             position: 'fixed',
//             top: anchorPosition.top,
//             left: anchorPosition.left,
//             width: anchorPosition.width || 300,
//             maxHeight: 400,
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
//             border: mode === 'dark' ? '1px solid #444' : '1px solid #ddd',
//             boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
//             borderRadius: '8px',
//             overflow: 'hidden',
//             zIndex: 999999,
//           }}
//         >
//           {/* حقل البحث */}
//           <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}` }}>
//             <TextField
//               fullWidth
//               size="small"
//               placeholder={`Search...`}
//               value={searchValue}
//               onChange={(e) => setSearchValue(e.target.value)}
//               autoFocus
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon fontSize="small" />
//                   </InputAdornment>
//                 ),
//                 endAdornment: searchValue && (
//                   <InputAdornment position="end">
//                     <IconButton
//                       size="small"
//                       onClick={() => setSearchValue('')}
//                       edge="end"
//                     >
//                       <ClearIcon fontSize="small" />
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//                 sx: {
//                   fontSize: '14px',
//                 }
//               }}
//             />
//           </Box>

//           {/* Select All Button */}
//           <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}` }}>
//             <Button
//               onClick={() => handleSelectAll(openMenu, options)}
//               size="small"
//               fullWidth
//               sx={{
//                 textTransform: "none",
//                 fontSize: "0.75rem",
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 justifyContent: 'flex-start',
//                 paddingLeft: 2
//               }}
//             >
//               {selectedItems.length === options.length
//                 ? "Deselect All"
//                 : "Select All"}
//             </Button>
//           </Box>

//           {/* القائمة */}
//           <List
//             sx={{
//               maxHeight: 300,
//               overflow: 'auto',
//               p: 0,
//             }}
//           >
//             {filteredOptions.length > 0 ? (
//               filteredOptions.map((option, index) => {
//                 const isSelected = selectedItems.some(
//                   item => getItemId(item) === getItemId(option)
//                 );

//                 return (
//                   <ListItem
//                     key={getItemId(option) || index}
//                     onClick={() => handleItemToggle(openMenu, option)}
//                     sx={{
//                       py: 1,
//                       px: 2,
//                       cursor: 'pointer',
//                       backgroundColor: isSelected
//                         ? (mode === 'dark' ? 'rgba(25, 118, 210, 0.2)' : 'rgba(25, 118, 210, 0.1)')
//                         : 'transparent',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                       '&:hover': {
//                         backgroundColor: isSelected
//                           ? (mode === 'dark' ? 'rgba(25, 118, 210, 0.3)' : 'rgba(25, 118, 210, 0.15)')
//                           : (mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.04)'),
//                       },
//                     }}
//                   >
//                     <ListItemIcon sx={{ minWidth: 40 }}>
//                       <Checkbox
//                         checked={isSelected}
//                         icon={icon}
//                         checkedIcon={checkedIcon}
//                         sx={{
//                           color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                           '&.Mui-checked': {
//                             color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                           },
//                         }}
//                       />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={getDisplayName(option)}
//                       primaryTypographyProps={{
//                         fontSize: '14px',
//                         fontWeight: isSelected ? '500' : '400',
//                       }}
//                     />
//                   </ListItem>
//                 );
//               })
//             ) : (
//               <ListItem disabled sx={{ justifyContent: 'center', py: 2 }}>
//                 <Typography variant="body2" color="text.secondary">
//                   No options found
//                 </Typography>
//               </ListItem>
//             )}
//           </List>
//         </Paper>
//       </ClickAwayListener>
//     );
//   };

//   // مكون حقل الفلتر
//   const FilterField = ({
//     title,
//     filterType,
//     icon: customIcon,
//     placeholder = `Select ${title}...`
//   }) => {
//     const selectedItems = filters[filterType] || [];
//     const isOpen = openMenu === filterType;

//     const handleClick = () => {
//       if (isOpen) {
//         handleCloseMenu();
//       } else {
//         handleOpenMenu(filterType);
//       }
//     };

//     const handleRemoveItem = (item, event) => {
//       event.stopPropagation();
//       handleItemToggle(filterType, item);
//     };

//     return (
//       <Box sx={{ mb: 3 }}>
//         <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, alignItems: "center" }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//             {customIcon && customIcon}
//             <Typography sx={{ fontWeight: 600, color: mode === 'dark' ? '#fff' : '#000' }}>
//               {title}
//             </Typography>
//           </Box>
//         </Box>

//         {/* حقل الاختيار */}
//         <Box
//           ref={fieldRefs[filterType]}
//           onClick={handleClick}
//           sx={{
//             border: '1px solid',
//             borderColor: isOpen
//               ? (mode === 'dark' ? '#90caf9' : '#1976d2')
//               : (mode === 'dark' ? '#444' : '#ccc'),
//             borderRadius: '4px',
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
//             minHeight: '40px',
//             padding: '8px 12px',
//             cursor: 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             '&:hover': {
//               borderColor: mode === 'dark' ? '#666' : '#999',
//             },
//             position: 'relative',
//             outline: isOpen ? `2px solid ${mode === 'dark' ? '#90caf9' : '#1976d2'}` : 'none',
//             outlineOffset: '-2px',
//           }}
//         >
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, flex: 1 }}>
//             {selectedItems.length > 0 ? (
//               selectedItems.slice(0, 3).map((item, index) => (
//                 <Chip
//                   key={index}
//                   label={getDisplayName(item)}
//                   size="small"
//                   onDelete={(e) => handleRemoveItem(item, e)}
//                   sx={{
//                     height: 24,
//                     fontSize: '0.7rem',
//                     backgroundColor: mode === 'dark' ? '#1976d2' : '#e3f2fd',
//                     color: mode === 'dark' ? '#fff' : '#1976d2',
//                     '& .MuiChip-deleteIcon': {
//                       fontSize: '1rem',
//                       color: 'inherit',
//                       '&:hover': {
//                         color: mode === 'dark' ? '#bbdefb' : '#bbdefb',
//                       }
//                     }
//                   }}
//                 />
//               ))
//             ) : (
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                   fontStyle: 'italic'
//                 }}
//               >
//                 {placeholder}
//               </Typography>
//             )}
//             {selectedItems.length > 3 && (
//               <Chip
//                 label={`+${selectedItems.length - 3} more`}
//                 size="small"
//                 sx={{
//                   height: 24,
//                   fontSize: '0.7rem',
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
//                 }}
//               />
//             )}
//           </Box>
//           <ArrowDropDownIcon sx={{
//             color: isOpen
//               ? (mode === 'dark' ? '#90caf9' : '#1976d2')
//               : (mode === 'dark' ? '#aaa' : '#666'),
//             ml: 1,
//             transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
//             transition: 'transform 0.2s'
//           }} />
//         </Box>

//         {/* عرض العناصر المختارة تحت الحقل */}
//         {selectedItems.length > 0 && (
//           <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//             {selectedItems.map((item, index) => (
//               <Chip
//                 key={index}
//                 label={getDisplayName(item)}
//                 size="small"
//                 onDelete={(e) => handleRemoveItem(item, e)}
//                 sx={{
//                   height: 24,
//                   fontSize: '0.7rem',
//                   backgroundColor: mode === 'dark' ? '#1976d2' : '#e3f2fd',
//                   color: mode === 'dark' ? '#fff' : '#1976d2',
//                   '& .MuiChip-deleteIcon': {
//                     fontSize: '1rem',
//                     color: 'inherit',
//                     '&:hover': {
//                       color: mode === 'dark' ? '#bbdefb' : '#bbdefb',
//                     }
//                   }
//                 }}
//               />
//             ))}
//           </Box>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="md"
//       fullWidth
//       fullScreen={isSmallScreen}
//       TransitionComponent={SlideTransition}
//       PaperProps={{
//         sx: {
//           borderRadius: 0,
//           backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//           backgroundImage: 'none',
//           margin: 0,
//           height: '100vh',
//           width: isSmallScreen ? '100vw' : '600px',
//           maxWidth: '600px !important',
//           position: 'fixed',
//           right: 0,
//           top: 0,
//           bottom: 0,
//           overflow: 'hidden',
//           boxShadow: '0 0 20px rgba(0,0,0,0.3)'
//         }
//       }}
//       sx={{
//         '& .MuiBackdrop-root': {
//           backgroundColor: 'rgba(0, 0, 0, 0.5)'
//         },
//         '& .MuiDialog-container': {
//           overflow: 'hidden'
//         }
//       }}
//     >
//       <DialogTitle
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           backgroundColor: mode === 'dark' ? 'primary.dark' : 'primary.main',
//           color: 'white',
//           padding: '16px 24px',
//           position: 'sticky',
//           top: 0,
//           zIndex: 9999,
//           boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//           minHeight: '64px'
//         }}
//       >
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//           <FilterListIcon />
//           <Typography variant="h6" component="span">
//             Quick Filter
//           </Typography>
//         </Box>
//         <IconButton
//           onClick={onClose}
//           sx={{ color: 'white' }}
//           size="small"
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent sx={{
//         p: 3,
//         overflow: 'auto',
//         width: '100%',
//         margin: 0,
//         height: 'calc(100vh - 128px)'
//       }}>
//         <LocalizationProvider dateAdapter={AdapterMoment}>
//           <Grid container spacing={3} alignItems="flex-start">
//             <Grid item xs={12}>

//               {/* Budget Filter */}
//               <Box sx={{ mb: 3, minHeight: '95px', display: 'flex', flexDirection: 'column', marginTop:"40px" }}>
//                 <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: '600', fontSize: '0.95rem', minHeight: '24px', lineHeight: '1.2', color: mode === 'dark' ? '#fff' : '#000' }}>
//                   Budget
//                 </Typography>
//                 <Box sx={{ flex: 1 }}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     placeholder="Enter budget amount..."
//                     value={filters.budget}
//                     onChange={(e) => handleBudgetChange(e.target.value)}
//                     type="number"
//                     sx={{
//                       width: '100%',
//                       '& .MuiInputBase-root': {
//                         width: '100%',
//                         backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff'
//                       },
//                       '& .MuiOutlinedInput-root': {
//                         '&:hover .MuiOutlinedInput-notchedOutline': {
//                           borderColor: mode === 'dark' ? '#666' : '#1976d2'
//                         }
//                       }
//                     }}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Typography variant="body2" color={mode === 'dark' ? '#aaa' : 'text.secondary'}>$</Typography>
//                         </InputAdornment>
//                       ),
//                       endAdornment: filters.budget && (
//                         <InputAdornment position="end">
//                           <IconButton size="small" onClick={() => handleBudgetChange('')}>
//                             <ClearIcon fontSize="small" />
//                           </IconButton>
//                         </InputAdornment>
//                       )
//                     }}
//                   />
//                 </Box>
//                 <Typography variant="caption" color={mode === 'dark' ? '#aaa' : 'text.secondary'} sx={{ mt: 0.5, display: 'block', minHeight: '20px' }}>
//                   Enter the budget amount
//                 </Typography>
//               </Box>

//               {/* Stage Filter */}
//               <FilterField title="Stage" filterType="stage" placeholder="Select Stage..." />

//               {/* Old Stage Filter */}
//               <FilterField
//                 title="Old Stage"
//                 filterType="oldstage"
//                 icon={<HistoryIcon fontSize="small" sx={{ mr: 0.5, color: mode === 'dark' ? '#ff9800' : '#1976d2' }} />}
//                 placeholder="Select Old Stage..."
//               />

//               {/* Sales Filter */}
//               <FilterField title="Sales" filterType="sales" placeholder="Select Sales..." />

//               {/* Channel Filter */}
//               <FilterField title="Channel" filterType="chanel" placeholder="Select Channel..." />

//               {/* Campaign Filter */}
//               <FilterField title="Campaign" filterType="campaign" placeholder="Select Campaign..." />

//               {/* Project Filter */}
//               <FilterField title="Project" filterType="project" placeholder="Select Project..." />

//               {/* Developer Filter */}
//               <FilterField title="Developer" filterType="developer" placeholder="Select Developer..." />

//               {/* Added By Filter */}
//               <FilterField title="Added By" filterType="addby" placeholder="Select Added By..." />

//               {/* Assigned From Filter */}
//               <FilterField
//                 title="Assigned From"
//                 filterType="assignedFrom"
//                 icon={<AssignmentIndIcon fontSize="small" sx={{ mr: 0.5, color: mode === 'dark' ? '#4fc3f7' : '#1976d2' }} />}
//                 placeholder="Select Assigned From..."
//               />

//               {/* Assigned To Filter */}
//               <FilterField
//                 title="Assigned To"
//                 filterType="assignedTo"
//                 icon={<AssignmentTurnedInIcon fontSize="small" sx={{ mr: 0.5, color: mode === 'dark' ? '#81c784' : '#1976d2' }} />}
//                 placeholder="Select Assigned To..."
//               />

//               {/* Creation Date Range */}
//               <Box sx={{ mb: 3, p: 2, border: '1px solid', borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', borderRadius: 1, minHeight: '110px', backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fafafa' }}>
//                 <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: '600', fontSize: '0.95rem', minHeight: '24px', lineHeight: '1.2', color: mode === 'dark' ? '#fff' : '#000' }}>
//                   Creation Date Range
//                 </Typography>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="From Date"
//                       value={filters.createdAt.from ? moment(filters.createdAt.from) : null}
//                       onChange={(date) => handleDateChange('from', date)}
//                       slotProps={{
//                         textField: {
//                           fullWidth: true,
//                           size: 'small',
//                           sx: {
//                             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff'
//                           }
//                         }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="To Date"
//                       value={filters.createdAt.to ? moment(filters.createdAt.to) : null}
//                       onChange={(date) => handleDateChange('to', date)}
//                       slotProps={{
//                         textField: {
//                           fullWidth: true,
//                           size: 'small',
//                           sx: {
//                             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff'
//                           }
//                         }
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Box>

//               {/* Stage Date Range */}
//               <Box sx={{ mb: 3, p: 2, border: '1px solid', borderColor: mode === 'dark' ? 'rgba(255,152,0,0.3)' : 'rgba(255,152,0,0.2)', borderRadius: 1, minHeight: '110px', backgroundColor: mode === 'dark' ? 'rgba(255,152,0,0.05)' : 'rgba(255,152,0,0.05)' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                   <UpdateIcon fontSize="small" color="warning" />
//                   <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: '600', fontSize: '0.95rem', minHeight: '24px', lineHeight: '1.2', color: mode === 'dark' ? '#ff9800' : '#1976d2' }}>
//                     Stage Date Range
//                   </Typography>
//                 </Box>
//                 <Typography variant="caption" color={mode === 'dark' ? '#aaa' : 'text.secondary'} gutterBottom sx={{ display: 'block', mb: 2 }}>
//                   Filter by stage update date (Stage Date Updated)
//                 </Typography>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="Stage Date From"
//                       value={filters.stagedateupdated.from ? moment(filters.stagedateupdated.from) : null}
//                       onChange={(date) => handleStageDateChange('from', date)}
//                       slotProps={{
//                         textField: {
//                           fullWidth: true,
//                           size: 'small',
//                           sx: {
//                             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//                             '& .MuiInputLabel-root': {
//                               color: mode === 'dark' ? '#ff9800' : '#1976d2'
//                             },
//                             '& .MuiOutlinedInput-root': {
//                               '&:hover .MuiOutlinedInput-notchedOutline': {
//                                 borderColor: mode === 'dark' ? '#ff9800' : '#1976d2'
//                               }
//                             }
//                           }
//                         }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="Stage Date To"
//                       value={filters.stagedateupdated.to ? moment(filters.stagedateupdated.to) : null}
//                       onChange={(date) => handleStageDateChange('to', date)}
//                       slotProps={{
//                         textField: {
//                           fullWidth: true,
//                           size: 'small',
//                           sx: {
//                             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//                             '& .MuiInputLabel-root': {
//                               color: mode === 'dark' ? '#ff9800' : '#1976d2'
//                             },
//                             '& .MuiOutlinedInput-root': {
//                               '&:hover .MuiOutlinedInput-notchedOutline': {
//                                 borderColor: mode === 'dark' ? '#ff9800' : '#1976d2'
//                               }
//                             }
//                           }
//                         }
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Box>
//             </Grid>
//           </Grid>

//           {/* Selected Filters Summary */}
//           {(filters.budget || Object.values(filters).some(val =>
//             Array.isArray(val) ? val.length > 0 :
//             typeof val === 'object' && val !== null ? (val.from || val.to) :
//             false
//           )) && (
//             <Box sx={{ mt: 3, p: 2, backgroundColor: mode === 'dark' ? 'rgba(25,118,210,0.1)' : 'rgba(25,118,210,0.05)', borderRadius: 2 }}>
//               <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: mode === 'dark' ? '#fff' : '#000' }}>
//                 Selected Filters:
//               </Typography>
//               <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                 {filters.budget && (
//                   <Chip
//                     label={`Budget: $${filters.budget}`}
//                     size="small"
//                     color="primary"
//                     variant="outlined"
//                     onDelete={() => handleBudgetChange('')}
//                     deleteIcon={<ClearIcon />}
//                     sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                   />
//                 )}
//                 {filters.stage.length > 0 && <Chip label={`Stage: ${filters.stage.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.oldstage.length > 0 && <Chip label={`Old Stage: ${filters.oldstage.length}`} size="small" color="secondary" variant="outlined" icon={<HistoryIcon />} sx={{ color: mode === 'dark' ? '#ff9800' : '#1976d2' }} />}
//                 {filters.sales.length > 0 && <Chip label={`Sales: ${filters.sales.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.chanel.length > 0 && <Chip label={`Channel: ${filters.chanel.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.campaign.length > 0 && <Chip label={`Campaign: ${filters.campaign.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.project.length > 0 && <Chip label={`Project: ${filters.project.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.developer.length > 0 && <Chip label={`Developer: ${filters.developer.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.addby.length > 0 && <Chip label={`Added By: ${filters.addby.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.assignedFrom.length > 0 && <Chip label={`Assigned From: ${filters.assignedFrom.length}`} size="small" color="info" variant="outlined" icon={<AssignmentIndIcon />} sx={{ color: mode === 'dark' ? '#4fc3f7' : '#1976d2' }} />}
//                 {filters.assignedTo.length > 0 && <Chip label={`Assigned To: ${filters.assignedTo.length}`} size="small" color="success" variant="outlined" icon={<AssignmentTurnedInIcon />} sx={{ color: mode === 'dark' ? '#81c784' : '#1976d2' }} />}
//                 {(filters.createdAt.from || filters.createdAt.to) && (
//                   <Chip label="Creation Date Range" size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />
//                 )}
//                 {(filters.stagedateupdated.from || filters.stagedateupdated.to) && (
//                   <Chip label="Stage Date Range" size="small" color="warning" variant="outlined" icon={<UpdateIcon />} sx={{ color: mode === 'dark' ? '#ff9800' : '#1976d2' }} />
//                 )}
//               </Box>
//             </Box>
//           )}
//         </LocalizationProvider>

//         {/* القائمة المفتوحة */}
//         {openMenu && <MenuComponent />}
//       </DialogContent>

//       <DialogActions sx={{ p: 3, gap: 1, borderTop: '1px solid', borderColor: 'divider', position: 'sticky', bottom: 0, backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff' }}>
//         <Button onClick={handleClearFilters} variant="outlined" sx={{ color: mode === 'dark' ? '#ffffff' : '#1976d2', borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)', '&:hover': { borderColor: mode === 'dark' ? '#ffffff' : '#1976d2', } }}>
//           Clear All
//         </Button>
//         <Box sx={{ flex: 1 }} />
//         <Button onClick={onClose} variant="outlined" sx={{ color: mode === 'dark' ? '#ffffff' : '#666', borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)', }}>
//           Cancel
//         </Button>
//         <Button variant="contained" onClick={handleApplyFilters} sx={{ backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#1565c0' } }}>
//           Apply Filters
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default QuickFilterModal;

// import React, { useState, useEffect, useRef, useMemo } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   IconButton,
//   useTheme,
//   useMediaQuery,
//   TextField,
//   Grid,
//   InputAdornment,
//   Chip,
//   Checkbox,
//   Slide,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Paper,
//   ClickAwayListener,
//   Alert,
//   Collapse,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import SearchIcon from '@mui/icons-material/Search';
// import ClearIcon from '@mui/icons-material/Clear';
// import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
// import CheckBoxIcon from '@mui/icons-material/CheckBox';
// import HistoryIcon from '@mui/icons-material/History';
// import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
// import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// import UpdateIcon from '@mui/icons-material/Update';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import GroupsIcon from '@mui/icons-material/Groups';
// import InfoIcon from '@mui/icons-material/Info';
// import { useDispatch, useSelector } from 'react-redux';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import moment from 'moment';

// // استيراد الـ actions
// import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
// import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
// import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
// import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';

// // Transition للـ offcanvas من اليمين
// const SlideTransition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="left" ref={ref} {...props} />;
// });

// // أيقونات الـ Checkbox
// const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
// const checkedIcon = <CheckBoxIcon fontSize="small" />;

// const QuickFilterModal = ({ open, onClose, onApplyFilters }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const dispatch = useDispatch();

//   // States للفلاتر
//   const [filters, setFilters] = useState({
//     budget: '',
//     stage: [],
//     oldstage: [],
//     sales: [],
//     chanel: [],
//     campaign: [],
//     project: [],
//     developer: [],
//     addby: [],
//     assignedFrom: [],
//     assignedTo: [],
//     teamLeaders: [], // 🔥 حقل جديد للـ Team Leaders
//     createdAt: {
//       from: null,
//       to: null
//     },
//     stagedateupdated: {
//       from: null,
//       to: null
//     }
//   });

//   // State للتحكم في الـ auto select
//   const [showAutoSelectInfo, setShowAutoSelectInfo] = useState(true);

//   // State للقائمة المفتوحة حاليًا
//   const [openMenu, setOpenMenu] = useState(null);
//   const [searchValue, setSearchValue] = useState('');
//   const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0, width: 0 });

//   // Refs للحقول
//   const fieldRefs = {
//     stage: useRef(null),
//     oldstage: useRef(null),
//     sales: useRef(null),
//     chanel: useRef(null),
//     campaign: useRef(null),
//     project: useRef(null),
//     developer: useRef(null),
//     addby: useRef(null),
//     assignedFrom: useRef(null),
//     assignedTo: useRef(null),
//     teamLeaders: useRef(null),
//   };

//   // جلب البيانات من Redux
//   const ressales = useSelector(state => state.AllSales.sales);
//   const reschannel = useSelector(state => state.AllChannalRoot.channal);
//   const resproject = useSelector(state => state.AllProjects.Projects);
//   const resstages = useSelector(state => state.Allstages.stage);
//   const resdevelopers = useSelector(state => state.AllDevelopers.Developers);
//   const rescampaigns = useSelector(state => state.AllCampaign.campaign);
//   const resusersAuth = useSelector(state => state.AuthRoot.Signup);

//   // 🔥 استخراج جميع الـ Team Leaders الفريدة من بيانات الـ sales
//   const teamLeadersArray = useMemo(() => {
//     if (!ressales?.data || !Array.isArray(ressales.data)) return [];

//     const teamLeadersMap = new Map();

//     ressales.data.forEach(sale => {
//       if (sale?.teamleader && sale.teamleader._id) {
//         // فقط الـ Team Leaders الحقيقيين (الذين لديهم role === 'Team Leader')
//         if (sale.teamleader.role === 'Team Leader') {
//           teamLeadersMap.set(sale.teamleader._id, {
//             _id: sale.teamleader._id,
//             name: sale.teamleader.name,
//             email: sale.teamleader.email,
//             role: sale.teamleader.role,
//             profileImg: sale.teamleader.profileImg
//           });
//         }
//       }
//     });

//     return Array.from(teamLeadersMap.values())
//       .filter(leader => !["Default", "Default M", "Default T", "Default S", "Developer", "Dev"].includes(leader?.name))
//       .sort((a, b) => a?.name?.localeCompare(b?.name));
//   }, [ressales]);

//   // 🔥 دالة للحصول على الـ sales التابعين لـ Team Leader معين
//   const getSalesByTeamLeader = (teamLeaderId) => {
//     if (!teamLeaderId || !ressales?.data || !Array.isArray(ressales.data)) return [];

//     return ressales.data.filter(sale => {
//       return sale?.teamleader?._id === teamLeaderId;
//     }).filter(sale => !["Default", "Default M", "Default T", "Default S", "Developer", "Dev"].includes(sale?.name));
//   };

//   // معالجة البيانات بشكل صحيح
//   const salesarray = useMemo(() => {
//     return (Array.isArray(ressales?.data) ? ressales.data : [])
//       .filter(sale => !["Default", "Default M", "Default T", "Default S", "Developer", "Dev"].includes(sale?.name))
//       .sort((a, b) => {
//         if (a?.name === "No Sales") return -1;
//         if (b?.name === "No Sales") return 1;
//         return a?.name?.localeCompare(b?.name);
//       });
//   }, [ressales]);

//   const channelarray = Array.isArray(reschannel?.data) ? reschannel.data : [];
//   const projectarray = Array.isArray(resproject?.data) ? resproject.data : [];
//   const stagesarray = Array.isArray(resstages?.data) ? resstages.data : [];
//   const developersarray = Array.isArray(resdevelopers?.data) ? resdevelopers.data : [];
//   const campaignsarray = Array.isArray(rescampaigns?.data) ? rescampaigns.data : [];

//   const usersarray = (Array.isArray(resusersAuth?.data) ? resusersAuth.data : [])
//     .filter(user => !["Default", "Default M", "Default T", "Default S", "Developer", "Dev"].includes(user?.name));

//   const getallfiltersarray = async () => {
//     await dispatch(Get_All_Sales_Action());
//     await dispatch(GetAllchannalData());
//     await dispatch(GetallProjectsdata());
//     await dispatch(GetAll_stage_Data());
//     await dispatch(GetDevelopersData());
//     await dispatch(GetAllCampainData());
//   };

//   useEffect(() => {
//     if (open) {
//       getallfiltersarray();
//     }
//   }, [open, dispatch]);

//   // 🔥 useEffect لتفعيل الـ auto select عند اختيار Team Leader
//   useEffect(() => {
//     if (filters.teamLeaders.length > 0) {
//       // جمع جميع الـ sales التابعين لجميع الـ Team Leaders المختارين
//       const allTeamLeaderIds = filters.teamLeaders.map(tl => getItemId(tl));
//       let allSalesUnderTeamLeaders = [];

//       allTeamLeaderIds.forEach(teamLeaderId => {
//         const salesUnderTeamLeader = getSalesByTeamLeader(teamLeaderId);
//         allSalesUnderTeamLeaders = [...allSalesUnderTeamLeaders, ...salesUnderTeamLeader];
//       });

//       // إزالة التكرارات
//       const uniqueSales = Array.from(new Set(allSalesUnderTeamLeaders.map(s => getItemId(s))))
//         .map(id => allSalesUnderTeamLeaders.find(s => getItemId(s) === id))
//         .filter(s => s);

//       // تحديث الـ sales filter
//       setFilters(prev => ({
//         ...prev,
//         sales: uniqueSales
//       }));
//     } else if (filters.teamLeaders.length === 0 && filters.sales.length > 0) {
//       // إذا لم يعد هناك Team Leaders مختارين، لا نغير الـ sales
//       // (يمكنك تعديل هذا السلوك إذا أردت مسح الـ sales أيضاً)
//     }
//   }, [filters.teamLeaders]);

//   // 🔥 دالة للتعامل مع اختيار/إزالة Team Leader
//   const handleTeamLeaderToggle = (teamLeader) => {
//     const isSelected = filters.teamLeaders.some(tl => getItemId(tl) === getItemId(teamLeader));

//     if (isSelected) {
//       // إزالة Team Leader
//       const newTeamLeaders = filters.teamLeaders.filter(tl => getItemId(tl) !== getItemId(teamLeader));

//       setFilters(prev => ({
//         ...prev,
//         teamLeaders: newTeamLeaders,
//       }));
//     } else {
//       // إضافة Team Leader
//       const newTeamLeaders = [...filters.teamLeaders, teamLeader];

//       setFilters(prev => ({
//         ...prev,
//         teamLeaders: newTeamLeaders,
//       }));
//     }
//   };

//   // دوال التعامل مع الفلاتر
//   const handleFilterChange = (filterType, value) => {
//     setFilters(prev => ({
//       ...prev,
//       [filterType]: value
//     }));
//   };

//   const handleBudgetChange = (value) => {
//     setFilters(prev => ({
//       ...prev,
//       budget: value
//     }));
//   };

//   const handleDateChange = (dateType, value) => {
//     setFilters(prev => ({
//       ...prev,
//       createdAt: {
//         ...prev.createdAt,
//         [dateType]: value ? moment(value).format('YYYY-MM-DD') : null
//       }
//     }));
//   };

//   const handleStageDateChange = (dateType, value) => {
//     setFilters(prev => ({
//       ...prev,
//       stagedateupdated: {
//         ...prev.stagedateupdated,
//         [dateType]: value ? moment(value).format('YYYY-MM-DD') : null
//       }
//     }));
//   };

//   const handleItemToggle = (filterType, item) => {
//     setFilters(prev => {
//       const current = prev[filterType];
//       const isSelected = current.some(i => getItemId(i) === getItemId(item));

//       if (isSelected) {
//         return {
//           ...prev,
//           [filterType]: current.filter(i => getItemId(i) !== getItemId(item))
//         };
//       } else {
//         return {
//           ...prev,
//           [filterType]: [...current, item]
//         };
//       }
//     });
//   };

//   const handleSelectAll = (filterType, options) => {
//     setFilters(prev => {
//       const current = prev[filterType];
//       if (current.length === options.length) {
//         return {
//           ...prev,
//           [filterType]: []
//         };
//       } else {
//         return {
//           ...prev,
//           [filterType]: [...options]
//         };
//       }
//     });
//   };

//   const handleOpenMenu = (menuType) => {
//     const fieldRef = fieldRefs[menuType];
//     if (fieldRef.current) {
//       const rect = fieldRef.current.getBoundingClientRect();
//       setAnchorPosition({
//         top: rect.bottom + window.scrollY,
//         left: rect.left + window.scrollX,
//         width: rect.width
//       });
//       setOpenMenu(menuType);
//       setSearchValue('');
//     }
//   };

//   const handleCloseMenu = () => {
//     setOpenMenu(null);
//     setSearchValue('');
//   };

//   const getDisplayName = (item) => {
//     if (typeof item === 'string') return item;
//     return item?.name || item?.CampainName || item?.title || 'Unknown';
//   };

//   const getItemId = (item) => {
//     return item?._id || item?.id || item?.name || item?.CampainName || JSON.stringify(item);
//   };

//   const handleApplyFilters = () => {
//     const cleanedFilters = {
//       ...filters,
//       stage: filters.stage.filter(item => item),
//       oldstage: filters.oldstage.filter(item => item),
//       sales: filters.sales.filter(item => item),
//       chanel: filters.chanel.filter(item => item),
//       campaign: filters.campaign.filter(item => item),
//       project: filters.project.filter(item => item),
//       developer: filters.developer.filter(item => item),
//       addby: filters.addby.filter(item => item),
//       assignedFrom: filters.assignedFrom.filter(item => item),
//       assignedTo: filters.assignedTo.filter(item => item),
//       teamLeaders: filters.teamLeaders.filter(item => item),
//       budget: filters.budget || '',
//       createdAt: {
//         from: filters.createdAt.from,
//         to: filters.createdAt.to
//       },
//       stagedateupdated: {
//         from: filters.stagedateupdated.from,
//         to: filters.stagedateupdated.to
//       }
//     };

//     console.log("🔍 Applying filters:", cleanedFilters);

//     const queryParams = new URLSearchParams();

//     const multiValueFields = [
//       'stage', 'sales', 'chanel', 'campaign', 'project', 'developer', 'addby'
//     ];

//     multiValueFields.forEach(field => {
//       if (cleanedFilters[field] && cleanedFilters[field].length > 0) {
//         cleanedFilters[field].forEach(item => {
//           const itemId = getItemId(item);
//           if (itemId) {
//             queryParams.append(field, itemId);
//           }
//         });
//       }
//     });

//     if (cleanedFilters.teamLeaders && cleanedFilters.teamLeaders.length > 0) {
//       cleanedFilters.teamLeaders.forEach(item => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('teamLeaders', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.oldstage && cleanedFilters.oldstage.length > 0) {
//       cleanedFilters.oldstage.forEach(item => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('oldstage', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.assignedFrom && cleanedFilters.assignedFrom.length > 0) {
//       cleanedFilters.assignedFrom.forEach(item => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('assignedFrom', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.assignedTo && cleanedFilters.assignedTo.length > 0) {
//       cleanedFilters.assignedTo.forEach(item => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('assignedTo', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.budget) {
//       queryParams.append('budget', cleanedFilters.budget);
//     }

//     if (cleanedFilters.createdAt.from) {
//       queryParams.append('createdFrom', cleanedFilters.createdAt.from);
//     }
//     if (cleanedFilters.createdAt.to) {
//       queryParams.append('createdTo', cleanedFilters.createdAt.to);
//     }

//     if (cleanedFilters.stagedateupdated.from) {
//       queryParams.append('stageDateFrom', cleanedFilters.stagedateupdated.from);
//     }
//     if (cleanedFilters.stagedateupdated.to) {
//       queryParams.append('stageDateTo', cleanedFilters.stagedateupdated.to);
//     }

//     const queryString = queryParams.toString();
//     console.log("🔍 Final Query String:", queryString);

//     onApplyFilters(cleanedFilters, queryString);
//     onClose();
//   };

//   const handleClearFilters = () => {
//     setFilters({
//       budget: '',
//       stage: [],
//       oldstage: [],
//       sales: [],
//       chanel: [],
//       campaign: [],
//       project: [],
//       developer: [],
//       addby: [],
//       assignedFrom: [],
//       assignedTo: [],
//       teamLeaders: [],
//       createdAt: {
//         from: null,
//         to: null
//       },
//       stagedateupdated: {
//         from: null,
//         to: null
//       }
//     });
//     handleCloseMenu();
//   };

//   const MenuComponent = () => {
//     if (!openMenu) return null;

//     let options = [];
//     switch (openMenu) {
//       case 'stage': options = stagesarray; break;
//       case 'oldstage': options = stagesarray; break;
//       case 'sales': options = salesarray; break;
//       case 'chanel': options = channelarray; break;
//       case 'campaign': options = campaignsarray; break;
//       case 'project': options = projectarray; break;
//       case 'developer': options = developersarray; break;
//       case 'addby': options = usersarray; break;
//       case 'assignedFrom': options = usersarray; break;
//       case 'assignedTo': options = salesarray; break;
//       case 'teamLeaders': options = teamLeadersArray; break;
//       default: options = [];
//     }

//     const selectedItems = filters[openMenu] || [];

//     const filteredOptions = options.filter(option =>
//       getDisplayName(option).toLowerCase().includes(searchValue.toLowerCase()) ||
//       selectedItems.some(selected => getItemId(selected) === getItemId(option))
//     );

//     const handleItemClick = (item) => {
//       if (openMenu === 'teamLeaders') {
//         handleTeamLeaderToggle(item);
//       } else {
//         handleItemToggle(openMenu, item);
//       }
//     };

//     return (
//       <ClickAwayListener onClickAway={handleCloseMenu}>
//         <Paper
//           sx={{
//             position: 'fixed',
//             top: anchorPosition.top,
//             left: anchorPosition.left,
//             width: anchorPosition.width || 300,
//             maxHeight: 400,
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
//             border: mode === 'dark' ? '1px solid #444' : '1px solid #ddd',
//             boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
//             borderRadius: '8px',
//             overflow: 'hidden',
//             zIndex: 999999,
//           }}
//         >
//           {openMenu === 'teamLeaders' && (
//             <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}`, backgroundColor: mode === 'dark' ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.05)' }}>
//               <Typography variant="caption" sx={{ fontSize: '0.7rem', color: mode === 'dark' ? '#90caf9' : '#1976d2', display: 'flex', alignItems: 'center', gap: 0.5 }}>
//                 <InfoIcon fontSize="inherit" />
// “All Sales members under this Team Leader will be selected automatically.”
//               </Typography>
//             </Box>
//           )}

//           <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}` }}>
//             <TextField
//               fullWidth
//               size="small"
//               placeholder={`Search...`}
//               value={searchValue}
//               onChange={(e) => setSearchValue(e.target.value)}
//               autoFocus
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon fontSize="small" />
//                   </InputAdornment>
//                 ),
//                 endAdornment: searchValue && (
//                   <InputAdornment position="end">
//                     <IconButton
//                       size="small"
//                       onClick={() => setSearchValue('')}
//                       edge="end"
//                     >
//                       <ClearIcon fontSize="small" />
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//                 sx: {
//                   fontSize: '14px',
//                 }
//               }}
//             />
//           </Box>

//           <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}` }}>
//             <Button
//               onClick={() => handleSelectAll(openMenu, options)}
//               size="small"
//               fullWidth
//               sx={{
//                 textTransform: "none",
//                 fontSize: "0.75rem",
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 justifyContent: 'flex-start',
//                 paddingLeft: 2
//               }}
//             >
//               {selectedItems.length === options.length
//                 ? "Deselect All"
//                 : "Select All"}
//             </Button>
//           </Box>

//           <List
//             sx={{
//               maxHeight: 300,
//               overflow: 'auto',
//               p: 0,
//             }}
//           >
//             {filteredOptions.length > 0 ? (
//               filteredOptions.map((option, index) => {
//                 const isSelected = selectedItems.some(
//                   item => getItemId(item) === getItemId(option)
//                 );

//                 // 🔥 حساب عدد الـ sales تحت Team Leader
//                 let salesCount = 0;
//                 if (openMenu === 'teamLeaders') {
//                   salesCount = getSalesByTeamLeader(getItemId(option)).length;
//                 }

//                 return (
//                   <ListItem
//                     key={getItemId(option) || index}
//                     onClick={() => handleItemClick(option)}
//                     sx={{
//                       py: 1,
//                       px: 2,
//                       cursor: 'pointer',
//                       backgroundColor: isSelected
//                         ? (mode === 'dark' ? 'rgba(25, 118, 210, 0.2)' : 'rgba(25, 118, 210, 0.1)')
//                         : 'transparent',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                       '&:hover': {
//                         backgroundColor: isSelected
//                           ? (mode === 'dark' ? 'rgba(25, 118, 210, 0.3)' : 'rgba(25, 118, 210, 0.15)')
//                           : (mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.04)'),
//                       },
//                     }}
//                   >
//                     <ListItemIcon sx={{ minWidth: 40 }}>
//                       <Checkbox
//                         checked={isSelected}
//                         icon={icon}
//                         checkedIcon={checkedIcon}
//                         sx={{
//                           color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                           '&.Mui-checked': {
//                             color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                           },
//                         }}
//                       />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={getDisplayName(option)}
//                       primaryTypographyProps={{
//                         fontSize: '14px',
//                         fontWeight: isSelected ? '500' : '400',
//                       }}
//                       secondary={openMenu === 'teamLeaders' && salesCount > 0 ? (
//                         <Typography variant="caption" color={mode === 'dark' ? '#4caf50' : '#2e7d32'}>
//                           {salesCount} sales
//                         </Typography>
//                       ) : null}
//                     />
//                   </ListItem>
//                 );
//               })
//             ) : (
//               <ListItem disabled sx={{ justifyContent: 'center', py: 2 }}>
//                 <Typography variant="body2" color="text.secondary">
//                   No options found
//                 </Typography>
//               </ListItem>
//             )}
//           </List>
//         </Paper>
//       </ClickAwayListener>
//     );
//   };

//   const FilterField = ({
//     title,
//     filterType,
//     icon: customIcon,
//     placeholder = `Select ${title}...`,
//   }) => {
//     const selectedItems = filters[filterType] || [];
//     const isOpen = openMenu === filterType;

//     const handleClick = () => {
//       if (isOpen) {
//         handleCloseMenu();
//       } else {
//         handleOpenMenu(filterType);
//       }
//     };

//     const handleRemoveItem = (item, event) => {
//       event.stopPropagation();
//       if (filterType === 'teamLeaders') {
//         handleTeamLeaderToggle(item);
//       } else {
//         handleItemToggle(filterType, item);
//       }
//     };

//     const getSalesCountUnderSelectedTeamLeaders = () => {
//       if (filterType !== 'teamLeaders') return 0;

//       let totalSales = 0;
//       selectedItems.forEach(teamLeader => {
//         const salesUnderTeamLeader = getSalesByTeamLeader(getItemId(teamLeader));
//         totalSales += salesUnderTeamLeader.length;
//       });

//       return totalSales;
//     };

//     return (
//       <Box sx={{ mb: 3 }}>
//         <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, alignItems: "center" }}>
//           <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//             {customIcon && customIcon}
//             <Typography sx={{ fontWeight: 600, color: mode === 'dark' ? '#fff' : '#000' }}>
//               {title}
//             </Typography>
//           </Box>
//           {filterType === 'teamLeaders' && selectedItems.length > 0 && (
//             <Typography variant="caption" sx={{ color: mode === 'dark' ? '#4caf50' : '#2e7d32', fontWeight: '500' }}>
//               {getSalesCountUnderSelectedTeamLeaders()} sales selected
//             </Typography>
//           )}
//         </Box>

//         <Box
//           ref={fieldRefs[filterType]}
//           onClick={handleClick}
//           sx={{
//             border: '1px solid',
//             borderColor: isOpen
//               ? (mode === 'dark' ? '#90caf9' : '#1976d2')
//               : (mode === 'dark' ? '#444' : '#ccc'),
//             borderRadius: '4px',
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
//             minHeight: '40px',
//             padding: '8px 12px',
//             cursor: 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             '&:hover': {
//               borderColor: mode === 'dark' ? '#666' : '#999',
//             },
//             position: 'relative',
//             outline: isOpen ? `2px solid ${mode === 'dark' ? '#90caf9' : '#1976d2'}` : 'none',
//             outlineOffset: '-2px',
//           }}
//         >
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, flex: 1 }}>
//             {selectedItems.length > 0 ? (
//               selectedItems.slice(0, 3).map((item, index) => (
//                 <Chip
//                   key={index}
//                   label={getDisplayName(item)}
//                   size="small"
//                   onDelete={(e) => handleRemoveItem(item, e)}
//                   sx={{
//                     height: 24,
//                     fontSize: '0.7rem',
//                     backgroundColor: mode === 'dark' ? '#1976d2' : '#e3f2fd',
//                     color: mode === 'dark' ? '#fff' : '#1976d2',
//                     '& .MuiChip-deleteIcon': {
//                       fontSize: '1rem',
//                       color: 'inherit',
//                       '&:hover': {
//                         color: mode === 'dark' ? '#bbdefb' : '#bbdefb',
//                       }
//                     }
//                   }}
//                 />
//               ))
//             ) : (
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                   fontStyle: 'italic'
//                 }}
//               >
//                 {placeholder}
//               </Typography>
//             )}
//             {selectedItems.length > 3 && (
//               <Chip
//                 label={`+${selectedItems.length - 3} more`}
//                 size="small"
//                 sx={{
//                   height: 24,
//                   fontSize: '0.7rem',
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
//                 }}
//               />
//             )}
//           </Box>
//           <ArrowDropDownIcon sx={{
//             color: isOpen
//               ? (mode === 'dark' ? '#90caf9' : '#1976d2')
//               : (mode === 'dark' ? '#aaa' : '#666'),
//             ml: 1,
//             transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
//             transition: 'transform 0.2s'
//           }} />
//         </Box>

//         {filterType === 'teamLeaders' && selectedItems.length > 0 && (
//           <Collapse in={showAutoSelectInfo}>
//             <Alert
//               severity="info"
//               icon={<InfoIcon fontSize="small" />}
//               sx={{
//                 mt: 1,
//                 py: 0.5,
//                 '& .MuiAlert-message': {
//                   fontSize: '0.75rem',
//                   padding: '4px 0'
//                 }
//               }}
//               onClose={() => setShowAutoSelectInfo(false)}
//             >
//               تم اختيار {getSalesCountUnderSelectedTeamLeaders()} sales تابعين لـ {selectedItems.length} Team Leader{selectedItems.length > 1 ? 's' : ''} تلقائياً
//             </Alert>
//           </Collapse>
//         )}

//         {selectedItems.length > 0 && (
//           <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//             {selectedItems.map((item, index) => (
//               <Chip
//                 key={index}
//                 label={getDisplayName(item)}
//                 size="small"
//                 onDelete={(e) => handleRemoveItem(item, e)}
//                 sx={{
//                   height: 24,
//                   fontSize: '0.7rem',
//                   backgroundColor: mode === 'dark' ? '#1976d2' : '#e3f2fd',
//                   color: mode === 'dark' ? '#fff' : '#1976d2',
//                   '& .MuiChip-deleteIcon': {
//                     fontSize: '1rem',
//                     color: 'inherit',
//                     '&:hover': {
//                       color: mode === 'dark' ? '#bbdefb' : '#bbdefb',
//                     }
//                   }
//                 }}
//               />
//             ))}
//           </Box>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       maxWidth="md"
//       fullWidth
//       fullScreen={isSmallScreen}
//       style={{zIndex:'50000'}}
//       TransitionComponent={SlideTransition}
//       PaperProps={{
//         sx: {
//           borderRadius: 0,
//           backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//           backgroundImage: 'none',
//           margin: 0,
//           height: '100vh',
//           width: isSmallScreen ? '100vw' : '600px',
//           maxWidth: '600px !important',
//           position: 'fixed',
//           right: 0,
//           top: 0,
//           bottom: 0,
//           overflow: 'hidden',
//           boxShadow: '0 0 20px rgba(0,0,0,0.3)'
//         }
//       }}
//       sx={{
//         '& .MuiBackdrop-root': {
//           backgroundColor: 'rgba(0, 0, 0, 0.5)'
//         },
//         '& .MuiDialog-container': {
//           overflow: 'hidden'
//         }
//       }}
//     >
//       <DialogTitle
//         sx={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//           backgroundColor: mode === 'dark' ? 'primary.dark' : 'primary.main',
//           color: 'white',
//           padding: '16px 24px',
//           position: 'sticky',
//           top: 0,
//           zIndex: 9999,
//           boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//           minHeight: '64px'
//         }}
//       >
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//           <FilterListIcon />
//           <Typography variant="h6" component="span">
//             Quick Filter
//           </Typography>
//         </Box>
//         <IconButton
//           onClick={onClose}
//           sx={{ color: 'white' }}
//           size="small"
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <DialogContent sx={{
//         p: 3,
//         overflow: 'auto',
//         width: '100%',
//         margin: 0,
//         height: 'calc(100vh - 128px)'
//       }}>
//         <LocalizationProvider dateAdapter={AdapterMoment}>
//           <Grid container spacing={3} alignItems="flex-start">
//             <Grid item xs={12}>

//               <Box sx={{ mb: 3, minHeight: '95px', display: 'flex', flexDirection: 'column', marginTop:"40px" }}>
//                 <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: '600', fontSize: '0.95rem', minHeight: '24px', lineHeight: '1.2', color: mode === 'dark' ? '#fff' : '#000' }}>
//                   Budget
//                 </Typography>
//                 <Box sx={{ flex: 1 }}>
//                   <TextField
//                     fullWidth
//                     size="small"
//                     placeholder="Enter budget amount..."
//                     value={filters.budget}
//                     onChange={(e) => handleBudgetChange(e.target.value)}
//                     type="number"
//                     sx={{
//                       width: '100%',
//                       '& .MuiInputBase-root': {
//                         width: '100%',
//                         backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff'
//                       },
//                       '& .MuiOutlinedInput-root': {
//                         '&:hover .MuiOutlinedInput-notchedOutline': {
//                           borderColor: mode === 'dark' ? '#666' : '#1976d2'
//                         }
//                       }
//                     }}
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <Typography variant="body2" color={mode === 'dark' ? '#aaa' : 'text.secondary'}>$</Typography>
//                         </InputAdornment>
//                       ),
//                       endAdornment: filters.budget && (
//                         <InputAdornment position="end">
//                           <IconButton size="small" onClick={() => handleBudgetChange('')}>
//                             <ClearIcon fontSize="small" />
//                           </IconButton>
//                         </InputAdornment>
//                       )
//                     }}
//                   />
//                 </Box>
//                 <Typography variant="caption" color={mode === 'dark' ? '#aaa' : 'text.secondary'} sx={{ mt: 0.5, display: 'block', minHeight: '20px' }}>
//                   Enter the budget amount
//                 </Typography>
//               </Box>

//               {/* 🔥 Team Leaders Filter - حقل جديد */}
//               <FilterField
//                 title="Team Leaders"
//                 filterType="teamLeaders"
//                 icon={<GroupsIcon fontSize="small" sx={{ mr: 0.5, color: mode === 'dark' ? '#4caf50' : '#1976d2' }} />}
//                 placeholder="Select Team Leaders..."
//               />

//               <FilterField title="Stage" filterType="stage" placeholder="Select Stage..." />

//               <FilterField
//                 title="Old Stage"
//                 filterType="oldstage"
//                 icon={<HistoryIcon fontSize="small" sx={{ mr: 0.5, color: mode === 'dark' ? '#ff9800' : '#1976d2' }} />}
//                 placeholder="Select Old Stage..."
//               />

//               <FilterField title="Sales" filterType="sales" placeholder="Select Sales..." />

//               <FilterField title="Channel" filterType="chanel" placeholder="Select Channel..." />

//               <FilterField title="Campaign" filterType="campaign" placeholder="Select Campaign..." />

//               <FilterField title="Project" filterType="project" placeholder="Select Project..." />

//               <FilterField title="Developer" filterType="developer" placeholder="Select Developer..." />

//               <FilterField title="Added By" filterType="addby" placeholder="Select Added By..." />

//               <FilterField
//                 title="Assigned From"
//                 filterType="assignedFrom"
//                 icon={<AssignmentIndIcon fontSize="small" sx={{ mr: 0.5, color: mode === 'dark' ? '#4fc3f7' : '#1976d2' }} />}
//                 placeholder="Select Assigned From..."
//               />

//               <FilterField
//                 title="Assigned To"
//                 filterType="assignedTo"
//                 icon={<AssignmentTurnedInIcon fontSize="small" sx={{ mr: 0.5, color: mode === 'dark' ? '#81c784' : '#1976d2' }} />}
//                 placeholder="Select Assigned To..."
//               />

//               <Box sx={{ mb: 3, p: 2, border: '1px solid', borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)', borderRadius: 1, minHeight: '110px', backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fafafa' }}>
//                 <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: '600', fontSize: '0.95rem', minHeight: '24px', lineHeight: '1.2', color: mode === 'dark' ? '#fff' : '#000' }}>
//                   Creation Date Range
//                 </Typography>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="From Date"
//                       value={filters.createdAt.from ? moment(filters.createdAt.from) : null}
//                       onChange={(date) => handleDateChange('from', date)}
//                       slotProps={{
//                         textField: {
//                           fullWidth: true,
//                           size: 'small',
//                           sx: {
//                             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff'
//                           }
//                         }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="To Date"
//                       value={filters.createdAt.to ? moment(filters.createdAt.to) : null}
//                       onChange={(date) => handleDateChange('to', date)}
//                       slotProps={{
//                         textField: {
//                           fullWidth: true,
//                           size: 'small',
//                           sx: {
//                             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff'
//                           }
//                         }
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Box>

//               <Box sx={{ mb: 3, p: 2, border: '1px solid', borderColor: mode === 'dark' ? 'rgba(255,152,0,0.3)' : 'rgba(255,152,0,0.2)', borderRadius: 1, minHeight: '110px', backgroundColor: mode === 'dark' ? 'rgba(255,152,0,0.05)' : 'rgba(255,152,0,0.05)' }}>
//                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                   <UpdateIcon fontSize="small" color="warning" />
//                   <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: '600', fontSize: '0.95rem', minHeight: '24px', lineHeight: '1.2', color: mode === 'dark' ? '#ff9800' : '#1976d2' }}>
//                     Stage Date Range
//                   </Typography>
//                 </Box>
//                 <Typography variant="caption" color={mode === 'dark' ? '#aaa' : 'text.secondary'} gutterBottom sx={{ display: 'block', mb: 2 }}>
//                   Filter by stage update date (Stage Date Updated)
//                 </Typography>
//                 <Grid container spacing={2}>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="Stage Date From"
//                       value={filters.stagedateupdated.from ? moment(filters.stagedateupdated.from) : null}
//                       onChange={(date) => handleStageDateChange('from', date)}
//                       slotProps={{
//                         textField: {
//                           fullWidth: true,
//                           size: 'small',
//                           sx: {
//                             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//                             '& .MuiInputLabel-root': {
//                               color: mode === 'dark' ? '#ff9800' : '#1976d2'
//                             },
//                             '& .MuiOutlinedInput-root': {
//                               '&:hover .MuiOutlinedInput-notchedOutline': {
//                                 borderColor: mode === 'dark' ? '#ff9800' : '#1976d2'
//                               }
//                             }
//                           }
//                         }
//                       }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <DatePicker
//                       label="Stage Date To"
//                       value={filters.stagedateupdated.to ? moment(filters.stagedateupdated.to) : null}
//                       onChange={(date) => handleStageDateChange('to', date)}
//                       slotProps={{
//                         textField: {
//                           fullWidth: true,
//                           size: 'small',
//                           sx: {
//                             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//                             '& .MuiInputLabel-root': {
//                               color: mode === 'dark' ? '#ff9800' : '#1976d2'
//                             },
//                             '& .MuiOutlinedInput-root': {
//                               '&:hover .MuiOutlinedInput-notchedOutline': {
//                                 borderColor: mode === 'dark' ? '#ff9800' : '#1976d2'
//                               }
//                             }
//                           }
//                         }
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               </Box>
//             </Grid>
//           </Grid>

//           {(filters.budget || Object.values(filters).some(val =>
//             Array.isArray(val) ? val.length > 0 :
//             typeof val === 'object' && val !== null ? (val.from || val.to) :
//             false
//           )) && (
//             <Box sx={{ mt: 3, p: 2, backgroundColor: mode === 'dark' ? 'rgba(25,118,210,0.1)' : 'rgba(25,118,210,0.05)', borderRadius: 2 }}>
//               <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', color: mode === 'dark' ? '#fff' : '#000' }}>
//                 Selected Filters:
//               </Typography>
//               <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                 {filters.budget && (
//                   <Chip
//                     label={`Budget: $${filters.budget}`}
//                     size="small"
//                     color="primary"
//                     variant="outlined"
//                     onDelete={() => handleBudgetChange('')}
//                     deleteIcon={<ClearIcon />}
//                     sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                   />
//                 )}
//                 {filters.teamLeaders.length > 0 && (
//                   <Chip
//                     label={`Team Leaders: ${filters.teamLeaders.length}`}
//                     size="small"
//                     color="success"
//                     variant="outlined"
//                     icon={<GroupsIcon />}
//                     sx={{ color: mode === 'dark' ? '#4caf50' : '#1976d2' }}
//                   />
//                 )}
//                 {filters.stage.length > 0 && <Chip label={`Stage: ${filters.stage.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.oldstage.length > 0 && <Chip label={`Old Stage: ${filters.oldstage.length}`} size="small" color="secondary" variant="outlined" icon={<HistoryIcon />} sx={{ color: mode === 'dark' ? '#ff9800' : '#1976d2' }} />}
//                 {filters.sales.length > 0 && <Chip label={`Sales: ${filters.sales.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.chanel.length > 0 && <Chip label={`Channel: ${filters.chanel.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.campaign.length > 0 && <Chip label={`Campaign: ${filters.campaign.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.project.length > 0 && <Chip label={`Project: ${filters.project.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.developer.length > 0 && <Chip label={`Developer: ${filters.developer.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.addby.length > 0 && <Chip label={`Added By: ${filters.addby.length}`} size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />}
//                 {filters.assignedFrom.length > 0 && <Chip label={`Assigned From: ${filters.assignedFrom.length}`} size="small" color="info" variant="outlined" icon={<AssignmentIndIcon />} sx={{ color: mode === 'dark' ? '#4fc3f7' : '#1976d2' }} />}
//                 {filters.assignedTo.length > 0 && <Chip label={`Assigned To: ${filters.assignedTo.length}`} size="small" color="success" variant="outlined" icon={<AssignmentTurnedInIcon />} sx={{ color: mode === 'dark' ? '#81c784' : '#1976d2' }} />}
//                 {(filters.createdAt.from || filters.createdAt.to) && (
//                   <Chip label="Creation Date Range" size="small" color="primary" variant="outlined" sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }} />
//                 )}
//                 {(filters.stagedateupdated.from || filters.stagedateupdated.to) && (
//                   <Chip label="Stage Date Range" size="small" color="warning" variant="outlined" icon={<UpdateIcon />} sx={{ color: mode === 'dark' ? '#ff9800' : '#1976d2' }} />
//                 )}
//               </Box>
//             </Box>
//           )}
//         </LocalizationProvider>

//         {openMenu && <MenuComponent />}
//       </DialogContent>

//       <DialogActions sx={{ p: 3, gap: 1, borderTop: '1px solid', borderColor: 'divider', position: 'sticky', bottom: 0, backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff' }}>
//         <Button onClick={handleClearFilters} variant="outlined" sx={{ color: mode === 'dark' ? '#ffffff' : '#1976d2', borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)', '&:hover': { borderColor: mode === 'dark' ? '#ffffff' : '#1976d2', } }}>
//           Clear All
//         </Button>
//         <Box sx={{ flex: 1 }} />
//         <Button onClick={onClose} variant="outlined" sx={{ color: mode === 'dark' ? '#ffffff' : '#666', borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)', }}>
//           Cancel
//         </Button>
//         <Button variant="contained" onClick={handleApplyFilters} sx={{ backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#1565c0' } }}>
//           Apply Filters
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default QuickFilterModal;























































// import React, { useState, useEffect, useRef, useMemo } from 'react';
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   Typography,
//   IconButton,
//   useTheme,
//   useMediaQuery,
//   TextField,
//   Grid,
//   InputAdornment,
//   Chip,
//   Checkbox,
//   Slide,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Paper,
//   ClickAwayListener,
//   Alert,
//   Collapse,
//   GlobalStyles,
// } from '@mui/material';
// import CloseIcon from '@mui/icons-material/Close';
// import FilterListIcon from '@mui/icons-material/FilterList';
// import SearchIcon from '@mui/icons-material/Search';
// import ClearIcon from '@mui/icons-material/Clear';
// import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
// import CheckBoxIcon from '@mui/icons-material/CheckBox';
// import HistoryIcon from '@mui/icons-material/History';
// import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
// import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
// import UpdateIcon from '@mui/icons-material/Update';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import GroupsIcon from '@mui/icons-material/Groups';
// import InfoIcon from '@mui/icons-material/Info';
// import { useDispatch, useSelector } from 'react-redux';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
// import moment from 'moment';

// // استيراد الـ actions
// import { GetDevelopersData } from '../Redux/Actions/DevelopersAction';
// import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
// import { GetAllCampainData } from '../Redux/Actions/Campaign_Actions';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// import { GetAllchannalData } from '../Redux/Actions/ChannalActions';
// import { GetallProjectsdata } from '../Redux/Actions/Projects_Action';
// import { GetAll_stage_Data } from '../Redux/Actions/Stage_Action';

// // Transition للـ offcanvas من اليمين
// const SlideTransition = React.forwardRef(function Transition(props, ref) {
//   return <Slide direction="left" ref={ref} {...props} />;
// });

// // أيقونات الـ Checkbox
// const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
// const checkedIcon = <CheckBoxIcon fontSize="small" />;

// // Global styles لضبط z-index للتقويم
// const globalStyles = (
//   <GlobalStyles
//     styles={{
//       '.MuiPickersPopper-root': {
//         zIndex: '999999 !important',
//       },
//       '.MuiPaper-root.MuiPickersPopper-paper': {
//         zIndex: '999999 !important',
//         maxHeight: '400px !important',
//         overflow: 'auto !important',
//       },
//       '.MuiPickersCalendar-root': {
//         maxHeight: '300px !important',
//         minHeight: '280px !important',
//       },
//       '.MuiDayCalendar-monthContainer': {
//         maxHeight: '300px !important',
//         overflow: 'hidden !important',
//       },
//     }}
//   />
// );

// // مكون DatePicker مخصص مع إصلاح مشكلة الظهور
// const CustomDatePicker = ({ label, value, onChange, color = 'primary', ...props }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;

//   const getColor = () => {
//     if (color === 'warning') return mode === 'dark' ? '#ff9800' : '#1976d2';
//     return mode === 'dark' ? '#2196f3' : '#1976d2';
//   };

//   return (
//     <DatePicker
//       label={label}
//       value={value}
//       onChange={onChange}
//       views={['year', 'month', 'day']}
//       slotProps={{
//         textField: {
//           fullWidth: true,
//           size: 'small',
//           sx: {
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//             '& .MuiInputLabel-root': {
//               color: getColor(),
//               '&.Mui-focused': {
//                 color: getColor(),
//               },
//             },
//             '& .MuiOutlinedInput-root': {
//               '&:hover .MuiOutlinedInput-notchedOutline': {
//                 borderColor: getColor(),
//               },
//               '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//                 borderColor: getColor(),
//               },
//             },
//           },
//         },
//         popper: {
//           sx: {
//             zIndex: 999999,
//             '& .MuiPaper-root': {
//               zIndex: '999999 !important',
//               maxHeight: '400px',
//               overflow: 'auto',
//             },
//             '& .MuiPickersCalendar-root': {
//               maxHeight: '300px',
//               minHeight: '280px',
//             },
//             '& .MuiDayCalendar-monthContainer': {
//               maxHeight: '300px',
//               minHeight: '280px',
//             },
//             '& .MuiDayCalendar-weekContainer': {
//               height: '36px',
//             },
//             '& .MuiPickersDay-root': {
//               height: '32px',
//               width: '32px',
//               fontSize: '0.875rem',
//             },
//           },
//           disablePortal: false,
//           placement: 'bottom-start',
//           modifiers: [
//             {
//               name: 'preventOverflow',
//               enabled: true,
//               options: {
//                 boundary: 'viewport',
//                 altBoundary: true,
//                 padding: 8,
//               },
//             },
//             {
//               name: 'flip',
//               enabled: true,
//               options: {
//                 fallbackPlacements: ['bottom-start', 'bottom-end', 'top-start', 'top-end'],
//               },
//             },
//           ],
//         },
//         desktopPaper: {
//           sx: {
//             zIndex: 999999,
//             maxHeight: '400px',
//             overflow: 'auto',
//           },
//         },
//       }}
//       {...props}
//     />
//   );
// };

// const QuickFilterModal = ({ open, onClose, onApplyFilters }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
//   const dispatch = useDispatch();

//   // States للفلاتر
//   const [filters, setFilters] = useState({
//     budget: '',
//     stage: [],
//     oldstage: [],
//     sales: [],
//     chanel: [],
//     campaign: [],
//     project: [],
//     developer: [],
//     addby: [],
//     assignedFrom: [],
//     assignedTo: [],
//     teamLeaders: [], // 🔥 حقل جديد للـ Team Leaders
//     createdAt: {
//       from: null,
//       to: null,
//     },
//     stagedateupdated: {
//       from: null,
//       to: null,
//     },
//   });

//   // State للتحكم في الـ auto select
//   const [showAutoSelectInfo, setShowAutoSelectInfo] = useState(true);

//   // State للقائمة المفتوحة حاليًا
//   const [openMenu, setOpenMenu] = useState(null);
//   const [searchValue, setSearchValue] = useState('');
//   const [anchorPosition, setAnchorPosition] = useState({ top: 0, left: 0, width: 0 });

//   // Refs للحقول
//   const fieldRefs = {
//     stage: useRef(null),
//     oldstage: useRef(null),
//     sales: useRef(null),
//     chanel: useRef(null),
//     campaign: useRef(null),
//     project: useRef(null),
//     developer: useRef(null),
//     addby: useRef(null),
//     assignedFrom: useRef(null),
//     assignedTo: useRef(null),
//     teamLeaders: useRef(null),
//   };

//   // جلب البيانات من Redux
//   const ressales = useSelector((state) => state.AllSales.sales);
//   const reschannel = useSelector((state) => state.AllChannalRoot.channal);
//   const resproject = useSelector((state) => state.AllProjects.Projects);
//   const resstages = useSelector((state) => state.Allstages.stage);
//   const resdevelopers = useSelector((state) => state.AllDevelopers.Developers);
//   const rescampaigns = useSelector((state) => state.AllCampaign.campaign);
//   const resusersAuth = useSelector((state) => state.AuthRoot.Signup);

//   // 🔥 استخراج جميع الـ Team Leaders الفريدة من بيانات الـ sales
//   const teamLeadersArray = useMemo(() => {
//     if (!ressales?.data || !Array.isArray(ressales.data)) return [];

//     const teamLeadersMap = new Map();

//     ressales.data.forEach((sale) => {
//       if (sale?.teamleader && sale.teamleader._id) {
//         // فقط الـ Team Leaders الحقيقيين (الذين لديهم role === 'Team Leader')
//         if (sale.teamleader.role === 'Team Leader') {
//           teamLeadersMap.set(sale.teamleader._id, {
//             _id: sale.teamleader._id,
//             name: sale.teamleader.name,
//             email: sale.teamleader.email,
//             role: sale.teamleader.role,
//             profileImg: sale.teamleader.profileImg,
//           });
//         }
//       }
//     });

//     return Array.from(teamLeadersMap.values())
//       .filter(
//         (leader) =>
//           !['Default', 'Default M', 'Default T', 'Default S', 'Developer', 'Dev'].includes(
//             leader?.name,
//           ),
//       )
//       .sort((a, b) => a?.name?.localeCompare(b?.name));
//   }, [ressales]);

//   // 🔥 دالة للحصول على الـ sales التابعين لـ Team Leader معين
//   const getSalesByTeamLeader = (teamLeaderId) => {
//     if (!teamLeaderId || !ressales?.data || !Array.isArray(ressales.data)) return [];

//     return ressales.data
//       .filter((sale) => {
//         return sale?.teamleader?._id === teamLeaderId;
//       })
//       .filter(
//         (sale) =>
//           !['Default', 'Default M', 'Default T', 'Default S', 'Developer', 'Dev'].includes(
//             sale?.name,
//           ),
//       );
//   };

//   // معالجة البيانات بشكل صحيح
//   const salesarray = useMemo(() => {
//     return (Array.isArray(ressales?.data) ? ressales.data : [])
//       .filter(
//         (sale) =>
//           !['Default', 'Default M', 'Default T', 'Default S', 'Developer', 'Dev'].includes(
//             sale?.name,
//           ),
//       )
//       .sort((a, b) => {
//         if (a?.name === 'No Sales') return -1;
//         if (b?.name === 'No Sales') return 1;
//         return a?.name?.localeCompare(b?.name);
//       });
//   }, [ressales]);

//   const channelarray = Array.isArray(reschannel?.data) ? reschannel.data : [];
//   const projectarray = Array.isArray(resproject?.data) ? resproject.data : [];
//   const stagesarray = Array.isArray(resstages?.data) ? resstages.data : [];
//   const developersarray = Array.isArray(resdevelopers?.data) ? resdevelopers.data : [];
//   const campaignsarray = Array.isArray(rescampaigns?.data) ? rescampaigns.data : [];

//   const usersarray = (Array.isArray(resusersAuth?.data) ? resusersAuth.data : []).filter(
//     (user) =>
//       !['Default', 'Default M', 'Default T', 'Default S', 'Developer', 'Dev'].includes(user?.name),
//   );

//   const getallfiltersarray = async () => {
//     await dispatch(Get_All_Sales_Action());
//     await dispatch(GetAllchannalData());
//     await dispatch(GetallProjectsdata());
//     await dispatch(GetAll_stage_Data());
//     await dispatch(GetDevelopersData());
//     await dispatch(GetAllCampainData());
//   };

//   useEffect(() => {
//     if (open) {
//       getallfiltersarray();
//     }
//   }, [open, dispatch]);

//   // 🔥 useEffect لتفعيل الـ auto select عند اختيار Team Leader
//   useEffect(() => {
//     if (filters.teamLeaders.length > 0) {
//       // جمع جميع الـ sales التابعين لجميع الـ Team Leaders المختارين
//       const allTeamLeaderIds = filters.teamLeaders.map((tl) => getItemId(tl));
//       let allSalesUnderTeamLeaders = [];

//       allTeamLeaderIds.forEach((teamLeaderId) => {
//         const salesUnderTeamLeader = getSalesByTeamLeader(teamLeaderId);
//         allSalesUnderTeamLeaders = [...allSalesUnderTeamLeaders, ...salesUnderTeamLeader];
//       });

//       // إزالة التكرارات
//       const uniqueSales = Array.from(new Set(allSalesUnderTeamLeaders.map((s) => getItemId(s))))
//         .map((id) => allSalesUnderTeamLeaders.find((s) => getItemId(s) === id))
//         .filter((s) => s);

//       // تحديث الـ sales filter
//       setFilters((prev) => ({
//         ...prev,
//         sales: uniqueSales,
//       }));
//     } else if (filters.teamLeaders.length === 0 && filters.sales.length > 0) {
//       // إذا لم يعد هناك Team Leaders مختارين، لا نغير الـ sales
//       // (يمكنك تعديل هذا السلوك إذا أردت مسح الـ sales أيضاً)
//     }
//   }, [filters.teamLeaders]);

//   // 🔥 دالة للتعامل مع اختيار/إزالة Team Leader
//   const handleTeamLeaderToggle = (teamLeader) => {
//     const isSelected = filters.teamLeaders.some((tl) => getItemId(tl) === getItemId(teamLeader));

//     if (isSelected) {
//       // إزالة Team Leader
//       const newTeamLeaders = filters.teamLeaders.filter(
//         (tl) => getItemId(tl) !== getItemId(teamLeader),
//       );

//       setFilters((prev) => ({
//         ...prev,
//         teamLeaders: newTeamLeaders,
//       }));
//     } else {
//       // إضافة Team Leader
//       const newTeamLeaders = [...filters.teamLeaders, teamLeader];

//       setFilters((prev) => ({
//         ...prev,
//         teamLeaders: newTeamLeaders,
//       }));
//     }
//   };

//   // دوال التعامل مع الفلاتر
//   const handleFilterChange = (filterType, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       [filterType]: value,
//     }));
//   };

//   const handleBudgetChange = (value) => {
//     setFilters((prev) => ({
//       ...prev,
//       budget: value,
//     }));
//   };

//   const handleDateChange = (dateType, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       createdAt: {
//         ...prev.createdAt,
//         [dateType]: value ? moment(value).format('YYYY-MM-DD') : null,
//       },
//     }));
//   };

//   const handleStageDateChange = (dateType, value) => {
//     setFilters((prev) => ({
//       ...prev,
//       stagedateupdated: {
//         ...prev.stagedateupdated,
//         [dateType]: value ? moment(value).format('YYYY-MM-DD') : null,
//       },
//     }));
//   };

//   const handleItemToggle = (filterType, item) => {
//     setFilters((prev) => {
//       const current = prev[filterType];
//       const isSelected = current.some((i) => getItemId(i) === getItemId(item));

//       if (isSelected) {
//         return {
//           ...prev,
//           [filterType]: current.filter((i) => getItemId(i) !== getItemId(item)),
//         };
//       } else {
//         return {
//           ...prev,
//           [filterType]: [...current, item],
//         };
//       }
//     });
//   };

//   const handleSelectAll = (filterType, options) => {
//     setFilters((prev) => {
//       const current = prev[filterType];
//       if (current.length === options.length) {
//         return {
//           ...prev,
//           [filterType]: [],
//         };
//       } else {
//         return {
//           ...prev,
//           [filterType]: [...options],
//         };
//       }
//     });
//   };

//   const handleOpenMenu = (menuType) => {
//     const fieldRef = fieldRefs[menuType];
//     if (fieldRef.current) {
//       const rect = fieldRef.current.getBoundingClientRect();
//       setAnchorPosition({
//         top: rect.bottom + window.scrollY,
//         left: rect.left + window.scrollX,
//         width: rect.width,
//       });
//       setOpenMenu(menuType);
//       setSearchValue('');
//     }
//   };

//   const handleCloseMenu = () => {
//     setOpenMenu(null);
//     setSearchValue('');
//   };

//   const getDisplayName = (item) => {
//     if (typeof item === 'string') return item;
//     return item?.name || item?.CampainName || item?.title || 'Unknown';
//   };

//   const getItemId = (item) => {
//     return item?._id || item?.id || item?.name || item?.CampainName || JSON.stringify(item);
//   };

//   const handleApplyFilters = () => {
//     const cleanedFilters = {
//       ...filters,
//       stage: filters.stage.filter((item) => item),
//       oldstage: filters.oldstage.filter((item) => item),
//       sales: filters.sales.filter((item) => item),
//       chanel: filters.chanel.filter((item) => item),
//       campaign: filters.campaign.filter((item) => item),
//       project: filters.project.filter((item) => item),
//       developer: filters.developer.filter((item) => item),
//       addby: filters.addby.filter((item) => item),
//       assignedFrom: filters.assignedFrom.filter((item) => item),
//       assignedTo: filters.assignedTo.filter((item) => item),
//       teamLeaders: filters.teamLeaders.filter((item) => item),
//       budget: filters.budget || '',
//       createdAt: {
//         from: filters.createdAt.from,
//         to: filters.createdAt.to,
//       },
//       stagedateupdated: {
//         from: filters.stagedateupdated.from,
//         to: filters.stagedateupdated.to,
//       },
//     };

//     console.log('🔍 Applying filters:', cleanedFilters);

//     const queryParams = new URLSearchParams();

//     const multiValueFields = [
//       'stage',
//       'sales',
//       'chanel',
//       'campaign',
//       'project',
//       'developer',
//       'addby',
//     ];

//     multiValueFields.forEach((field) => {
//       if (cleanedFilters[field] && cleanedFilters[field].length > 0) {
//         cleanedFilters[field].forEach((item) => {
//           const itemId = getItemId(item);
//           if (itemId) {
//             queryParams.append(field, itemId);
//           }
//         });
//       }
//     });

//     if (cleanedFilters.teamLeaders && cleanedFilters.teamLeaders.length > 0) {
//       cleanedFilters.teamLeaders.forEach((item) => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('teamLeaders', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.oldstage && cleanedFilters.oldstage.length > 0) {
//       cleanedFilters.oldstage.forEach((item) => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('oldstage', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.assignedFrom && cleanedFilters.assignedFrom.length > 0) {
//       cleanedFilters.assignedFrom.forEach((item) => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('assignedFrom', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.assignedTo && cleanedFilters.assignedTo.length > 0) {
//       cleanedFilters.assignedTo.forEach((item) => {
//         const itemId = getItemId(item);
//         if (itemId) {
//           queryParams.append('assignedTo', itemId);
//         }
//       });
//     }

//     if (cleanedFilters.budget) {
//       queryParams.append('budget', cleanedFilters.budget);
//     }

//     if (cleanedFilters.createdAt.from) {
//       queryParams.append('createdFrom', cleanedFilters.createdAt.from);
//     }
//     if (cleanedFilters.createdAt.to) {
//       queryParams.append('createdTo', cleanedFilters.createdAt.to);
//     }

//     if (cleanedFilters.stagedateupdated.from) {
//       queryParams.append('stageDateFrom', cleanedFilters.stagedateupdated.from);
//     }
//     if (cleanedFilters.stagedateupdated.to) {
//       queryParams.append('stageDateTo', cleanedFilters.stagedateupdated.to);
//     }

//     const queryString = queryParams.toString();
//     console.log('🔍 Final Query String:', queryString);

//     onApplyFilters(cleanedFilters, queryString);
//     onClose();
//   };

//   const handleClearFilters = () => {
//     setFilters({
//       budget: '',
//       stage: [],
//       oldstage: [],
//       sales: [],
//       chanel: [],
//       campaign: [],
//       project: [],
//       developer: [],
//       addby: [],
//       assignedFrom: [],
//       assignedTo: [],
//       teamLeaders: [],
//       createdAt: {
//         from: null,
//         to: null,
//       },
//       stagedateupdated: {
//         from: null,
//         to: null,
//       },
//     });
//     handleCloseMenu();
//   };

//   const MenuComponent = () => {
//     if (!openMenu) return null;

//     let options = [];
//     switch (openMenu) {
//       case 'stage':
//         options = stagesarray;
//         break;
//       case 'oldstage':
//         options = stagesarray;
//         break;
//       case 'sales':
//         options = salesarray;
//         break;
//       case 'chanel':
//         options = channelarray;
//         break;
//       case 'campaign':
//         options = campaignsarray;
//         break;
//       case 'project':
//         options = projectarray;
//         break;
//       case 'developer':
//         options = developersarray;
//         break;
//       case 'addby':
//         options = usersarray;
//         break;
//       case 'assignedFrom':
//         options = usersarray;
//         break;
//       case 'assignedTo':
//         options = salesarray;
//         break;
//       case 'teamLeaders':
//         options = teamLeadersArray;
//         break;
//       default:
//         options = [];
//     }

//     const selectedItems = filters[openMenu] || [];

//     const filteredOptions = options.filter(
//       (option) =>
//         getDisplayName(option).toLowerCase().includes(searchValue.toLowerCase()) ||
//         selectedItems.some((selected) => getItemId(selected) === getItemId(option)),
//     );

//     const handleItemClick = (item) => {
//       if (openMenu === 'teamLeaders') {
//         handleTeamLeaderToggle(item);
//       } else {
//         handleItemToggle(openMenu, item);
//       }
//     };

//     return (
//       <ClickAwayListener onClickAway={handleCloseMenu}>
//         <Paper
//           sx={{
//             position: 'fixed',
//             top: anchorPosition.top,
//             left: anchorPosition.left,
//             width: anchorPosition.width || 300,
//             maxHeight: 400,
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
//             border: mode === 'dark' ? '1px solid #444' : '1px solid #ddd',
//             boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
//             borderRadius: '8px',
//             overflow: 'hidden',
//             zIndex: 999998,
//           }}
//         >
//           {openMenu === 'teamLeaders' && (
//             <Box
//               sx={{
//                 p: 1,
//                 borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}`,
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(33, 150, 243, 0.1)' : 'rgba(33, 150, 243, 0.05)',
//               }}
//             >
//               <Typography
//                 variant="caption"
//                 sx={{
//                   fontSize: '0.7rem',
//                   color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                   display: 'flex',
//                   alignItems: 'center',
//                   gap: 0.5,
//                 }}
//               >
//                 <InfoIcon fontSize="inherit" />
//                 “All Sales members under this Team Leader will be selected automatically.”
//               </Typography>
//             </Box>
//           )}

//           <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}` }}>
//             <TextField
//               fullWidth
//               size="small"
//               placeholder={`Search...`}
//               value={searchValue}
//               onChange={(e) => setSearchValue(e.target.value)}
//               autoFocus
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon fontSize="small" />
//                   </InputAdornment>
//                 ),
//                 endAdornment: searchValue && (
//                   <InputAdornment position="end">
//                     <IconButton size="small" onClick={() => setSearchValue('')} edge="end">
//                       <ClearIcon fontSize="small" />
//                     </IconButton>
//                   </InputAdornment>
//                 ),
//                 sx: {
//                   fontSize: '14px',
//                 },
//               }}
//             />
//           </Box>

//           <Box sx={{ p: 1, borderBottom: `1px solid ${mode === 'dark' ? '#444' : '#eee'}` }}>
//             <Button
//               onClick={() => handleSelectAll(openMenu, options)}
//               size="small"
//               fullWidth
//               sx={{
//                 textTransform: 'none',
//                 fontSize: '0.75rem',
//                 color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                 justifyContent: 'flex-start',
//                 paddingLeft: 2,
//               }}
//             >
//               {selectedItems.length === options.length ? 'Deselect All' : 'Select All'}
//             </Button>
//           </Box>

//           <List
//             sx={{
//               maxHeight: 300,
//               overflow: 'auto',
//               p: 0,
//             }}
//           >
//             {filteredOptions.length > 0 ? (
//               filteredOptions.map((option, index) => {
//                 const isSelected = selectedItems.some(
//                   (item) => getItemId(item) === getItemId(option),
//                 );

//                 // 🔥 حساب عدد الـ sales تحت Team Leader
//                 let salesCount = 0;
//                 if (openMenu === 'teamLeaders') {
//                   salesCount = getSalesByTeamLeader(getItemId(option)).length;
//                 }

//                 return (
//                   <ListItem
//                     key={getItemId(option) || index}
//                     onClick={() => handleItemClick(option)}
//                     sx={{
//                       py: 1,
//                       px: 2,
//                       cursor: 'pointer',
//                       backgroundColor: isSelected
//                         ? mode === 'dark'
//                           ? 'rgba(25, 118, 210, 0.2)'
//                           : 'rgba(25, 118, 210, 0.1)'
//                         : 'transparent',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                       '&:hover': {
//                         backgroundColor: isSelected
//                           ? mode === 'dark'
//                             ? 'rgba(25, 118, 210, 0.3)'
//                             : 'rgba(25, 118, 210, 0.15)'
//                           : mode === 'dark'
//                             ? 'rgba(255,255,255,0.1)'
//                             : 'rgba(0,0,0,0.04)',
//                       },
//                     }}
//                   >
//                     <ListItemIcon sx={{ minWidth: 40 }}>
//                       <Checkbox
//                         checked={isSelected}
//                         icon={icon}
//                         checkedIcon={checkedIcon}
//                         sx={{
//                           color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                           '&.Mui-checked': {
//                             color: mode === 'dark' ? '#90caf9' : '#1976d2',
//                           },
//                         }}
//                       />
//                     </ListItemIcon>
//                     <ListItemText
//                       primary={getDisplayName(option)}
//                       primaryTypographyProps={{
//                         fontSize: '14px',
//                         fontWeight: isSelected ? '500' : '400',
//                       }}
//                       secondary={
//                         openMenu === 'teamLeaders' && salesCount > 0 ? (
//                           <Typography
//                             variant="caption"
//                             color={mode === 'dark' ? '#4caf50' : '#2e7d32'}
//                           >
//                             {salesCount} sales
//                           </Typography>
//                         ) : null
//                       }
//                     />
//                   </ListItem>
//                 );
//               })
//             ) : (
//               <ListItem disabled sx={{ justifyContent: 'center', py: 2 }}>
//                 <Typography variant="body2" color="text.secondary">
//                   No options found
//                 </Typography>
//               </ListItem>
//             )}
//           </List>
//         </Paper>
//       </ClickAwayListener>
//     );
//   };

//   const FilterField = ({
//     title,
//     filterType,
//     icon: customIcon,
//     placeholder = `Select ${title}...`,
//   }) => {
//     const selectedItems = filters[filterType] || [];
//     const isOpen = openMenu === filterType;

//     const handleClick = () => {
//       if (isOpen) {
//         handleCloseMenu();
//       } else {
//         handleOpenMenu(filterType);
//       }
//     };

//     const handleRemoveItem = (item, event) => {
//       event.stopPropagation();
//       if (filterType === 'teamLeaders') {
//         handleTeamLeaderToggle(item);
//       } else {
//         handleItemToggle(filterType, item);
//       }
//     };

//     const getSalesCountUnderSelectedTeamLeaders = () => {
//       if (filterType !== 'teamLeaders') return 0;

//       let totalSales = 0;
//       selectedItems.forEach((teamLeader) => {
//         const salesUnderTeamLeader = getSalesByTeamLeader(getItemId(teamLeader));
//         totalSales += salesUnderTeamLeader.length;
//       });

//       return totalSales;
//     };

//     return (
//       <Box sx={{ mb: 3 }}>
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, alignItems: 'center' }}>
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             {customIcon && customIcon}
//             <Typography sx={{ fontWeight: 600, color: mode === 'dark' ? '#fff' : '#000' }}>
//               {title}
//             </Typography>
//           </Box>
//           {filterType === 'teamLeaders' && selectedItems.length > 0 && (
//             <Typography
//               variant="caption"
//               sx={{ color: mode === 'dark' ? '#4caf50' : '#2e7d32', fontWeight: '500' }}
//             >
//               {getSalesCountUnderSelectedTeamLeaders()} sales selected
//             </Typography>
//           )}
//         </Box>

//         <Box
//           ref={fieldRefs[filterType]}
//           onClick={handleClick}
//           sx={{
//             border: '1px solid',
//             borderColor: isOpen
//               ? mode === 'dark'
//                 ? '#90caf9'
//                 : '#1976d2'
//               : mode === 'dark'
//                 ? '#444'
//                 : '#ccc',
//             borderRadius: '4px',
//             backgroundColor: mode === 'dark' ? '#2d2d2d' : '#ffffff',
//             minHeight: '40px',
//             padding: '8px 12px',
//             cursor: 'pointer',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             '&:hover': {
//               borderColor: mode === 'dark' ? '#666' : '#999',
//             },
//             position: 'relative',
//             outline: isOpen ? `2px solid ${mode === 'dark' ? '#90caf9' : '#1976d2'}` : 'none',
//             outlineOffset: '-2px',
//           }}
//         >
//           <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, flex: 1 }}>
//             {selectedItems.length > 0 ? (
//               selectedItems.slice(0, 3).map((item, index) => (
//                 <Chip
//                   key={index}
//                   label={getDisplayName(item)}
//                   size="small"
//                   onDelete={(e) => handleRemoveItem(item, e)}
//                   sx={{
//                     height: 24,
//                     fontSize: '0.7rem',
//                     backgroundColor: mode === 'dark' ? '#1976d2' : '#e3f2fd',
//                     color: mode === 'dark' ? '#fff' : '#1976d2',
//                     '& .MuiChip-deleteIcon': {
//                       fontSize: '1rem',
//                       color: 'inherit',
//                       '&:hover': {
//                         color: mode === 'dark' ? '#bbdefb' : '#bbdefb',
//                       },
//                     },
//                   }}
//                 />
//               ))
//             ) : (
//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.5)',
//                   fontStyle: 'italic',
//                 }}
//               >
//                 {placeholder}
//               </Typography>
//             )}
//             {selectedItems.length > 3 && (
//               <Chip
//                 label={`+${selectedItems.length - 3} more`}
//                 size="small"
//                 sx={{
//                   height: 24,
//                   fontSize: '0.7rem',
//                   backgroundColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                   color: mode === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
//                 }}
//               />
//             )}
//           </Box>
//           <ArrowDropDownIcon
//             sx={{
//               color: isOpen
//                 ? mode === 'dark'
//                   ? '#90caf9'
//                   : '#1976d2'
//                 : mode === 'dark'
//                   ? '#aaa'
//                   : '#666',
//               ml: 1,
//               transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
//               transition: 'transform 0.2s',
//             }}
//           />
//         </Box>

//         {filterType === 'teamLeaders' && selectedItems.length > 0 && (
//           <Collapse in={showAutoSelectInfo}>
//             <Alert
//               severity="info"
//               icon={<InfoIcon fontSize="small" />}
//               sx={{
//                 mt: 1,
//                 py: 0.5,
//                 '& .MuiAlert-message': {
//                   fontSize: '0.75rem',
//                   padding: '4px 0',
//                 },
//               }}
//               onClose={() => setShowAutoSelectInfo(false)}
//             >
//               Choose Done {getSalesCountUnderSelectedTeamLeaders()} sales For {selectedItems.length}{' '}
//               Team Leader{selectedItems.length > 1 ? 's' : ''} تلقائياً
//             </Alert>
//           </Collapse>
//         )}

//         {selectedItems.length > 0 && (
//           <Box sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
//             {selectedItems.map((item, index) => (
//               <Chip
//                 key={index}
//                 label={getDisplayName(item)}
//                 size="small"
//                 onDelete={(e) => handleRemoveItem(item, e)}
//                 sx={{
//                   height: 24,
//                   fontSize: '0.7rem',
//                   backgroundColor: mode === 'dark' ? '#1976d2' : '#e3f2fd',
//                   color: mode === 'dark' ? '#fff' : '#1976d2',
//                   '& .MuiChip-deleteIcon': {
//                     fontSize: '1rem',
//                     color: 'inherit',
//                     '&:hover': {
//                       color: mode === 'dark' ? '#bbdefb' : '#bbdefb',
//                     },
//                   },
//                 }}
//               />
//             ))}
//           </Box>
//         )}
//       </Box>
//     );
//   };

//   return (
//     <>
//       {globalStyles}
//       <Dialog
//         open={open}
//         onClose={onClose}
//         maxWidth="md"
//         fullWidth
//         fullScreen={isSmallScreen}
//         style={{ zIndex: '50000' }}
//         TransitionComponent={SlideTransition}
//         PaperProps={{
//           sx: {
//             borderRadius: 0,
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//             backgroundImage: 'none',
//             margin: 0,
//             height: '100vh',
//             width: isSmallScreen ? '100vw' : '600px',
//             maxWidth: '600px !important',
//             position: 'fixed',
//             right: 0,
//             top: 0,
//             bottom: 0,
//             overflow: 'hidden',
//             boxShadow: '0 0 20px rgba(0,0,0,0.3)',
//           },
//         }}
//         sx={{
//           '& .MuiBackdrop-root': {
//             backgroundColor: 'rgba(0, 0, 0, 0.5)',
//           },
//           '& .MuiDialog-container': {
//             overflow: 'hidden',
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             backgroundColor: mode === 'dark' ? 'primary.dark' : 'primary.main',
//             color: 'white',
//             padding: '16px 24px',
//             position: 'sticky',
//             top: 0,
//             zIndex: 9999,
//             boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//             minHeight: '64px',
//           }}
//         >
//           <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <FilterListIcon />
//             <Typography variant="h6" component="span">
//               Quick Filter
//             </Typography>
//           </Box>
//           <IconButton onClick={onClose} sx={{ color: 'white' }} size="small">
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>

//         <DialogContent
//           sx={{
//             p: 3,
//             overflow: 'auto',
//             width: '100%',
//             margin: 0,
//             height: 'calc(100vh - 128px)',
//           }}
//         >
//           <LocalizationProvider dateAdapter={AdapterMoment}>
//             <Grid container spacing={3} alignItems="flex-start">
//               <Grid item xs={12}>
//                 <Box
//                   sx={{
//                     mb: 3,
//                     minHeight: '95px',
//                     display: 'flex',
//                     flexDirection: 'column',
//                     marginTop: '40px',
//                   }}
//                 >
//                   <Typography
//                     variant="subtitle1"
//                     gutterBottom
//                     sx={{
//                       fontWeight: '600',
//                       fontSize: '0.95rem',
//                       minHeight: '24px',
//                       lineHeight: '1.2',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                     }}
//                   >
//                     Budget
//                   </Typography>
//                   <Box sx={{ flex: 1 }}>
//                     <TextField
//                       fullWidth
//                       size="small"
//                       placeholder="Enter budget amount..."
//                       value={filters.budget}
//                       onChange={(e) => handleBudgetChange(e.target.value)}
//                       type="number"
//                       sx={{
//                         width: '100%',
//                         '& .MuiInputBase-root': {
//                           width: '100%',
//                           backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fff',
//                         },
//                         '& .MuiOutlinedInput-root': {
//                           '&:hover .MuiOutlinedInput-notchedOutline': {
//                             borderColor: mode === 'dark' ? '#666' : '#1976d2',
//                           },
//                         },
//                       }}
//                       InputProps={{
//                         startAdornment: (
//                           <InputAdornment position="start">
//                             <Typography
//                               variant="body2"
//                               color={mode === 'dark' ? '#aaa' : 'text.secondary'}
//                             >
//                               $
//                             </Typography>
//                           </InputAdornment>
//                         ),
//                         endAdornment: filters.budget && (
//                           <InputAdornment position="end">
//                             <IconButton size="small" onClick={() => handleBudgetChange('')}>
//                               <ClearIcon fontSize="small" />
//                             </IconButton>
//                           </InputAdornment>
//                         ),
//                       }}
//                     />
//                   </Box>
//                   <Typography
//                     variant="caption"
//                     color={mode === 'dark' ? '#aaa' : 'text.secondary'}
//                     sx={{ mt: 0.5, display: 'block', minHeight: '20px' }}
//                   >
//                     Enter the budget amount
//                   </Typography>
//                 </Box>

//                 {/* 🔥 Team Leaders Filter - حقل جديد */}
//                 <FilterField
//                   title="Team Leaders"
//                   filterType="teamLeaders"
//                   icon={
//                     <GroupsIcon
//                       fontSize="small"
//                       sx={{ mr: 0.5, color: mode === 'dark' ? '#4caf50' : '#1976d2' }}
//                     />
//                   }
//                   placeholder="Select Team Leaders..."
//                 />

//                 <FilterField title="Stage" filterType="stage" placeholder="Select Stage..." />

//                 <FilterField
//                   title="Old Stage"
//                   filterType="oldstage"
//                   icon={
//                     <HistoryIcon
//                       fontSize="small"
//                       sx={{ mr: 0.5, color: mode === 'dark' ? '#ff9800' : '#1976d2' }}
//                     />
//                   }
//                   placeholder="Select Old Stage..."
//                 />

//                 <FilterField title="Sales" filterType="sales" placeholder="Select Sales..." />

//                 <FilterField title="Channel" filterType="chanel" placeholder="Select Channel..." />

//                 <FilterField
//                   title="Campaign"
//                   filterType="campaign"
//                   placeholder="Select Campaign..."
//                 />

//                 <FilterField title="Project" filterType="project" placeholder="Select Project..." />

//                 <FilterField
//                   title="Developer"
//                   filterType="developer"
//                   placeholder="Select Developer..."
//                 />

//                 <FilterField title="Added By" filterType="addby" placeholder="Select Added By..." />

//                 <FilterField
//                   title="Assigned From"
//                   filterType="assignedFrom"
//                   icon={
//                     <AssignmentIndIcon
//                       fontSize="small"
//                       sx={{ mr: 0.5, color: mode === 'dark' ? '#4fc3f7' : '#1976d2' }}
//                     />
//                   }
//                   placeholder="Select Assigned From..."
//                 />

//                 <FilterField
//                   title="Assigned To"
//                   filterType="assignedTo"
//                   icon={
//                     <AssignmentTurnedInIcon
//                       fontSize="small"
//                       sx={{ mr: 0.5, color: mode === 'dark' ? '#81c784' : '#1976d2' }}
//                     />
//                   }
//                   placeholder="Select Assigned To..."
//                 />

//                 <Box
//                   sx={{
//                     mb: 3,
//                     p: 2,
//                     border: '1px solid',
//                     borderColor: mode === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
//                     borderRadius: 1,
//                     minHeight: '110px',
//                     backgroundColor: mode === 'dark' ? '#2d2d2d' : '#fafafa',
//                   }}
//                 >
//                   <Typography
//                     variant="subtitle1"
//                     gutterBottom
//                     sx={{
//                       fontWeight: '600',
//                       fontSize: '0.95rem',
//                       minHeight: '24px',
//                       lineHeight: '1.2',
//                       color: mode === 'dark' ? '#fff' : '#000',
//                     }}
//                   >
//                     Creation Date Range
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <CustomDatePicker
//                         label="From Date"
//                         value={filters.createdAt.from ? moment(filters.createdAt.from) : null}
//                         onChange={(date) => handleDateChange('from', date)}
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <CustomDatePicker
//                         label="To Date"
//                         value={filters.createdAt.to ? moment(filters.createdAt.to) : null}
//                         onChange={(date) => handleDateChange('to', date)}
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>

//                 <Box
//                   sx={{
//                     mb: 3,
//                     p: 2,
//                     border: '1px solid',
//                     borderColor: mode === 'dark' ? 'rgba(255,152,0,0.3)' : 'rgba(255,152,0,0.2)',
//                     borderRadius: 1,
//                     minHeight: '110px',
//                     backgroundColor:
//                       mode === 'dark' ? 'rgba(255,152,0,0.05)' : 'rgba(255,152,0,0.05)',
//                   }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
//                     <UpdateIcon fontSize="small" color="warning" />
//                     <Typography
//                       variant="subtitle1"
//                       gutterBottom
//                       sx={{
//                         fontWeight: '600',
//                         fontSize: '0.95rem',
//                         minHeight: '24px',
//                         lineHeight: '1.2',
//                         color: mode === 'dark' ? '#ff9800' : '#1976d2',
//                       }}
//                     >
//                       Stage Date Range
//                     </Typography>
//                   </Box>
//                   <Typography
//                     variant="caption"
//                     color={mode === 'dark' ? '#aaa' : 'text.secondary'}
//                     gutterBottom
//                     sx={{ display: 'block', mb: 2 }}
//                   >
//                     Filter by stage update date (Stage Date Updated)
//                   </Typography>
//                   <Grid container spacing={2}>
//                     <Grid item xs={12} sm={6}>
//                       <CustomDatePicker
//                         label="Stage Date From"
//                         value={
//                           filters.stagedateupdated.from
//                             ? moment(filters.stagedateupdated.from)
//                             : null
//                         }
//                         onChange={(date) => handleStageDateChange('from', date)}
//                         color="warning"
//                       />
//                     </Grid>
//                     <Grid item xs={12} sm={6}>
//                       <CustomDatePicker
//                         label="Stage Date To"
//                         value={
//                           filters.stagedateupdated.to ? moment(filters.stagedateupdated.to) : null
//                         }
//                         onChange={(date) => handleStageDateChange('to', date)}
//                         color="warning"
//                       />
//                     </Grid>
//                   </Grid>
//                 </Box>
//               </Grid>
//             </Grid>

//             {(filters.budget ||
//               Object.values(filters).some((val) =>
//                 Array.isArray(val)
//                   ? val.length > 0
//                   : typeof val === 'object' && val !== null
//                     ? val.from || val.to
//                     : false,
//               )) && (
//               <Box
//                 sx={{
//                   mt: 3,
//                   p: 2,
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(25,118,210,0.1)' : 'rgba(25,118,210,0.05)',
//                   borderRadius: 2,
//                 }}
//               >
//                 <Typography
//                   variant="subtitle2"
//                   gutterBottom
//                   sx={{ fontWeight: 'bold', color: mode === 'dark' ? '#fff' : '#000' }}
//                 >
//                   Selected Filters:
//                 </Typography>
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                   {filters.budget && (
//                     <Chip
//                       label={`Budget: $${filters.budget}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       onDelete={() => handleBudgetChange('')}
//                       deleteIcon={<ClearIcon />}
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.teamLeaders.length > 0 && (
//                     <Chip
//                       label={`Team Leaders: ${filters.teamLeaders.length}`}
//                       size="small"
//                       color="success"
//                       variant="outlined"
//                       icon={<GroupsIcon />}
//                       sx={{ color: mode === 'dark' ? '#4caf50' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.stage.length > 0 && (
//                     <Chip
//                       label={`Stage: ${filters.stage.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.oldstage.length > 0 && (
//                     <Chip
//                       label={`Old Stage: ${filters.oldstage.length}`}
//                       size="small"
//                       color="secondary"
//                       variant="outlined"
//                       icon={<HistoryIcon />}
//                       sx={{ color: mode === 'dark' ? '#ff9800' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.sales.length > 0 && (
//                     <Chip
//                       label={`Sales: ${filters.sales.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.chanel.length > 0 && (
//                     <Chip
//                       label={`Channel: ${filters.chanel.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.campaign.length > 0 && (
//                     <Chip
//                       label={`Campaign: ${filters.campaign.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.project.length > 0 && (
//                     <Chip
//                       label={`Project: ${filters.project.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.developer.length > 0 && (
//                     <Chip
//                       label={`Developer: ${filters.developer.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.addby.length > 0 && (
//                     <Chip
//                       label={`Added By: ${filters.addby.length}`}
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.assignedFrom.length > 0 && (
//                     <Chip
//                       label={`Assigned From: ${filters.assignedFrom.length}`}
//                       size="small"
//                       color="info"
//                       variant="outlined"
//                       icon={<AssignmentIndIcon />}
//                       sx={{ color: mode === 'dark' ? '#4fc3f7' : '#1976d2' }}
//                     />
//                   )}
//                   {filters.assignedTo.length > 0 && (
//                     <Chip
//                       label={`Assigned To: ${filters.assignedTo.length}`}
//                       size="small"
//                       color="success"
//                       variant="outlined"
//                       icon={<AssignmentTurnedInIcon />}
//                       sx={{ color: mode === 'dark' ? '#81c784' : '#1976d2' }}
//                     />
//                   )}
//                   {(filters.createdAt.from || filters.createdAt.to) && (
//                     <Chip
//                       label="Creation Date Range"
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                       sx={{ color: mode === 'dark' ? '#90caf9' : '#1976d2' }}
//                     />
//                   )}
//                   {(filters.stagedateupdated.from || filters.stagedateupdated.to) && (
//                     <Chip
//                       label="Stage Date Range"
//                       size="small"
//                       color="warning"
//                       variant="outlined"
//                       icon={<UpdateIcon />}
//                       sx={{ color: mode === 'dark' ? '#ff9800' : '#1976d2' }}
//                     />
//                   )}
//                 </Box>
//               </Box>
//             )}
//           </LocalizationProvider>

//           {openMenu && <MenuComponent />}
//         </DialogContent>

//         <DialogActions
//           sx={{
//             p: 3,
//             gap: 1,
//             borderTop: '1px solid',
//             borderColor: 'divider',
//             position: 'sticky',
//             bottom: 0,
//             backgroundColor: mode === 'dark' ? '#1e1e1e' : '#ffffff',
//           }}
//         >
//           <Button
//             onClick={handleClearFilters}
//             variant="outlined"
//             sx={{
//               color: mode === 'dark' ? '#ffffff' : '#1976d2',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(25,118,210,0.3)',
//               '&:hover': { borderColor: mode === 'dark' ? '#ffffff' : '#1976d2' },
//             }}
//           >
//             Clear All
//           </Button>
//           <Box sx={{ flex: 1 }} />
//           <Button
//             onClick={onClose}
//             variant="outlined"
//             sx={{
//               color: mode === 'dark' ? '#ffffff' : '#666',
//               borderColor: mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
//             }}
//           >
//             Cancel
//           </Button>
//           <Button
//             variant="contained"
//             onClick={handleApplyFilters}
//             sx={{ backgroundColor: '#1976d2', '&:hover': { backgroundColor: '#1565c0' } }}
//           >
//             Apply Filters
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// export default QuickFilterModal;























// 20-5-2026

// import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
// import {
//   Dialog, DialogTitle, DialogContent, DialogActions,
//   Button, Box, Typography, IconButton, useTheme, useMediaQuery,
//   Grid, InputAdornment, Chip, Checkbox, Slide, List, ListItem,
//   ListItemIcon, ListItemText, Paper, ClickAwayListener,
//   GlobalStyles, TextField, Alert, Collapse,
// } from '@mui/material';
// import CloseIcon               from '@mui/icons-material/Close';
// import FilterListIcon          from '@mui/icons-material/FilterList';
// import SearchIcon              from '@mui/icons-material/Search';
// import ClearIcon               from '@mui/icons-material/Clear';
// import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
// import CheckBoxIcon            from '@mui/icons-material/CheckBox';
// import HistoryIcon             from '@mui/icons-material/History';
// import AssignmentIndIcon       from '@mui/icons-material/AssignmentInd';
// import AssignmentTurnedInIcon  from '@mui/icons-material/AssignmentTurnedIn';
// import UpdateIcon              from '@mui/icons-material/Update';
// import GroupsIcon              from '@mui/icons-material/Groups';
// import InfoIcon                from '@mui/icons-material/Info';
// import RestoreIcon             from '@mui/icons-material/Restore';
// import { useDispatch, useSelector } from 'react-redux';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { AdapterMoment }       from '@mui/x-date-pickers/AdapterMoment';
// import { DatePicker }          from '@mui/x-date-pickers/DatePicker';
// import moment                  from 'moment';
// import { useLayoutEffect }     from 'react';
// import { GetDevelopersData }   from '../Redux/Actions/DevelopersAction';
// import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
// import { GetAllCampainData }   from '../Redux/Actions/Campaign_Actions';
// import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
// import { GetAllchannalData }   from '../Redux/Actions/ChannalActions';
// import { GetallProjectsdata }  from '../Redux/Actions/Projects_Action';
// import { GetAll_stage_Data }   from '../Redux/Actions/Stage_Action';

// const SlideTransition = React.forwardRef((props, ref) => (
//   <Slide direction="left" ref={ref} {...props} />
// ));

// const icon        = <CheckBoxOutlineBlankIcon fontSize="small" />;
// const checkedIcon = <CheckBoxIcon fontSize="small" />;

// const EXCLUDE = ['Default','Default M','Default T','Default S','Developer','Dev'];
// const LAST_FILTER_KEY = 'quickFilter_lastUsed'; // ✅ key للـ localStorage

// const stageColors = {
//   'Discovery': '#6366F1', 'Viewing': '#10B981', 'Offer': '#F59E0B',
//   'Urgent': '#EF4444', 'Lost': '#6B7280', 'Closing': '#0D47A1',
// };

// const EMPTY_FILTERS = {
//   budget: '', stage: [], oldstage: [], sales: [], chanel: [], campaign: [],
//   project: [], developer: [], addby: [], assignedFrom: [], assignedTo: [],
//   teamLeaders: [], createdAt: { from: null, to: null }, stagedateupdated: { from: null, to: null },
// };

// /* ══ StableMenu ══════════════════════════════════════════════════════ */
// const StableMenu = ({
//   open, options, selected, searchValue, onSearchChange,
//   onToggle, onSelectAll, onClose, anchorPosition, mode,
//   textSecondary, inputBg, bg, border, accent,
//   getId, getName, showSalesCount = false, getSalesCount = null,
// }) => {
//   const listRef       = useRef(null);
//   const scrollTopRef  = useRef(0);
//   const searchInputRef= useRef(null);
//   const textPrimary   = mode === 'dark' ? '#ffffff' : '#1a1a2e';

//   useLayoutEffect(() => { if (listRef.current) listRef.current.scrollTop = scrollTopRef.current; });
//   const handleScroll = () => { if (listRef.current) scrollTopRef.current = listRef.current.scrollTop; };

//   useEffect(() => {
//     if (open && searchInputRef.current) {
//       setTimeout(() => { const input = searchInputRef.current.querySelector('input'); if (input) input.focus(); }, 50);
//     }
//   }, [open]);

//   const filtered = options.filter(opt =>
//     getName(opt).toLowerCase().includes(searchValue.toLowerCase()) ||
//     selected.some(s => getId(s) === getId(opt))
//   );

//   if (!open) return null;

//   return (
//     <ClickAwayListener onClickAway={onClose}>
//       <Paper sx={{ position:'fixed', top:anchorPosition.top, left:anchorPosition.left, width:anchorPosition.width, maxHeight:360, bgcolor:bg, border:`1px solid ${border}`, borderRadius:'12px', overflow:'hidden', zIndex:999999, boxShadow:'0 10px 25px -5px rgba(0,0,0,0.15)' }}>
//         {showSalesCount && (
//           <Box sx={{ p:1.5, borderBottom:`1px solid ${border}`, backgroundColor: mode==='dark' ? 'rgba(99,102,241,0.1)' : 'rgba(99,102,241,0.05)' }}>
//             <Typography variant="caption" sx={{ fontSize:'0.7rem', color:accent, display:'flex', alignItems:'center', gap:0.5 }}>
//               <InfoIcon fontSize="inherit" />
//               All Sales members under this Team Leader will be selected automatically.
//             </Typography>
//           </Box>
//         )}
//         <Box ref={searchInputRef} sx={{ p:1.5, borderBottom:`1px solid ${border}` }}>
//           <TextField fullWidth size="small" placeholder="Search..." value={searchValue} onChange={e => onSearchChange(e.target.value)} autoFocus
//             InputProps={{ startAdornment:<InputAdornment position="start"><SearchIcon sx={{fontSize:18,color:textSecondary}}/></InputAdornment>, endAdornment: searchValue && <IconButton size="small" onClick={()=>onSearchChange('')}><ClearIcon sx={{fontSize:16}}/></IconButton> }}
//             sx={{ '& .MuiOutlinedInput-root':{ borderRadius:'8px', bgcolor:inputBg, '& input':{ color:textPrimary } } }}
//           />
//         </Box>
//         <Box sx={{ px:1.5, py:1, borderBottom:`1px solid ${border}` }}>
//           <Button size="small" onClick={()=>onSelectAll(options)} sx={{ textTransform:'none', color:accent, fontSize:12, fontWeight:500 }}>
//             {selected.length===options.length ? 'Deselect All' : 'Select All'}
//           </Button>
//         </Box>
//         <List ref={listRef} onScroll={handleScroll} sx={{ maxHeight:260, overflow:'auto', p:0 }}>
//           {filtered.length > 0 ? filtered.map(opt => {
//             const sel = selected.some(s => getId(s)===getId(opt));
//             const salesCount = showSalesCount && getSalesCount ? getSalesCount(getId(opt))?.length||0 : 0;
//             return (
//               <ListItem key={getId(opt)} onClick={()=>onToggle(opt)} sx={{ cursor:'pointer', py:1.5, '&:hover':{ bgcolor: mode==='dark' ? 'rgba(255,255,255,0.05)' : '#f5f5f5' } }}>
//                 <ListItemIcon sx={{minWidth:36}}><Checkbox checked={sel} icon={icon} checkedIcon={checkedIcon} sx={{ p:0, color:textSecondary, '&.Mui-checked':{color:accent} }}/></ListItemIcon>
//                 <ListItemText primary={getName(opt)} primaryTypographyProps={{fontSize:13,fontWeight:sel?500:400,color:textPrimary}}
//                   secondary={showSalesCount && salesCount>0 ? <Typography variant="caption" sx={{color:'#10B981',fontSize:11}}>{salesCount} sales</Typography> : null}
//                 />
//               </ListItem>
//             );
//           }) : (
//             <ListItem disabled sx={{justifyContent:'center',py:3}}>
//               <Typography variant="body2" color={textSecondary}>No options found</Typography>
//             </ListItem>
//           )}
//         </List>
//       </Paper>
//     </ClickAwayListener>
//   );
// };

// /* ══ CustomDatePicker ════════════════════════════════════════════════ */
// const CustomDatePicker = ({ label, value, onChange, color='primary', ...props }) => {
//   const theme = useTheme();
//   const mode  = theme.palette.mode;
//   const getColor = () => color==='warning' ? (mode==='dark' ? '#ff9800' : '#F59E0B') : (mode==='dark' ? '#90caf9' : '#6366F1');

//   return (
//     <DatePicker label={label} value={value} onChange={onChange} views={['year','month','day']}
//       slotProps={{
//         textField: { fullWidth:true, size:'small', sx:{ backgroundColor: mode==='dark' ? '#2a2a42' : '#f9fafb', borderRadius:'10px', '& .MuiInputLabel-root':{ color: mode==='dark' ? '#888888' : '#6b7280', fontSize:'13px', '&.Mui-focused':{color:getColor()} }, '& .MuiOutlinedInput-root':{ borderRadius:'10px', '& fieldset':{borderColor: mode==='dark' ? '#333333' : '#e5e7eb'}, '&:hover fieldset':{borderColor:getColor()}, '&.Mui-focused fieldset':{borderColor:getColor(),borderWidth:'1px'} } } },
//         popper: { sx:{ zIndex:'9999999 !important', '& .MuiPaper-root':{zIndex:'9999999 !important',marginTop:'8px',borderRadius:'12px',boxShadow:'0 25px 50px -12px rgba(0,0,0,0.25)'} }, disablePortal:false, placement:'bottom-start', modifiers:[{name:'preventOverflow',enabled:true,options:{boundary:'viewport',altBoundary:true,padding:8}},{name:'flip',enabled:true,options:{fallbackPlacements:['bottom-start','bottom-end','top-start','top-end']}}] },
//       }}
//       {...props}
//     />
//   );
// };

// /* ══ QuickFilterModal ════════════════════════════════════════════════ */
// const QuickFilterModal = ({ open, onClose, onApplyFilters }) => {
//   const theme        = useTheme();
//   const mode         = theme.palette.mode;
//   const isSmallScreen= useMediaQuery(theme.breakpoints.down('sm'));
//   const dispatch     = useDispatch();

//   const bg          = mode==='dark' ? '#1a1a2e' : '#ffffff';
//   const textPrimary = mode==='dark' ? '#ffffff' : '#1a1a2e';
//   const textSecondary=mode==='dark' ? '#888888' : '#6b7280';
//   const border      = mode==='dark' ? '#333333' : '#e5e7eb';
//   const inputBg     = mode==='dark' ? '#2a2a42' : '#f9fafb';
//   const accent      = '#0D47A1';

//   const [filters, setFilters] = useState(EMPTY_FILTERS);

//   // ✅ Last Filter state
//   const [lastFilter, setLastFilter] = useState(() => {
//     try { const s = localStorage.getItem(LAST_FILTER_KEY); return s ? JSON.parse(s) : null; }
//     catch { return null; }
//   });

//   const [showAutoSelectInfo, setShowAutoSelectInfo] = useState(true);
//   const [openMenu,      setOpenMenu]      = useState(null);
//   const [searchValue,   setSearchValue]   = useState('');
//   const [anchorPosition,setAnchorPosition]= useState({ top:0, left:0, width:0 });

//   const fieldRefs = {
//     stage: useRef(null), oldstage: useRef(null), sales: useRef(null),
//     chanel: useRef(null), campaign: useRef(null), project: useRef(null),
//     developer: useRef(null), addby: useRef(null),
//     assignedFrom: useRef(null), assignedTo: useRef(null), teamLeaders: useRef(null),
//   };

//   const ressales     = useSelector(s => s.AllSales.sales);
//   const reschannel   = useSelector(s => s.AllChannalRoot.channal);
//   const resproject   = useSelector(s => s.AllProjects.Projects);
//   const resstages    = useSelector(s => s.Allstages.stage);
//   const resdevelopers= useSelector(s => s.AllDevelopers.Developers);
//   const rescampaigns = useSelector(s => s.AllCampaign.campaign);
//   const resusersAuth = useSelector(s => s.AuthRoot.Signup);

//   const getId  = useCallback(item => item?._id||item?.id||item?.name||item?.CampainName||JSON.stringify(item), []);
//   const getName= useCallback(item => item?.name||item?.CampainName||item?.title||'Unknown', []);

//   const teamLeadersArray = useMemo(() => {
//     if (!ressales?.data || !Array.isArray(ressales.data)) return [];
//     const map = new Map();
//     ressales.data.forEach(sale => {
//       if (sale?.teamleader?._id && sale.teamleader.role==='Team Leader')
//         map.set(sale.teamleader._id, { _id:sale.teamleader._id, name:sale.teamleader.name, email:sale.teamleader.email, role:sale.teamleader.role, profileImg:sale.teamleader.profileImg });
//     });
//     return Array.from(map.values()).filter(l => !EXCLUDE.includes(l?.name)).sort((a,b) => a?.name?.localeCompare(b?.name));
//   }, [ressales]);

//   const getSalesByTeamLeader = useCallback((teamLeaderId) => {
//     if (!teamLeaderId || !ressales?.data || !Array.isArray(ressales.data)) return [];
//     return ressales.data.filter(s => s?.teamleader?._id===teamLeaderId).filter(s => !EXCLUDE.includes(s?.name));
//   }, [ressales]);

//   const salesarray    = useMemo(() => (Array.isArray(ressales?.data) ? ressales.data : []).filter(s => !EXCLUDE.includes(s?.name)).sort((a,b) => a?.name?.localeCompare(b?.name)), [ressales]);
//   const stagesarray   = Array.isArray(resstages?.data)    ? resstages.data    : [];
//   const channelarray  = Array.isArray(reschannel?.data)   ? reschannel.data   : [];
//   const projectarray  = Array.isArray(resproject?.data)   ? resproject.data   : [];
//   const developersarray= Array.isArray(resdevelopers?.data)? resdevelopers.data: [];
//   const campaignsarray= Array.isArray(rescampaigns?.data) ? rescampaigns.data : [];
//   const usersarray    = (Array.isArray(resusersAuth?.data) ? resusersAuth.data : []).filter(u => !EXCLUDE.includes(u?.name));

//   const uniqueStageNames = useMemo(() => [...new Set(stagesarray.map(s => getName(s)))], [stagesarray, getName]);

//   useEffect(() => {
//     if (open) {
//       dispatch(Get_All_Sales_Action()); dispatch(GetAllchannalData());
//       dispatch(GetallProjectsdata()); dispatch(GetAll_stage_Data());
//       dispatch(GetDevelopersData()); dispatch(GetAllCampainData());
//       dispatch(GetCommunicationwayData());
//     }
//   }, [open, dispatch]);

//   useEffect(() => {
//     if (filters.teamLeaders.length > 0) {
//       let all = [];
//       filters.teamLeaders.forEach(tl => { all = [...all, ...getSalesByTeamLeader(getId(tl))]; });
//       const unique = Array.from(new Set(all.map(s => getId(s)))).map(id => all.find(s => getId(s)===id)).filter(Boolean);
//       setFilters(prev => ({ ...prev, sales: unique }));
//     }
//   }, [filters.teamLeaders, getSalesByTeamLeader, getId]);

//   const getTotalSalesCount = useCallback(() => {
//     let total = 0;
//     filters.teamLeaders.forEach(tl => { total += getSalesByTeamLeader(getId(tl)).length; });
//     return total;
//   }, [filters.teamLeaders, getSalesByTeamLeader, getId]);

//   const handleToggle = useCallback((filterType, item) => {
//     setFilters(prev => ({
//       ...prev,
//       [filterType]: prev[filterType].some(i => getId(i)===getId(item))
//         ? prev[filterType].filter(i => getId(i)!==getId(item))
//         : [...prev[filterType], item],
//     }));
//   }, [getId]);

//   const handleSelectAll = useCallback((filterType, options) => {
//     setFilters(prev => ({ ...prev, [filterType]: prev[filterType].length===options.length ? [] : [...options] }));
//   }, []);

//   const handleOpenMenu = (menuType) => {
//     const ref = fieldRefs[menuType];
//     if (ref?.current) {
//       const rect = ref.current.getBoundingClientRect();
//       setAnchorPosition({ top: rect.bottom+window.scrollY+4, left: rect.left+window.scrollX, width: rect.width });
//       setOpenMenu(menuType); setSearchValue('');
//     }
//   };

//   const handleCloseMenu = () => { setOpenMenu(null); setSearchValue(''); };

//   const handleBudgetChange = (value) => setFilters(prev => ({ ...prev, budget: value }));

//   const handleDateChange = (type, field, value) => {
//     setFilters(prev => ({ ...prev, [type]: { ...prev[type], [field]: value ? moment(value).format('YYYY-MM-DD') : null } }));
//   };

//   // ✅ Restore last filter
//   const handleRestoreLastFilter = () => {
//     if (!lastFilter) return;
//     setFilters(lastFilter);
//   };

//   const handleApply = () => {
//     const cleanedFilters = {
//       ...filters,
//       stage: filters.stage.filter(Boolean), oldstage: filters.oldstage.filter(Boolean),
//       sales: filters.sales.filter(Boolean), chanel: filters.chanel.filter(Boolean),
//       campaign: filters.campaign.filter(Boolean), project: filters.project.filter(Boolean),
//       developer: filters.developer.filter(Boolean), addby: filters.addby.filter(Boolean),
//       assignedFrom: filters.assignedFrom.filter(Boolean), assignedTo: filters.assignedTo.filter(Boolean),
//       teamLeaders: filters.teamLeaders.filter(Boolean),
//     };

//     const q = new URLSearchParams();
//     ['stage','sales','chanel','campaign','project','developer','addby'].forEach(f => {
//       cleanedFilters[f]?.forEach(item => q.append(f, getId(item)));
//     });
//     ['teamLeaders','oldstage','assignedFrom','assignedTo'].forEach(f => {
//       if (cleanedFilters[f]?.length > 0) cleanedFilters[f].forEach(item => q.append(f, getId(item)));
//     });
//     if (cleanedFilters.budget)              q.append('budget',        cleanedFilters.budget);
//     if (cleanedFilters.createdAt.from)      q.append('createdFrom',   cleanedFilters.createdAt.from);
//     if (cleanedFilters.createdAt.to)        q.append('createdTo',     cleanedFilters.createdAt.to);
//     if (cleanedFilters.stagedateupdated.from) q.append('stageDateFrom', cleanedFilters.stagedateupdated.from);
//     if (cleanedFilters.stagedateupdated.to)   q.append('stageDateTo',   cleanedFilters.stagedateupdated.to);

//     // ✅ حفظ الـ filter الحالي كـ last filter
//     try {
//       localStorage.setItem(LAST_FILTER_KEY, JSON.stringify(filters));
//       setLastFilter(filters);
//     } catch(e) { console.error('Failed to save last filter:', e); }

//     onApplyFilters(cleanedFilters, q.toString());
//     handleCloseMenu();
//     onClose();
//   };

//   const handleClear = () => {
//     setFilters(EMPTY_FILTERS);
//     setShowAutoSelectInfo(true);
//     handleCloseMenu();
//   };

//   const getOptions = (menuType) => {
//     switch(menuType) {
//       case 'stage': case 'oldstage': return stagesarray;
//       case 'sales': case 'assignedTo': return salesarray;
//       case 'chanel': return channelarray;
//       case 'campaign': return campaignsarray;
//       case 'project': return projectarray;
//       case 'developer': return developersarray;
//       case 'addby': case 'assignedFrom': return usersarray;
//       case 'teamLeaders': return teamLeadersArray;
//       default: return [];
//     }
//   };

//   const FilterField = ({ title, filterType, icon: Icon, placeholder }) => {
//     const selected = filters[filterType] || [];
//     const isOpen   = openMenu === filterType;
//     const isTeamLeaders = filterType === 'teamLeaders';

//     return (
//       <Box sx={{ mb:2.5 }}>
//         <Typography sx={{ fontSize:12, fontWeight:500, color:textSecondary, mb:1, display:'flex', alignItems:'center', gap:0.5 }}>
//           {Icon && <Icon sx={{ fontSize:14, color:accent }} />}
//           {title}
//           {isTeamLeaders && selected.length > 0 && (
//             <Typography component="span" variant="caption" sx={{ color:'#10B981', ml:1 }}>({getTotalSalesCount()} sales)</Typography>
//           )}
//         </Typography>
//         <Box ref={fieldRefs[filterType]} onClick={() => isOpen ? handleCloseMenu() : handleOpenMenu(filterType)}
//           sx={{ border:`1px solid ${isOpen ? accent : border}`, borderRadius:'10px', bgcolor:inputBg, px:2, py:1.5, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'space-between', transition:'border-color 0.15s', '&:hover':{borderColor:accent} }}>
//           <Box sx={{ display:'flex', flexWrap:'wrap', gap:0.5, flex:1 }}>
//             {selected.length > 0 ? (
//               <>
//                 {selected.slice(0,2).map((item,idx) => (
//                   <Chip key={idx} label={getName(item)} size="small" onDelete={e => { e.stopPropagation(); handleToggle(filterType, item); }}
//                     sx={{ height:24, fontSize:11, borderRadius:'6px', bgcolor:accent, color:'#fff', '& .MuiChip-deleteIcon':{color:'#fff',fontSize:14} }} />
//                 ))}
//                 {selected.length > 2 && <Chip label={`+${selected.length-2}`} size="small" sx={{ height:24, fontSize:11, bgcolor:border, color:textSecondary }} />}
//               </>
//             ) : (
//               <Typography sx={{ fontSize:13, color:textSecondary }}>{placeholder}</Typography>
//             )}
//           </Box>
//           <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ transform: isOpen ? 'rotate(180deg)' : 'none', transition:'transform 0.2s', flexShrink:0, marginLeft:8 }}>
//             <path d="M6 9L12 15L18 9" stroke={textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//           </svg>
//         </Box>
//         {isTeamLeaders && selected.length > 0 && showAutoSelectInfo && (
//           <Collapse in={showAutoSelectInfo}>
//             <Alert severity="info" icon={<InfoIcon fontSize="small"/>} sx={{ mt:1.5, py:0.5, borderRadius:'8px', '& .MuiAlert-message':{fontSize:'0.7rem',padding:'4px 0'} }} onClose={() => setShowAutoSelectInfo(false)}>
//               {getTotalSalesCount()} sales will be auto-selected for {selected.length} Team Leader{selected.length>1?'s':''}
//             </Alert>
//           </Collapse>
//         )}
//       </Box>
//     );
//   };

//   const StageCard = ({ stageName }) => {
//     const stageObj  = stagesarray.find(s => getName(s)===stageName);
//     const isSelected= stageObj && filters.stage.some(s => getId(s)===getId(stageObj));
//     const color     = stageColors[stageName] || accent;
//     return (
//       <Box onClick={() => { if (stageObj) handleToggle('stage', stageObj); }}
//         sx={{ px:2, py:1, borderRadius:'20px', border:`1px solid ${border}`, bgcolor: isSelected ? color : 'transparent', cursor:'pointer', transition:'all 0.15s', textAlign:'center',
//           '&:hover':{ transform:'translateY(-1px)', boxShadow:'0 2px 8px rgba(0,0,0,0.05)', bgcolor: isSelected ? color : mode==='dark' ? 'rgba(255,255,255,0.05)' : '#f5f5f5' } }}>
//         <Typography sx={{ fontSize:12, fontWeight:500, color: isSelected ? '#fff' : textPrimary }}>{stageName}</Typography>
//       </Box>
//     );
//   };

//   const currentOptions  = openMenu ? getOptions(openMenu) : [];
//   const currentSelected = openMenu ? (filters[openMenu] || []) : [];
//   const showSalesCount  = openMenu === 'teamLeaders';

//   const hasFilters = filters.budget || filters.stage.length>0 || filters.oldstage.length>0 ||
//     filters.sales.length>0 || filters.chanel.length>0 || filters.campaign.length>0 ||
//     filters.project.length>0 || filters.developer.length>0 || filters.addby.length>0 ||
//     filters.assignedFrom.length>0 || filters.assignedTo.length>0 || filters.teamLeaders.length>0 ||
//     filters.createdAt.from || filters.createdAt.to || filters.stagedateupdated.from || filters.stagedateupdated.to;

//   return (
//     <>
//       <GlobalStyles styles={{ '.MuiPickersPopper-root':{ zIndex:999999 }, '.MuiPickersPopper-paper':{ zIndex:999999 } }} />

//       <Dialog open={open} onClose={() => { handleCloseMenu(); onClose(); }}
//         fullScreen={isSmallScreen} maxWidth="sm" fullWidth
//         TransitionComponent={SlideTransition} disableEnforceFocus disableAutoFocus
//         PaperProps={{ sx:{ borderRadius: isSmallScreen ? 0 : '20px', bgcolor:bg, margin: isSmallScreen ? 0 : 2, height: isSmallScreen ? '100vh' : 'auto', maxHeight:'90vh', overflow:'hidden', boxShadow:'0 25px 50px -12px rgba(0,0,0,0.25)' } }}
//         sx={{ zIndex:50000 }}
//       >
//         {/* ── Header ── */}
//         <DialogTitle sx={{ px:3, py:2.5, borderBottom:`1px solid ${border}`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
//           <Box sx={{ display:'flex', alignItems:'center', gap:1.5 }}>
//             <FilterListIcon sx={{ color:accent, fontSize:22 }} />
//             <Typography sx={{ fontSize:20, fontWeight:700, color:textPrimary, letterSpacing:'-0.01em' }}>
//               Quick Filter
//             </Typography>
//           </Box>

//           <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
//             {/* ✅ زرار Last Filter */}
//             {lastFilter && (
//               <Button
//                 onClick={handleRestoreLastFilter}
//                 size="small"
//                 startIcon={<RestoreIcon sx={{ fontSize:16 }} />}
//                 sx={{
//                   textTransform:'none', fontSize:12, fontWeight:600,
//                   color: accent,
//                   bgcolor: mode==='dark' ? 'rgba(13,71,161,0.15)' : 'rgba(13,71,161,0.08)',
//                   borderRadius:'8px', px:1.5, py:0.5,
//                   '&:hover':{ bgcolor: mode==='dark' ? 'rgba(13,71,161,0.25)' : 'rgba(13,71,161,0.15)' },
//                 }}
//               >
//                 Last Filter
//               </Button>
//             )}
//             <IconButton onClick={() => { handleCloseMenu(); onClose(); }} size="small">
//               <CloseIcon sx={{ color:textSecondary }} />
//             </IconButton>
//           </Box>
//         </DialogTitle>

//         {/* ── Body ── */}
//         <DialogContent sx={{ p:3, overflow:'auto' }}>
//           <LocalizationProvider dateAdapter={AdapterMoment}>

//             {/* Budget */}
//             <Box sx={{ mb:3 }}>
//               <Typography sx={{ fontSize:12, fontWeight:500, color:textSecondary, mb:1 }}>Budget</Typography>
//               <Box sx={{ border:`1px solid ${border}`, borderRadius:'10px', bgcolor:inputBg, p:'10px 12px' }}>
//                 <Box sx={{ display:'flex', alignItems:'center', gap:0.5 }}>
//                   <Typography sx={{ fontWeight:500, color:textSecondary }}>$</Typography>
//                   <input type="text" placeholder="Enter budget amount..." value={filters.budget} onChange={e => handleBudgetChange(e.target.value)}
//                     style={{ border:'none', background:'transparent', outline:'none', fontSize:14, color:textPrimary, width:'100%', fontFamily:'inherit' }} />
//                   {filters.budget && <ClearIcon sx={{ fontSize:16, color:textSecondary, cursor:'pointer' }} onClick={() => handleBudgetChange('')} />}
//                 </Box>
//               </Box>
//             </Box>

//             <FilterField title="Team Leaders"  filterType="teamLeaders"  icon={GroupsIcon}           placeholder="Select Team Leaders..." />

//             {/* Lead Stage */}
//             <Box sx={{ mb:3 }}>
//               <Typography sx={{ fontSize:12, fontWeight:500, color:textSecondary, mb:1 }}>Lead Stage</Typography>
//               {stagesarray.length > 0 ? (
//                 <Box sx={{ display:'flex', flexWrap:'wrap', gap:1 }}>
//                   {uniqueStageNames.map(s => <StageCard key={s} stageName={s} />)}
//                 </Box>
//               ) : (
//                 <Box sx={{ border:`1px solid ${border}`, borderRadius:'10px', p:2, textAlign:'center', bgcolor:inputBg }}>
//                   <Typography sx={{ fontSize:13, color:textSecondary }}>Loading stages...</Typography>
//                 </Box>
//               )}
//             </Box>

//             <FilterField title="Old Stage"     filterType="oldstage"     icon={HistoryIcon}          placeholder="Select Old Stage..." />
//             <FilterField title="Sales Agents"  filterType="sales"                                    placeholder="Search by name..." />
//             <FilterField title="Channel"       filterType="chanel"                                   placeholder="Select Channel..." />
//             <FilterField title="Campaign"      filterType="campaign"                                  placeholder="Select Campaign..." />
//             <FilterField title="Project"       filterType="project"                                   placeholder="Select Project..." />
//             <FilterField title="Developer"     filterType="developer"                                 placeholder="Select Developer..." />
//             <FilterField title="Added By"      filterType="addby"                                     placeholder="Select Added By..." />
//             <FilterField title="Assigned From" filterType="assignedFrom" icon={AssignmentIndIcon}    placeholder="Select Assigned From..." />
//             <FilterField title="Assigned To"   filterType="assignedTo"   icon={AssignmentTurnedInIcon} placeholder="Select Assigned To..." />

//             {/* Creation Date Range */}
//             <Box sx={{ mb:2.5 }}>
//               <Typography sx={{ fontSize:12, fontWeight:500, color:textSecondary, mb:1 }}>Creation Date Range</Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={6}><CustomDatePicker label="From Date" value={filters.createdAt.from ? moment(filters.createdAt.from) : null} onChange={d => handleDateChange('createdAt','from',d)} /></Grid>
//                 <Grid item xs={6}><CustomDatePicker label="To Date"   value={filters.createdAt.to   ? moment(filters.createdAt.to)   : null} onChange={d => handleDateChange('createdAt','to',d)}   /></Grid>
//               </Grid>
//             </Box>

//             {/* Stage Date Range */}
//             <Box sx={{ mb:2.5 }}>
//               <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:1 }}>
//                 <UpdateIcon sx={{ fontSize:16, color:'#F59E0B' }} />
//                 <Typography sx={{ fontSize:12, fontWeight:500, color:textSecondary }}>Stage Date Range</Typography>
//               </Box>
//               <Typography variant="caption" sx={{ color:textSecondary, fontSize:10, mb:1, display:'block' }}>Filter by stage update date</Typography>
//               <Grid container spacing={2}>
//                 <Grid item xs={6}><CustomDatePicker label="From Date" value={filters.stagedateupdated.from ? moment(filters.stagedateupdated.from) : null} onChange={d => handleDateChange('stagedateupdated','from',d)} color="warning" /></Grid>
//                 <Grid item xs={6}><CustomDatePicker label="To Date"   value={filters.stagedateupdated.to   ? moment(filters.stagedateupdated.to)   : null} onChange={d => handleDateChange('stagedateupdated','to',d)}   color="warning" /></Grid>
//               </Grid>
//             </Box>

//             {/* Selected Summary */}
//             {hasFilters && (
//               <Box sx={{ mt:3, p:2, bgcolor: mode==='dark' ? 'rgba(99,102,241,0.1)' : 'rgba(99,102,241,0.05)', borderRadius:2 }}>
//                 <Typography variant="subtitle2" sx={{ fontWeight:'bold', color:textPrimary, mb:1, fontSize:12 }}>Selected Filters:</Typography>
//                 <Box sx={{ display:'flex', flexWrap:'wrap', gap:1 }}>
//                   {filters.budget && <Chip label={`Budget: $${filters.budget}`} size="small" onDelete={() => handleBudgetChange('')} sx={{ height:24, fontSize:11 }} />}
//                   {filters.teamLeaders.length>0 && <Chip label={`Team Leaders: ${filters.teamLeaders.length}`} size="small" icon={<GroupsIcon/>} sx={{ height:24, fontSize:11 }} />}
//                   {filters.stage.length>0       && <Chip label={`Stage: ${filters.stage.length}`}             size="small" sx={{ height:24, fontSize:11 }} />}
//                   {filters.oldstage.length>0     && <Chip label={`Old Stage: ${filters.oldstage.length}`}      size="small" icon={<HistoryIcon/>} sx={{ height:24, fontSize:11 }} />}
//                   {filters.sales.length>0        && <Chip label={`Sales: ${filters.sales.length}`}             size="small" sx={{ height:24, fontSize:11 }} />}
//                   {filters.chanel.length>0       && <Chip label={`Channel: ${filters.chanel.length}`}          size="small" sx={{ height:24, fontSize:11 }} />}
//                   {filters.campaign.length>0     && <Chip label={`Campaign: ${filters.campaign.length}`}        size="small" sx={{ height:24, fontSize:11 }} />}
//                   {filters.project.length>0      && <Chip label={`Project: ${filters.project.length}`}          size="small" sx={{ height:24, fontSize:11 }} />}
//                   {filters.developer.length>0    && <Chip label={`Developer: ${filters.developer.length}`}      size="small" sx={{ height:24, fontSize:11 }} />}
//                   {filters.addby.length>0        && <Chip label={`Added By: ${filters.addby.length}`}           size="small" sx={{ height:24, fontSize:11 }} />}
//                   {filters.assignedFrom.length>0 && <Chip label={`Assigned From: ${filters.assignedFrom.length}`} size="small" icon={<AssignmentIndIcon/>} sx={{ height:24, fontSize:11 }} />}
//                   {filters.assignedTo.length>0   && <Chip label={`Assigned To: ${filters.assignedTo.length}`}  size="small" icon={<AssignmentTurnedInIcon/>} sx={{ height:24, fontSize:11 }} />}
//                   {(filters.createdAt.from||filters.createdAt.to)           && <Chip label="Creation Date Range" size="small" sx={{ height:24, fontSize:11 }} />}
//                   {(filters.stagedateupdated.from||filters.stagedateupdated.to) && <Chip label="Stage Date Range" size="small" icon={<UpdateIcon/>} sx={{ height:24, fontSize:11 }} />}
//                 </Box>
//               </Box>
//             )}

//           </LocalizationProvider>
//         </DialogContent>

//         {/* ── Footer ── */}
//         <DialogActions sx={{ px:3, py:2.5, borderTop:`1px solid ${border}`, gap:2 }}>
//           <Button onClick={handleClear} sx={{ color:textSecondary, textTransform:'none', fontWeight:500, fontSize:13, '&:hover':{bgcolor:'transparent',color:accent} }}>
//             CLEAR ALL
//           </Button>
//           <Box sx={{ flex:1 }} />
//           <Button onClick={onClose} sx={{ color:textSecondary, textTransform:'none', fontWeight:500, fontSize:13, '&:hover':{bgcolor:'transparent',color:accent} }}>
//             Cancel
//           </Button>
//           <Button onClick={handleApply} variant="contained"
//             sx={{ bgcolor:accent, textTransform:'none', fontWeight:600, px:4, borderRadius:'10px', fontSize:13, boxShadow:'none', '&:hover':{bgcolor:'#0D47A1',boxShadow:'none'} }}>
//             Apply Filters
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <StableMenu
//         open={!!openMenu} options={currentOptions} selected={currentSelected}
//         searchValue={searchValue} onSearchChange={setSearchValue}
//         onToggle={item => handleToggle(openMenu, item)}
//         onSelectAll={opts => handleSelectAll(openMenu, opts)}
//         onClose={handleCloseMenu} anchorPosition={anchorPosition}
//         mode={mode} textSecondary={textSecondary} inputBg={inputBg} bg={bg} border={border} accent={accent}
//         getId={getId} getName={getName}
//         showSalesCount={showSalesCount} getSalesCount={getSalesByTeamLeader}
//       />
//     </>
//   );
// };

// export default QuickFilterModal;





















// after 20-5-2026

import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Box, Typography, IconButton, useTheme, useMediaQuery,
  Grid, InputAdornment, Chip, Checkbox, Slide, List, ListItem,
  ListItemIcon, ListItemText, Paper, ClickAwayListener,
  GlobalStyles, TextField, Alert, Collapse,
} from '@mui/material';
import CloseIcon               from '@mui/icons-material/Close';
import FilterListIcon          from '@mui/icons-material/FilterList';
import SearchIcon              from '@mui/icons-material/Search';
import ClearIcon               from '@mui/icons-material/Clear';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon            from '@mui/icons-material/CheckBox';
import HistoryIcon             from '@mui/icons-material/History';
import AssignmentIndIcon       from '@mui/icons-material/AssignmentInd';
import AssignmentTurnedInIcon  from '@mui/icons-material/AssignmentTurnedIn';
import UpdateIcon              from '@mui/icons-material/Update';
import GroupsIcon              from '@mui/icons-material/Groups';
import InfoIcon                from '@mui/icons-material/Info';
import RestoreIcon             from '@mui/icons-material/Restore';
import SystemUpdateAltIcon     from '@mui/icons-material/SystemUpdateAlt';
import { useDispatch, useSelector } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment }       from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker }          from '@mui/x-date-pickers/DatePicker';
import moment                  from 'moment';
import { useLayoutEffect }     from 'react';
import axios                   from 'axios';
import baseurl, { db_url }              from '../Api/BaseUrl';
import { GetDevelopersData }   from '../Redux/Actions/DevelopersAction';
import { GetCommunicationwayData } from '../Redux/Actions/CommunicationWay_Action';
import { GetAllCampainData }   from '../Redux/Actions/Campaign_Actions';
import { Get_All_Sales_Action } from '../Redux/Actions/SalesAction';
import { GetAllchannalData }   from '../Redux/Actions/ChannalActions';
import { GetallProjectsdata }  from '../Redux/Actions/Projects_Action';
import { GetAll_stage_Data }   from '../Redux/Actions/Stage_Action';

const SlideTransition = React.forwardRef((props, ref) => (
  <Slide direction="left" ref={ref} {...props} />
));

const icon        = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const EXCLUDE = ['Default','Default M','Default T','Default S','Developer','Dev'];
const LAST_FILTER_KEY = 'quickFilter_lastUsed';

const stageColors = {
  'Discovery': '#6366F1', 'Viewing': '#10B981', 'Offer': '#F59E0B',
  'Urgent': '#EF4444', 'Lost': '#6B7280', 'Closing': '#0D47A1',
};

const EMPTY_FILTERS = {
  budget: '', stage: [], oldstage: [], sales: [], chanel: [], campaign: [],
  project: [], developer: [], addby: [], assignedFrom: [], assignedTo: [],
  teamLeaders: [], createdAt: { from: null, to: null }, stagedateupdated: { from: null, to: null },
};

/* ══ StableMenu ══════════════════════════════════════════════════════ */
const StableMenu = ({
  open, options, selected, searchValue, onSearchChange,
  onToggle, onSelectAll, onClose, anchorPosition, mode,
  textSecondary, inputBg, bg, border, accent,
  getId, getName, showSalesCount = false, getSalesCount = null,
}) => {
  const listRef       = useRef(null);
  const scrollTopRef  = useRef(0);
  const searchInputRef= useRef(null);
  const textPrimary   = mode === 'dark' ? '#ffffff' : '#1a1a2e';

  useLayoutEffect(() => { if (listRef.current) listRef.current.scrollTop = scrollTopRef.current; });
  const handleScroll = () => { if (listRef.current) scrollTopRef.current = listRef.current.scrollTop; };

  useEffect(() => {
    if (open && searchInputRef.current) {
      setTimeout(() => { const input = searchInputRef.current.querySelector('input'); if (input) input.focus(); }, 50);
    }
  }, [open]);

  const filtered = options.filter(opt =>
    getName(opt).toLowerCase().includes(searchValue.toLowerCase()) ||
    selected.some(s => getId(s) === getId(opt))
  );

  if (!open) return null;

  return (
    <ClickAwayListener onClickAway={onClose}>
      <Paper sx={{ position:'fixed', top:anchorPosition.top, left:anchorPosition.left, width:anchorPosition.width, maxHeight:360, bgcolor:bg, border:`1px solid ${border}`, borderRadius:'12px', overflow:'hidden', zIndex:999999, boxShadow:'0 10px 25px -5px rgba(0,0,0,0.15)' }}>
        {showSalesCount && (
          <Box sx={{ p:1.5, borderBottom:`1px solid ${border}`, backgroundColor: mode==='dark' ? 'rgba(99,102,241,0.1)' : 'rgba(99,102,241,0.05)' }}>
            <Typography variant="caption" sx={{ fontSize:'0.7rem', color:accent, display:'flex', alignItems:'center', gap:0.5 }}>
              <InfoIcon fontSize="inherit" />
              All Sales members under this Team Leader will be selected automatically.
            </Typography>
          </Box>
        )}
        <Box ref={searchInputRef} sx={{ p:1.5, borderBottom:`1px solid ${border}` }}>
          <TextField fullWidth size="small" placeholder="Search..." value={searchValue} onChange={e => onSearchChange(e.target.value)} autoFocus
            InputProps={{ startAdornment:<InputAdornment position="start"><SearchIcon sx={{fontSize:18,color:textSecondary}}/></InputAdornment>, endAdornment: searchValue && <IconButton size="small" onClick={()=>onSearchChange('')}><ClearIcon sx={{fontSize:16}}/></IconButton> }}
            sx={{ '& .MuiOutlinedInput-root':{ borderRadius:'8px', bgcolor:inputBg, '& input':{ color:textPrimary } } }}
          />
        </Box>
        <Box sx={{ px:1.5, py:1, borderBottom:`1px solid ${border}` }}>
          <Button size="small" onClick={()=>onSelectAll(options)} sx={{ textTransform:'none', color:accent, fontSize:12, fontWeight:500 }}>
            {selected.length===options.length ? 'Deselect All' : 'Select All'}
          </Button>
        </Box>
        <List ref={listRef} onScroll={handleScroll} sx={{ maxHeight:260, overflow:'auto', p:0 }}>
          {filtered.length > 0 ? filtered.map(opt => {
            const sel = selected.some(s => getId(s)===getId(opt));
            const salesCount = showSalesCount && getSalesCount ? getSalesCount(getId(opt))?.length||0 : 0;
            return (
              <ListItem key={getId(opt)} onClick={()=>onToggle(opt)} sx={{ cursor:'pointer', py:1.5, '&:hover':{ bgcolor: mode==='dark' ? 'rgba(255,255,255,0.05)' : '#f5f5f5' } }}>
                <ListItemIcon sx={{minWidth:36}}><Checkbox checked={sel} icon={icon} checkedIcon={checkedIcon} sx={{ p:0, color:textSecondary, '&.Mui-checked':{color:accent} }}/></ListItemIcon>
                <ListItemText primary={getName(opt)} primaryTypographyProps={{fontSize:13,fontWeight:sel?500:400,color:textPrimary}}
                  secondary={showSalesCount && salesCount>0 ? <Typography variant="caption" sx={{color:'#10B981',fontSize:11}}>{salesCount} sales</Typography> : null}
                />
              </ListItem>
            );
          }) : (
            <ListItem disabled sx={{justifyContent:'center',py:3}}>
              <Typography variant="body2" color={textSecondary}>No options found</Typography>
            </ListItem>
          )}
        </List>
      </Paper>
    </ClickAwayListener>
  );
};

/* ══ CustomDatePicker ════════════════════════════════════════════════ */
const CustomDatePicker = ({ label, value, onChange, color='primary', ...props }) => {
  const theme = useTheme();
  const mode  = theme.palette.mode;
  const getColor = () => color==='warning' ? (mode==='dark' ? '#ff9800' : '#F59E0B') : (mode==='dark' ? '#90caf9' : '#6366F1');

  return (
    <DatePicker label={label} value={value} onChange={onChange} views={['year','month','day']}
      slotProps={{
        textField: { fullWidth:true, size:'small', sx:{ backgroundColor: mode==='dark' ? '#2a2a42' : '#f9fafb', borderRadius:'10px', '& .MuiInputLabel-root':{ color: mode==='dark' ? '#888888' : '#6b7280', fontSize:'13px', '&.Mui-focused':{color:getColor()} }, '& .MuiOutlinedInput-root':{ borderRadius:'10px', '& fieldset':{borderColor: mode==='dark' ? '#333333' : '#e5e7eb'}, '&:hover fieldset':{borderColor:getColor()}, '&.Mui-focused fieldset':{borderColor:getColor(),borderWidth:'1px'} } } },
        popper: { sx:{ zIndex:'9999999 !important', '& .MuiPaper-root':{zIndex:'9999999 !important',marginTop:'8px',borderRadius:'12px',boxShadow:'0 25px 50px -12px rgba(0,0,0,0.25)'} }, disablePortal:false, placement:'bottom-start', modifiers:[{name:'preventOverflow',enabled:true,options:{boundary:'viewport',altBoundary:true,padding:8}},{name:'flip',enabled:true,options:{fallbackPlacements:['bottom-start','bottom-end','top-start','top-end']}}] },
      }}
      {...props}
    />
  );
};

/* ══ QuickFilterModal ════════════════════════════════════════════════ */
const QuickFilterModal = ({ open, onClose, onApplyFilters,pageType = 'original'  }) => {
  const theme        = useTheme();
  const mode         = theme.palette.mode;
  const isSmallScreen= useMediaQuery(theme.breakpoints.down('sm'));
  const dispatch     = useDispatch();

  const bg           = mode==='dark' ? '#1a1a2e' : '#ffffff';
  const textPrimary  = mode==='dark' ? '#ffffff' : '#1a1a2e';
  const textSecondary= mode==='dark' ? '#888888' : '#6b7280';
  const border       = mode==='dark' ? '#333333' : '#e5e7eb';
  const inputBg      = mode==='dark' ? '#2a2a42' : '#f9fafb';
  const accent       = '#0D47A1';

  const [filters, setFilters] = useState(EMPTY_FILTERS);

  const [lastFilter, setLastFilter] = useState(() => {
    try { const s = localStorage.getItem(LAST_FILTER_KEY); return s ? JSON.parse(s) : null; }
    catch { return null; }
  });

  const [showAutoSelectInfo, setShowAutoSelectInfo] = useState(true);
  const [openMenu,       setOpenMenu]       = useState(null);
  const [searchValue,    setSearchValue]    = useState('');
  const [anchorPosition, setAnchorPosition] = useState({ top:0, left:0, width:0 });

  const fieldRefs = {
    stage: useRef(null), oldstage: useRef(null), sales: useRef(null),
    chanel: useRef(null), campaign: useRef(null), project: useRef(null),
    developer: useRef(null), addby: useRef(null),
    assignedFrom: useRef(null), assignedTo: useRef(null), teamLeaders: useRef(null),
  };

  const ressales      = useSelector(s => s.AllSales.sales);
  const reschannel    = useSelector(s => s.AllChannalRoot.channal);
  const resproject    = useSelector(s => s.AllProjects.Projects);
  const resstages     = useSelector(s => s.Allstages.stage);
  const resdevelopers = useSelector(s => s.AllDevelopers.Developers);
  const rescampaigns  = useSelector(s => s.AllCampaign.campaign);
  const resusersAuth  = useSelector(s => s.AuthRoot.Signup);

  const getId   = useCallback(item => item?._id||item?.id||item?.name||item?.CampainName||JSON.stringify(item), []);
  const getName = useCallback(item => item?.name||item?.CampainName||item?.title||'Unknown', []);

  const teamLeadersArray = useMemo(() => {
    if (!ressales?.data || !Array.isArray(ressales.data)) return [];
    const map = new Map();
    ressales.data.forEach(sale => {
      if (sale?.teamleader?._id && sale.teamleader.role==='Team Leader')
        map.set(sale.teamleader._id, { _id:sale.teamleader._id, name:sale.teamleader.name, email:sale.teamleader.email, role:sale.teamleader.role, profileImg:sale.teamleader.profileImg });
    });
    return Array.from(map.values()).filter(l => !EXCLUDE.includes(l?.name)).sort((a,b) => a?.name?.localeCompare(b?.name));
  }, [ressales]);

  const getSalesByTeamLeader = useCallback((teamLeaderId) => {
    if (!teamLeaderId || !ressales?.data || !Array.isArray(ressales.data)) return [];
    return ressales.data.filter(s => s?.teamleader?._id===teamLeaderId).filter(s => !EXCLUDE.includes(s?.name));
  }, [ressales]);

  const salesarray     = useMemo(() => (Array.isArray(ressales?.data) ? ressales.data : []).filter(s => !EXCLUDE.includes(s?.name)).sort((a,b) => a?.name?.localeCompare(b?.name)), [ressales]);
  const stagesarray    = Array.isArray(resstages?.data)     ? resstages.data     : [];
  const channelarray   = Array.isArray(reschannel?.data)    ? reschannel.data    : [];
  const projectarray   = Array.isArray(resproject?.data)    ? resproject.data    : [];
  const developersarray= Array.isArray(resdevelopers?.data) ? resdevelopers.data : [];
  const campaignsarray = Array.isArray(rescampaigns?.data)  ? rescampaigns.data  : [];
  const usersarray     = (Array.isArray(resusersAuth?.data) ? resusersAuth.data : []).filter(u => !EXCLUDE.includes(u?.name));

  const uniqueStageNames = useMemo(() => [...new Set(stagesarray.map(s => getName(s)))], [stagesarray, getName]);

  useEffect(() => {
    if (open) {
      dispatch(Get_All_Sales_Action()); dispatch(GetAllchannalData());
      dispatch(GetallProjectsdata()); dispatch(GetAll_stage_Data());
      dispatch(GetDevelopersData()); dispatch(GetAllCampainData());
      dispatch(GetCommunicationwayData());
    }
  }, [open, dispatch]);

  useEffect(() => {
    if (filters.teamLeaders.length > 0) {
      let all = [];
      filters.teamLeaders.forEach(tl => { all = [...all, ...getSalesByTeamLeader(getId(tl))]; });
      const unique = Array.from(new Set(all.map(s => getId(s)))).map(id => all.find(s => getId(s)===id)).filter(Boolean);
      setFilters(prev => ({ ...prev, sales: unique }));
    }
  }, [filters.teamLeaders, getSalesByTeamLeader, getId]);

  const getTotalSalesCount = useCallback(() => {
    let total = 0;
    filters.teamLeaders.forEach(tl => { total += getSalesByTeamLeader(getId(tl)).length; });
    return total;
  }, [filters.teamLeaders, getSalesByTeamLeader, getId]);

  const handleToggle = useCallback((filterType, item) => {
    setFilters(prev => ({
      ...prev,
      [filterType]: prev[filterType].some(i => getId(i)===getId(item))
        ? prev[filterType].filter(i => getId(i)!==getId(item))
        : [...prev[filterType], item],
    }));
  }, [getId]);

  const handleSelectAll = useCallback((filterType, options) => {
    setFilters(prev => ({ ...prev, [filterType]: prev[filterType].length===options.length ? [] : [...options] }));
  }, []);

  const handleOpenMenu = (menuType) => {
    const ref = fieldRefs[menuType];
    if (ref?.current) {
      const rect = ref.current.getBoundingClientRect();
      setAnchorPosition({ top: rect.bottom+window.scrollY+4, left: rect.left+window.scrollX, width: rect.width });
      setOpenMenu(menuType); setSearchValue('');
    }
  };

  const handleCloseMenu = () => { setOpenMenu(null); setSearchValue(''); };

  const handleBudgetChange = (value) => setFilters(prev => ({ ...prev, budget: value }));

  const handleDateChange = (type, field, value) => {
    setFilters(prev => ({ ...prev, [type]: { ...prev[type], [field]: value ? moment(value).format('YYYY-MM-DD') : null } }));
  };

  const handleRestoreLastFilter = () => { if (!lastFilter) return; setFilters(lastFilter); };

  const handleApply = () => {
    const cleanedFilters = {
      ...filters,
      stage: filters.stage.filter(Boolean), oldstage: filters.oldstage.filter(Boolean),
      sales: filters.sales.filter(Boolean), chanel: filters.chanel.filter(Boolean),
      campaign: filters.campaign.filter(Boolean), project: filters.project.filter(Boolean),
      developer: filters.developer.filter(Boolean), addby: filters.addby.filter(Boolean),
      assignedFrom: filters.assignedFrom.filter(Boolean), assignedTo: filters.assignedTo.filter(Boolean),
      teamLeaders: filters.teamLeaders.filter(Boolean),
    };

    const q = new URLSearchParams();
    ['stage','sales','chanel','campaign','project','developer','addby'].forEach(f => {
      cleanedFilters[f]?.forEach(item => q.append(f, getId(item)));
    });
    ['teamLeaders','oldstage','assignedFrom','assignedTo'].forEach(f => {
      if (cleanedFilters[f]?.length > 0) cleanedFilters[f].forEach(item => q.append(f, getId(item)));
    });
    if (cleanedFilters.budget)                q.append('budget',        cleanedFilters.budget);
    if (cleanedFilters.createdAt.from)        q.append('createdFrom',   cleanedFilters.createdAt.from);
    if (cleanedFilters.createdAt.to)          q.append('createdTo',     cleanedFilters.createdAt.to);
    if (cleanedFilters.stagedateupdated.from) q.append('stageDateFrom', cleanedFilters.stagedateupdated.from);
    if (cleanedFilters.stagedateupdated.to)   q.append('stageDateTo',   cleanedFilters.stagedateupdated.to);

    try {
      localStorage.setItem(LAST_FILTER_KEY, JSON.stringify(filters));
      setLastFilter(filters);
    } catch(e) { console.error('Failed to save last filter:', e); }

    onApplyFilters(cleanedFilters, q.toString());
    handleCloseMenu();
    onClose();
  };

  const handleClear = () => {
    setFilters(EMPTY_FILTERS);
    setShowAutoSelectInfo(true);
    handleCloseMenu();
  };

  // ✅ دالة Export الجديدة
// const handleExport = async () => {
//   const params = new URLSearchParams();
//   params.set('leadisactive', 'true');
//   params.set('data', 'false');
//   params.set('transferefromdata', 'true');

//   ['stage','sales','chanel','campaign','project','developer','addby'].forEach(f => {
//     filters[f]?.forEach(item => params.append(f, getId(item)));
//   });
//   ['oldstage','assignedFrom','assignedTo'].forEach(f => {
//     filters[f]?.forEach(item => params.append(f, getId(item)));
//   });
//   if (filters.budget)                params.append('budget',        filters.budget);
//   if (filters.createdAt.from)        params.append('createdFrom',   filters.createdAt.from);
//   if (filters.createdAt.to)          params.append('createdTo',     filters.createdAt.to);
//   if (filters.stagedateupdated.from) params.append('stageDateFrom', filters.stagedateupdated.from);
//   if (filters.stagedateupdated.to)   params.append('stageDateTo',   filters.stagedateupdated.to);

//   try {
//     const response = await baseurl.get(      // ✅ baseurl مش axios
//       `${db_url}api/v1/users/leads/export?${params.toString()}`,
//       { responseType: 'blob' }              // ✅ مش محتاج headers يدوي
//     );

//     const url  = window.URL.createObjectURL(new Blob([response.data]));
//     const link = document.createElement('a');
//     link.href  = url;
//     link.setAttribute('download', `Leads_${moment().format('YYYY-MM-DD')}.xlsx`);
//     document.body.appendChild(link);
//     link.click();
//     link.remove();
//     window.URL.revokeObjectURL(url);

//   } catch (err) {
//     console.error('Export failed:', err);
//   }
// };




  const handleExport = async () => {
    const params = new URLSearchParams();
    params.set('leadisactive', 'true');

    // ✅ حسب الصفحة
    if (pageType === 'crm') {
      params.set('data', 'false');
      params.set('transferefromdata', 'false');  // Data Center
    } else {
      params.set('data', 'false');
      params.set('transferefromdata', 'true');   // Original Leads
    }

    ['stage','sales','chanel','campaign','project','developer','addby'].forEach(f => {
      filters[f]?.forEach(item => params.append(f, getId(item)));
    });
    ['oldstage','assignedFrom','assignedTo'].forEach(f => {
      filters[f]?.forEach(item => params.append(f, getId(item)));
    });
    if (filters.budget)                params.append('budget',        filters.budget);
    if (filters.createdAt.from)        params.append('createdFrom',   filters.createdAt.from);
    if (filters.createdAt.to)          params.append('createdTo',     filters.createdAt.to);
    if (filters.stagedateupdated.from) params.append('stageDateFrom', filters.stagedateupdated.from);
    if (filters.stagedateupdated.to)   params.append('stageDateTo',   filters.stagedateupdated.to);

    try {
      const response = await baseurl.get(
      `${db_url}api/v1/users/leads/export?${params.toString()}`,
        { responseType: 'blob' }
      );
      const url  = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href  = url;
      link.setAttribute('download', `Leads_${moment().format('YYYY-MM-DD')}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Export failed:', err);
    }
  };

  const getOptions = (menuType) => {
    switch(menuType) {
      case 'stage': case 'oldstage': return stagesarray;
      case 'sales': case 'assignedTo': return salesarray;
      case 'chanel': return channelarray;
      case 'campaign': return campaignsarray;
      case 'project': return projectarray;
      case 'developer': return developersarray;
      case 'addby': case 'assignedFrom': return usersarray;
      case 'teamLeaders': return teamLeadersArray;
      default: return [];
    }
  };

  const FilterField = ({ title, filterType, icon: Icon, placeholder }) => {
    const selected = filters[filterType] || [];
    const isOpen   = openMenu === filterType;
    const isTeamLeaders = filterType === 'teamLeaders';

    return (
      <Box sx={{ mb:2.5 }}>
        <Typography sx={{ fontSize:12, fontWeight:500, color:textSecondary, mb:1, display:'flex', alignItems:'center', gap:0.5 }}>
          {Icon && <Icon sx={{ fontSize:14, color:accent }} />}
          {title}
          {isTeamLeaders && selected.length > 0 && (
            <Typography component="span" variant="caption" sx={{ color:'#10B981', ml:1 }}>({getTotalSalesCount()} sales)</Typography>
          )}
        </Typography>
        <Box ref={fieldRefs[filterType]} onClick={() => isOpen ? handleCloseMenu() : handleOpenMenu(filterType)}
          sx={{ border:`1px solid ${isOpen ? accent : border}`, borderRadius:'10px', bgcolor:inputBg, px:2, py:1.5, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'space-between', transition:'border-color 0.15s', '&:hover':{borderColor:accent} }}>
          <Box sx={{ display:'flex', flexWrap:'wrap', gap:0.5, flex:1 }}>
            {selected.length > 0 ? (
              <>
                {selected.slice(0,2).map((item,idx) => (
                  <Chip key={idx} label={getName(item)} size="small" onDelete={e => { e.stopPropagation(); handleToggle(filterType, item); }}
                    sx={{ height:24, fontSize:11, borderRadius:'6px', bgcolor:accent, color:'#fff', '& .MuiChip-deleteIcon':{color:'#fff',fontSize:14} }} />
                ))}
                {selected.length > 2 && <Chip label={`+${selected.length-2}`} size="small" sx={{ height:24, fontSize:11, bgcolor:border, color:textSecondary }} />}
              </>
            ) : (
              <Typography sx={{ fontSize:13, color:textSecondary }}>{placeholder}</Typography>
            )}
          </Box>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ transform: isOpen ? 'rotate(180deg)' : 'none', transition:'transform 0.2s', flexShrink:0, marginLeft:8 }}>
            <path d="M6 9L12 15L18 9" stroke={textSecondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </Box>
        {isTeamLeaders && selected.length > 0 && showAutoSelectInfo && (
          <Collapse in={showAutoSelectInfo}>
            <Alert severity="info" icon={<InfoIcon fontSize="small"/>} sx={{ mt:1.5, py:0.5, borderRadius:'8px', '& .MuiAlert-message':{fontSize:'0.7rem',padding:'4px 0'} }} onClose={() => setShowAutoSelectInfo(false)}>
              {getTotalSalesCount()} sales will be auto-selected for {selected.length} Team Leader{selected.length>1?'s':''}
            </Alert>
          </Collapse>
        )}
      </Box>
    );
  };

  const StageCard = ({ stageName }) => {
    const stageObj  = stagesarray.find(s => getName(s)===stageName);
    const isSelected= stageObj && filters.stage.some(s => getId(s)===getId(stageObj));
    const color     = stageColors[stageName] || accent;
    return (
      <Box onClick={() => { if (stageObj) handleToggle('stage', stageObj); }}
        sx={{ px:2, py:1, borderRadius:'20px', border:`1px solid ${border}`, bgcolor: isSelected ? color : 'transparent', cursor:'pointer', transition:'all 0.15s', textAlign:'center',
          '&:hover':{ transform:'translateY(-1px)', boxShadow:'0 2px 8px rgba(0,0,0,0.05)', bgcolor: isSelected ? color : mode==='dark' ? 'rgba(255,255,255,0.05)' : '#f5f5f5' } }}>
        <Typography sx={{ fontSize:12, fontWeight:500, color: isSelected ? '#fff' : textPrimary }}>{stageName}</Typography>
      </Box>
    );
  };

  const currentOptions  = openMenu ? getOptions(openMenu) : [];
  const currentSelected = openMenu ? (filters[openMenu] || []) : [];
  const showSalesCount  = openMenu === 'teamLeaders';

  const hasFilters = filters.budget || filters.stage.length>0 || filters.oldstage.length>0 ||
    filters.sales.length>0 || filters.chanel.length>0 || filters.campaign.length>0 ||
    filters.project.length>0 || filters.developer.length>0 || filters.addby.length>0 ||
    filters.assignedFrom.length>0 || filters.assignedTo.length>0 || filters.teamLeaders.length>0 ||
    filters.createdAt.from || filters.createdAt.to || filters.stagedateupdated.from || filters.stagedateupdated.to;

  return (
    <>
      <GlobalStyles styles={{ '.MuiPickersPopper-root':{ zIndex:999999 }, '.MuiPickersPopper-paper':{ zIndex:999999 } }} />

      <Dialog open={open} onClose={() => { handleCloseMenu(); onClose(); }}
        fullScreen={isSmallScreen} maxWidth="sm" fullWidth
        TransitionComponent={SlideTransition} disableEnforceFocus disableAutoFocus
        PaperProps={{ sx:{ borderRadius: isSmallScreen ? 0 : '20px', bgcolor:bg, margin: isSmallScreen ? 0 : 2, height: isSmallScreen ? '100vh' : 'auto', maxHeight:'90vh', overflow:'hidden', boxShadow:'0 25px 50px -12px rgba(0,0,0,0.25)' } }}
        sx={{ zIndex:50000 }}
      >
        {/* ── Header ── */}
        <DialogTitle sx={{ px:3, py:2.5, borderBottom:`1px solid ${border}`, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <Box sx={{ display:'flex', alignItems:'center', gap:1.5 }}>
            <FilterListIcon sx={{ color:accent, fontSize:22 }} />
            <Typography sx={{ fontSize:20, fontWeight:700, color:textPrimary, letterSpacing:'-0.01em' }}>
              Quick Filter
            </Typography>
          </Box>
          <Box sx={{ display:'flex', alignItems:'center', gap:1 }}>
            {lastFilter && (
              <Button onClick={handleRestoreLastFilter} size="small" startIcon={<RestoreIcon sx={{ fontSize:16 }} />}
                sx={{ textTransform:'none', fontSize:12, fontWeight:600, color:accent, bgcolor: mode==='dark' ? 'rgba(13,71,161,0.15)' : 'rgba(13,71,161,0.08)', borderRadius:'8px', px:1.5, py:0.5, '&:hover':{ bgcolor: mode==='dark' ? 'rgba(13,71,161,0.25)' : 'rgba(13,71,161,0.15)' } }}>
                Last Filter
              </Button>
            )}
            <IconButton onClick={() => { handleCloseMenu(); onClose(); }} size="small">
              <CloseIcon sx={{ color:textSecondary }} />
            </IconButton>
          </Box>
        </DialogTitle>

        {/* ── Body ── */}
        <DialogContent sx={{ p:3, overflow:'auto' }}>
          <LocalizationProvider dateAdapter={AdapterMoment}>

            {/* Budget */}
            <Box sx={{ mb:3 }}>
              <Typography sx={{ fontSize:12, fontWeight:500, color:textSecondary, mb:1 }}>Budget</Typography>
              <Box sx={{ border:`1px solid ${border}`, borderRadius:'10px', bgcolor:inputBg, p:'10px 12px' }}>
                <Box sx={{ display:'flex', alignItems:'center', gap:0.5 }}>
                  <Typography sx={{ fontWeight:500, color:textSecondary }}>$</Typography>
                  <input type="text" placeholder="Enter budget amount..." value={filters.budget} onChange={e => handleBudgetChange(e.target.value)}
                    style={{ border:'none', background:'transparent', outline:'none', fontSize:14, color:textPrimary, width:'100%', fontFamily:'inherit' }} />
                  {filters.budget && <ClearIcon sx={{ fontSize:16, color:textSecondary, cursor:'pointer' }} onClick={() => handleBudgetChange('')} />}
                </Box>
              </Box>
            </Box>

            <FilterField title="Team Leaders"  filterType="teamLeaders"  icon={GroupsIcon}             placeholder="Select Team Leaders..." />

            {/* Lead Stage */}
            <Box sx={{ mb:3 }}>
              <Typography sx={{ fontSize:12, fontWeight:500, color:textSecondary, mb:1 }}>Lead Stage</Typography>
              {stagesarray.length > 0 ? (
                <Box sx={{ display:'flex', flexWrap:'wrap', gap:1 }}>
                  {uniqueStageNames.map(s => <StageCard key={s} stageName={s} />)}
                </Box>
              ) : (
                <Box sx={{ border:`1px solid ${border}`, borderRadius:'10px', p:2, textAlign:'center', bgcolor:inputBg }}>
                  <Typography sx={{ fontSize:13, color:textSecondary }}>Loading stages...</Typography>
                </Box>
              )}
            </Box>

            <FilterField title="Old Stage"     filterType="oldstage"     icon={HistoryIcon}            placeholder="Select Old Stage..." />
            <FilterField title="Sales Agents"  filterType="sales"                                      placeholder="Search by name..." />
            <FilterField title="Channel"       filterType="chanel"                                     placeholder="Select Channel..." />
            <FilterField title="Campaign"      filterType="campaign"                                   placeholder="Select Campaign..." />
            <FilterField title="Project"       filterType="project"                                    placeholder="Select Project..." />
            <FilterField title="Developer"     filterType="developer"                                  placeholder="Select Developer..." />
            <FilterField title="Added By"      filterType="addby"                                      placeholder="Select Added By..." />
            <FilterField title="Assigned From" filterType="assignedFrom" icon={AssignmentIndIcon}      placeholder="Select Assigned From..." />
            <FilterField title="Assigned To"   filterType="assignedTo"   icon={AssignmentTurnedInIcon} placeholder="Select Assigned To..." />

            {/* Creation Date Range */}
            <Box sx={{ mb:2.5 }}>
              <Typography sx={{ fontSize:12, fontWeight:500, color:textSecondary, mb:1 }}>Creation Date Range</Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}><CustomDatePicker label="From Date" value={filters.createdAt.from ? moment(filters.createdAt.from) : null} onChange={d => handleDateChange('createdAt','from',d)} /></Grid>
                <Grid item xs={6}><CustomDatePicker label="To Date"   value={filters.createdAt.to   ? moment(filters.createdAt.to)   : null} onChange={d => handleDateChange('createdAt','to',d)}   /></Grid>
              </Grid>
            </Box>

            {/* Stage Date Range */}
            <Box sx={{ mb:2.5 }}>
              <Box sx={{ display:'flex', alignItems:'center', gap:1, mb:1 }}>
                <UpdateIcon sx={{ fontSize:16, color:'#F59E0B' }} />
                <Typography sx={{ fontSize:12, fontWeight:500, color:textSecondary }}>Stage Date Range</Typography>
              </Box>
              <Typography variant="caption" sx={{ color:textSecondary, fontSize:10, mb:1, display:'block' }}>Filter by stage update date</Typography>
              <Grid container spacing={2}>
                <Grid item xs={6}><CustomDatePicker label="From Date" value={filters.stagedateupdated.from ? moment(filters.stagedateupdated.from) : null} onChange={d => handleDateChange('stagedateupdated','from',d)} color="warning" /></Grid>
                <Grid item xs={6}><CustomDatePicker label="To Date"   value={filters.stagedateupdated.to   ? moment(filters.stagedateupdated.to)   : null} onChange={d => handleDateChange('stagedateupdated','to',d)}   color="warning" /></Grid>
              </Grid>
            </Box>

            {/* Selected Summary */}
            {hasFilters && (
              <Box sx={{ mt:3, p:2, bgcolor: mode==='dark' ? 'rgba(99,102,241,0.1)' : 'rgba(99,102,241,0.05)', borderRadius:2 }}>
                <Typography variant="subtitle2" sx={{ fontWeight:'bold', color:textPrimary, mb:1, fontSize:12 }}>Selected Filters:</Typography>
                <Box sx={{ display:'flex', flexWrap:'wrap', gap:1 }}>
                  {filters.budget && <Chip label={`Budget: $${filters.budget}`} size="small" onDelete={() => handleBudgetChange('')} sx={{ height:24, fontSize:11 }} />}
                  {filters.teamLeaders.length>0 && <Chip label={`Team Leaders: ${filters.teamLeaders.length}`} size="small" icon={<GroupsIcon/>} sx={{ height:24, fontSize:11 }} />}
                  {filters.stage.length>0        && <Chip label={`Stage: ${filters.stage.length}`}             size="small" sx={{ height:24, fontSize:11 }} />}
                  {filters.oldstage.length>0     && <Chip label={`Old Stage: ${filters.oldstage.length}`}      size="small" icon={<HistoryIcon/>} sx={{ height:24, fontSize:11 }} />}
                  {filters.sales.length>0        && <Chip label={`Sales: ${filters.sales.length}`}             size="small" sx={{ height:24, fontSize:11 }} />}
                  {filters.chanel.length>0       && <Chip label={`Channel: ${filters.chanel.length}`}          size="small" sx={{ height:24, fontSize:11 }} />}
                  {filters.campaign.length>0     && <Chip label={`Campaign: ${filters.campaign.length}`}       size="small" sx={{ height:24, fontSize:11 }} />}
                  {filters.project.length>0      && <Chip label={`Project: ${filters.project.length}`}         size="small" sx={{ height:24, fontSize:11 }} />}
                  {filters.developer.length>0    && <Chip label={`Developer: ${filters.developer.length}`}     size="small" sx={{ height:24, fontSize:11 }} />}
                  {filters.addby.length>0        && <Chip label={`Added By: ${filters.addby.length}`}          size="small" sx={{ height:24, fontSize:11 }} />}
                  {filters.assignedFrom.length>0 && <Chip label={`Assigned From: ${filters.assignedFrom.length}`} size="small" icon={<AssignmentIndIcon/>} sx={{ height:24, fontSize:11 }} />}
                  {filters.assignedTo.length>0   && <Chip label={`Assigned To: ${filters.assignedTo.length}`} size="small" icon={<AssignmentTurnedInIcon/>} sx={{ height:24, fontSize:11 }} />}
                  {(filters.createdAt.from||filters.createdAt.to)               && <Chip label="Creation Date Range" size="small" sx={{ height:24, fontSize:11 }} />}
                  {(filters.stagedateupdated.from||filters.stagedateupdated.to) && <Chip label="Stage Date Range" size="small" icon={<UpdateIcon/>} sx={{ height:24, fontSize:11 }} />}
                </Box>
              </Box>
            )}

          </LocalizationProvider>
        </DialogContent>

        {/* ── Footer ── */}
        <DialogActions sx={{ px:3, py:2.5, borderTop:`1px solid ${border}`, gap:2 }}>
          <Button onClick={handleClear} sx={{ color:textSecondary, textTransform:'none', fontWeight:500, fontSize:13, '&:hover':{bgcolor:'transparent',color:accent} }}>
            CLEAR ALL
          </Button>
          <Box sx={{ flex:1 }} />
          <Button onClick={onClose} sx={{ color:textSecondary, textTransform:'none', fontWeight:500, fontSize:13, '&:hover':{bgcolor:'transparent',color:accent} }}>
            Cancel
          </Button>

          {/* ✅ زرار Export */}
          <Button
            onClick={handleExport}
            variant="outlined"
            startIcon={<SystemUpdateAltIcon sx={{ fontSize:16 }} />}
            sx={{
              borderColor: '#16A34A', color: '#16A34A',
              textTransform: 'none', fontWeight: 600,
              px: 3, borderRadius: '10px', fontSize: 13,
              '&:hover': { bgcolor: '#F0FDF4', borderColor: '#15803D', color: '#15803D' },
            }}
          >
            Export
          </Button>

          <Button onClick={handleApply} variant="contained"
            sx={{ bgcolor:accent, textTransform:'none', fontWeight:600, px:4, borderRadius:'10px', fontSize:13, boxShadow:'none', '&:hover':{bgcolor:'#0D47A1',boxShadow:'none'} }}>
            Apply Filters
          </Button>
        </DialogActions>
      </Dialog>

      <StableMenu
        open={!!openMenu} options={currentOptions} selected={currentSelected}
        searchValue={searchValue} onSearchChange={setSearchValue}
        onToggle={item => handleToggle(openMenu, item)}
        onSelectAll={opts => handleSelectAll(openMenu, opts)}
        onClose={handleCloseMenu} anchorPosition={anchorPosition}
        mode={mode} textSecondary={textSecondary} inputBg={inputBg} bg={bg} border={border} accent={accent}
        getId={getId} getName={getName}
        showSalesCount={showSalesCount} getSalesCount={getSalesByTeamLeader}
      />
    </>
  );
};

export default QuickFilterModal;
